import { clone, state, ui, res, prefs } from './stores.js';
import { get } from 'svelte/store';
import { getPlayerIndex, getCard, moveTo, doAction, logText, getDeck, infoRevealed, shuffleDeck, getMarketCards, shuffle, allCards, getNeutralZone, removeBeamed, removeTokens, genCard, getDeckForCard, checkForReactions, cardByID, badlands, resetCache, isBadlands, removeOrbiting, handSize, dynamicHandSize, getP } from './game.js';
import { changeView, choose, chooseCards, info, pause, cc, cn, cancel, convert, clearSelection, waitMillis, debounce, currentPlayer, activePlayer } from './ui.js';
import { compute_rest_props, escape, tick } from 'svelte/internal';
import { allBeamed, allScoreableCards, checkDomination } from './scores.js';
import { canBurn, claimLocation, endGame } from './turns.js';
import { isMe } from './net.js';
import { getCardEffect, autoCardActions, getHints, doReaction, ongoingPlayer, hasStagingDuty, ongoingEffects, autoReaction, meetsThreshold, getAllPlayEffects, cardOwner, upperInitial, checkOwnership, resolveOwner, resolveNum, resolveAction, trawlFor, countMatches, testNum, doActionPause, hintNames, resolveEffects, resolveLocCondition, resolveCondition, shipLocation, shipsAtLocation, validEffect, cardWCs, currentTraits, shouldCheckWCs, cacheWC, checkMission, addCardsToCache, resolveObject, resolveExactCard, canAfford, joinText, getPrevTypes, otherPlayer, resolvePlace, resolveAnother, resolveCountTypes, resolveQualifier, cacheItem, clearCacheItem, expandSkills, currentCard, ongoingPlayerWithCards, resolveFilters } from './parse.js';
import { getCostInfo, pay , autoDevelop, canPay, renderCost } from './costs.js';
import { countAllTokens, countPlayerTokens, bestShipDestinations, botValue, botValuer, resolveBotCard, resolveSurpriseOnLog, botAwayOut, removeBotAway, doBotAction, botFavouriteCards, bestAwayRemove, countSpecificTokens } from './bot.js';
import { collectableTraits, markCollected } from './khan.js';
import { checkCollectiveRewards } from './borg.js';
import { playSound } from './sounds.js';
import { countableTraits } from './newcards/types.js';
import { pushFrame, popFrame, unitOfEffects, clearSlotsIn } from './frames.js';

export let allActions = [
    {
        name: 'Play',
        type: 'play',
        cardShortcut: 'p',
        action: async (p, params) => {
            setDefault(params);
            await playCard(p, getCard(params.obj), params);
        },
        log: (params) => {
            if(params.obj) return `played ${cc(params.obj || params.card)}`;
        }
    },
    {
        name: 'Scan',
        type: 'scan',
        listAs: 'scan',
        action: async (p, params) => {
            if(!params.deck || params.deck.length == 0) throw 'uncompleted';
            let choices = ['Top 1', 'Top 2', 'Top 3', '#nl', ...get(res).traits.map(t => `[[${t}]] ${t[0].toUpperCase()}${t.slice(1)}`).sort()];
            let chosen = await choose('Scan for:', choices, {cancellable: true});
            if(!chosen) throw 'uncompleted';
            let info = get(state).cardLog[params.deck[0].uniqueID];
            if(!info) throw 'uncompleted';
            let deckName = info.deck;
            if(chosen.startsWith('Top')){
                let num = parseInt(chosen[chosen.length - 1])
                params.text = `top ${num} of ${deckName} deck`; // TODO put deck in too!
                let type = Object.keys(get(res).marketTypes).find(t => get(res).marketTypes[t] == deckName);
                await scanOf(p, params.deck, num, type)
            }else if(chosen.startsWith('[')){
                let trait = chosen.match(/\[\[([^\]]+)\]\]/)[1];
                params.result = await scanFor(p, [params.deck[0]], trait);
                if(!params.result){
                    let messageCard = p.decks.captain[0];
                    if(params.card){
                        messageCard = getCard(params.card);
                        cardMessage(messageCard, `[[${trait}]] not found: gaining 2 [[glory]] instead`);
                    }
                }
                params.text = `for ${chosen} in ${deckName} deck`; // TODO put deck in too!
            }
        },
        log: (params) => {
            return `Scanned ${params.text ? params.text : '' }`;
        }
    },
    {
        type: 'exhaust',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(!tableEffectsActive(c)){
                logText(`Can't exhaust ${cc(c)} because it is not in the play area!`);
                throw 'uncompleted';
            }
            if(c.activated) throw 'uncompleted'; // Can't exhaust something already exhausted!
            c.activated = true;
            //await updateAllTypeGains();
            let ongoing = ongoingEffects(c, 'ongoing', true);
            for(let o of ongoing){
                await handleOngoingChange(p, c, o, 'entering'); // NB entering shouldn't be needed
            }
        },
        log: (params) => {
            return `Exhausted ${cc(params.obj)} `
        }
    },
    {
        type: 'move',
        action: async (p, params) => {
            if(!params.to) throw 'uncompleted'; // Nowhere to put it!
            let toCard = getCard(possArray(params.to)[0]);
            if(!toCard) throw 'uncompleted';
            if(!toCard[params.obj.specific]) toCard[params.obj.specific] = 0;
            let fromCard = getCard(params.obj.fromCard) || p; // If no cardthe
            let amount = params.obj.num;
            if(!params.obj.fromCard){
                // it means from your captain!
                fromCard = p;
            }
            if(fromCard[params.obj.specific] && fromCard[params.obj.specific] >= params.obj.num){
                fromCard[params.obj.specific] -= params.obj.num;
                toCard[params.obj.specific] += params.obj.num;
            }else if(fromCard[params.obj.specific]){
                // Some but not enough
                amount = fromCard[params.obj.specific];
                fromCard[params.obj.specific] = 0;
                toCard[params.obj.specific] += amount;
                logText(`Cannot move full ${params.obj.num} [[${params.obj.specific}]]: only ${amount} available, so moved that much and then abandoned`)
                throw 'uncompleted';
            }else{
                amount = 0;
                logText(`Cannot move ${params.obj.num} [[${params.obj.specific}]]: 0 available`)
                throw 'uncompleted';
            }
            params.amount = amount;
        },
        log: (params) => {
            return `moved ${params.amount || params.obj.num} [[${params.obj.specific}]] ${params.obj.fromCard ? `from ${cc(params.obj.fromCard)}` : ''} to ${cc(possArray(params.to)[0])}`
        }
    },
    {
        type: 'place',
        action: async (p, params) => {
            if(params.obj && params.obj.location && !params.location) params.location = params.obj.location;
            if(params.location == 'here') params.on = params.card;
            if(!params.on) throw `Nowhere to place!`;
            if(!params.obj.specific) throw 'Nothing to place!';
            if(!Array.isArray(params.on)) params.on = [params.on];
            for(let o of params.on){
                let c = getCard(o);
                tokenOnCard(c, params.obj.specific, params.obj.num);
            }
            
            await checkForReactions(p, 'card_tokens', {obj: params.on}, 'before');
        },
        log: (params) => {
            return params.on ? `Placed ${params.obj.num} [[${params.obj.specific}]] on ${cc(params.on)}` : ''
        }
    },
    {
        type: 'undevelop',
        action: async (p, params) => {
            setDefault(params);
            await moveTo(getCard(params.obj), `players.dev.${getPlayerIndex(p)}`);
        },
        log: (params) => {
            return `Placed ${cc(params.obj || params.card)} back in Development area`;
        }
    },
    {
        type: 'scan_new_species',
        listAs: 'scan',
        action: async (p, params) => {
            /// ("Select [[any species]] you have none"i _ "of"? _ "in play and scan for it" {return {verb: 'scan_new_species'}})
            let speciesInPlay = cardsInPlay(p).flatMap(c => c.traits).filter(t => get(res).species.includes(t));
            let availableSpecies = get(res).species.filter(s => !speciesInPlay.includes(s));
            if(availableSpecies.length == 0){
                logText(`No species left to scan for!`);
                throw 'uncompleted';
            }
            let species = await choose(`Which species do you want to scan for?`, availableSpecies.map(s => `[[${s}]]`), {cancellable: true});
            if(!species || species == 'cancelled') throw 'cancelled';
            let chosen = availableSpecies.find(s => species == `[[${s}]]`);
            await doAction(p, 'scan_for', {...params, obj: chosen});
        }
    },
    {
        type: 'scan_any_trait',
        action: async (p, params) => {
            let scannable = countableTraits(get(res).traits);
            let trait = await choose(`Which trait do you want to scan for?`, scannable.sort((a,b) => a.localeCompare(b)).map(t => `[[${t}]]`));
            if(!trait || trait == 'cancelled') throw 'cancelled';
            trait = scannable.find(t => trait == `[[${t}]]`);
            await doAction(p, 'scan_for', {...params, obj: trait});
        }
    },
    {
        type: 'scan_for_shared_trait',
        action: async (p, params) => {
            let c = getCard(params.obj);
            let traits = c.traits;
            if(c.traits.includes('wildcard')) traits = [...traits, ...countableTraits(get(res).traits)];
            if(c.traits.includes('any species')) traits = [...traits, ...get(res).species];
            if(c.traits.some(t => t.startsWith('any species') && t.includes('!'))){
                let t = c.traits.find(t => t.startsWith('any species') && t.includes('!'));
                let except = t.split('!')[1];
                traits = [...traits, ...get(res).species.filter(s => s != except)];
            }
            if(params.species) traits = traits.filter(t => get(res).species.includes(t));
            await doAction(p, 'scan_for', {obj: c.traits});
        }
    },
    {
        type: 'include_junk_next',
        action: async (p, params) => {
            cacheItem('from_junk_next', true);
        }
    },
    {
        type: 'scan_for',
        listAs: 'scan',
        action: async (p, params) => {
            let toScan = getMarketCards();
            if(params.deck){
                toScan = [];
                for(let t of possArray(params.deck)){
                    let c = get(state).commons[get(res).marketTypes[t]][0];
                    if(c) toScan.push(c);
                }
                if(toScan.length == 0) throw 'uncompleted';
            }
            if(get(state).cache && get(state).cache.from_junk_next){
                params.junk = true;
                clearCacheItem('from_junk_next');
            }
            let junk = params.junk;
            if(!junk && (p.from_junk || ongoingPlayer(p).includes('from_junk') || badlands() || hasNeutralJunkAccess(p))){
                junk = await checkFromJunk(p, false, 'scan');
            }
           /* if(badlands() && myAway(p, badlands()) && !junk){
                let choice = await choose(`Remove an [[away team]] from *Badlands* to include the Junk?`, ['Yes', 'No']);
                if(choice == 'Yes') junk = true;
            }*/
            if((ongoingPlayer(p).includes('scan_junk') || junk) && get(state).commons.junk.length > 0){
                toScan = [...toScan, ...get(state).commons.junk];
            }
            //console.log(params.obj);

            let scanningFor = params.obj;

            let possibleSpecies = get(res).species.map(s => `[[${s}]]`);

            

            if(params.obj == 'any species'){
                scanningFor = await choose(`Choose a species to scan for`, possibleSpecies, {cancellable: true});
                if(!scanningFor || scanningFor == 'cancelled') throw 'cancelled';
                params.obj = get(res).species.find(s => scanningFor == `[[${s}]]`);
            }

            if(params.limit_suits){
                // Limit to the same suit
                if(get(state).cache && get(state).cache.reactionTypes){
                    //let types = get(state).cache.reactionTypes;
                    toScan = get(state).cache.reactionTypes.map(t => get(state).commons[get(res).marketTypes[t]][0]);
                }else if(get(state).cache && get(state).cache.prevTypes){
                    toScan = get(state).cache.prevTypes.map(t => get(state).commons[get(res).marketTypes[t]][0]);
                }
            }
            if(params.scan_different && get(state).cache && get(state).cache.scanForTypes){
                toScan = possArray(toScan).filter(t => !get(state).cache.scanForTypes.includes(t));
            }
            params.result = await scanFor(p, toScan, params.obj);
            params.text = `Scanned for ${Array.isArray(params.obj) ? params.obj.map(t => `[[${t}]]`).join('/') : `[[${params.obj}]]`}`;
        },
        log: (params) => {
            return `${params.text ? params.text : '' }`;
        }
    },
    {
        type: 'scan_of',
        listAs: 'scan',
        action: async (p, params) => {
            let t = params.obj.types;
            let scanDeck;
            if(get(state).cache && get(state).cache.from_junk_next){
                params.junk = true;
                clearCacheItem('from_junk_next');
            }
            let extras = [];
            if(Array.isArray(t)){
                let possDecks = getMarketCards().filter(c => matches(c, t));
                if((params.junk || ongoingPlayer(p).includes('scan_junk') || ongoingPlayer(p).includes('from_junk')) && get(state).commons.junk.length > 0 && getMarketCards().length < 4){
                    // Possibly missing market cards
                    let emptyDecks = Object.keys(get(res).marketTypes);
                    emptyDecks = emptyDecks.filter(k => get(state).commons[get(res).marketTypes[k]].length == 0);
                    //emptyDecks = emptyDecks.map(k => get(res).marketTypes[k]);
                    emptyDecks = emptyDecks.filter(e => t.includes(e)).filter(e => get(state).commons.junk.some(c => matches(c, e)));
                    for(let e of emptyDecks){
                        extras.push({
                            name: `Scan for [[${e}]] (from Junk)`,
                            value: e
                        })
                    }
                    /*if(emptyDecks.length > 0){
                        for(let )
                        possDecks = [...possDecks, ...get(state).commons.junk];
                    }*/
                }
                let deck = await chooseCards(`Select deck to scan:`, possDecks, {cancellable: true, extraChoices: extras}); //TODO cancellable?
                if(!deck || deck == 'cancelled') throw 'cancelled';
                if(typeof deck != 'string'){
                    let info = get(state).cardLog[deck.uniqueID];
                    scanDeck = getDeck(get(state), info.area, info.deck, info.player);
                    t = deck.suits[0]; // So that scanOf correctly filters
                }else{
                    t = deck;
                    deck = []; // Acknowledgement it's empty
                }
                
            }else{
                scanDeck = get(state).commons[get(res).marketTypes[t]];
            }
            params.result = await scanOf(p, scanDeck, params.obj.num, t, params.junk);
        },
        log: (params) => {
            return `Scanned ${params.obj.num} of ${Array.isArray(params.obj.types) ? params.obj.types.map(t => convert(`[[${t}]]`, true)) : convert(params.obj.types, true)}`;
        }
    },
    /*{
        type: 'janeway_journey',
        // If you have no active [[mission]] with [[journey]] in play, draw a card from your Journey deck (see rules).
        action: async (p, params) => {
            if(p.decks.missions && p.decks.missions.filter(c => matches(c, 'journey')).length == 0 && p.decks.journey){
                await moveTo(p.decks.journey[0], `players.missions.${getPlayerIndex(p)}`);
                params.moved = p.decks.missions[0];
            }
        },
        log: (params) => params.moved ? `drew ${cc(params.moved)} from Journey deck` : `previous Journey card still active, so did not draw`
    },*/
    {
        type: 'flip',
        name: 'Flip',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            let info = get(state).cardLog[c.uniqueID];
            
            if(params.toSide){
                if(params.toSide == 'down'){
                    c.facedown = true;
                    delete c.activated; // flipped cards lose their activation
                    params.flipped = true;
                }else{
                    delete c.facedown;
                    delete c.activated; // flipped cards lose their activation
                    params.flipped = true;
                }
                return;
            }
            if(c.facedown){
                // just a simple facedown card so turn faceup!
                delete c.facedown;
                params.flipped = true;
                return;
            }
            let rev = c.reverse;
            if(!rev){
                console.log('Card is not flippable!');
                c.facedown = true;
                delete c.activated; // flipped cards lose their activation
            }
            rev = get(state).commons.destroyed.find(c => c.id == rev);//get(res).cards.find(c => c.id == c.reverse);
            if(!rev) throw `Can't find reverse of card!`;
            //rev = genCard(rev);
            let savedAT = false;
            let savedDrones = false;
            if(c.away_teams){
                savedAT = c.away_teams;
                delete c.away_teams;
            }
            if(c.drones){ // drones are away teams: they survive a flip too
                savedDrones = c.drones;
                delete c.drones;
            }
            let deck = getDeckForCard(c);
            let index = deck.findIndex(cd => cd.id == c.id);
            await moveTo(c, `commons.destroyed`);
            let key = `${info.area}.${info.deck}`;
            if(info.player || info.player === 0) key = `${info.area}.${info.deck}.${info.player}`;
            await doActionPause();
            await moveTo(rev, key, index);
            if(savedAT){
                rev.away_teams = savedAT;
            }
            if(savedDrones){
                rev.drones = savedDrones;
            }
            params.flipped = {
                c: c.uniqueID,
                rev: rev.uniqueID
            }
        },
        log: (params) => {
            if(params.flipped){
                return `Flipped ${cc(params.flipped.c)} to ${cc(params.flipped.rev)}`;
            }else{
                return `Unable to flip ${cc(params.card)}`;
            }
        }
    },
    {
        type: 'flip_tcc',
        action: async (p, params) => {
            if(!p.bot || !p.currentChart) throw 'uncompleted';
            // NB currently it doesn't actually check what it's flipping from/to, in case that's a problem
            let otherSide = Object.keys(get(res).botCharts[p.captain]).find(k => k != 'chartName' && k != p.currentChart);
            p.currentChart = otherSide;
            params.flipped = true;
        },
        log: (params) => {
            if(params.flipped){
                return `flipped the Traits Command Card from *${params.sideA}* to *${params.sideB}*`
            }else{
                return `Unable to flip the Traits Command Card`
            }
        }
    },
    {
        type: 'bye_bye_captain',
        // "Flip your [[captain]] face-down and place its token here
        action: async (p, params) => {
            if(p.decks.captain[0].facedown) throw 'uncompleted';
            //delete p.decks.captain[0].visiting;
            if(p.decks.captain[0].whereAmI){
                let where = getCard(p.decks.captain[0].whereAmI);
                delete where.visiting;
                delete p.decks.captain[0].whereAmI;
            }
            await doActionPause(); // for rendering to update
            //await moveTo(p.decks.captain[0], `commons.destroyed`);
        },
        log: (params) => `flipped [[captain]] face-down and returned all relevant tokens to the card`
    },
    {
        type: 'yay_captain_is_back',
        action: async (p, params) => {
            if(!p.decks.captain[0].facedown) throw 'uncompleted';
            params.obj = p.decks.captain[0].uniqueID;
            delete p.decks.captain[0].facedown;
        },
        log: (params) => `flipped [[captain]] face-up. ${params.obj ? `Welcome back, ${cc(params.obj)}!` : ''}`
    
    },
    {
        type: 'put',
        action: async (p, params) => {
            setDefault(params);
            let p2;
            let deck;
            let placement = 0;
            let owner = cardOwner(getCard(params.card)); // Important for determining what 'its' means...
            if(!params.on && params.to){
                if(!get(res).BvB) alert('syntax error on card text: says "put X to Y" rather that "put X on Y". Continuing for now, but report as text bug');
                params.on = params.to;
                params.on_name = params.to_name;
            }
            if(!params.location && params.obj.location) params.location = params.obj.location;
            if(params.location){
                p2 = p;
                if(params.location.owner == 'opponent' || params.location.owner == 'they') p2 = get(state).players.find(pl => pl.captain != p.captain);
                if(params.location.owner == 'bot'){
                    let c = getCard(params.card);
                    if(params.location.place == 'deck' && (!/*c.botCard*/ !get(state).inBotChart || !owner.bot)){
                        // Get the relevant deck for the card
                        deck = getLocation(getCard(params.obj));
                    }else{
                        p2 = get(state).players.find(pl => pl.bot);
                    }
                    
                }
                if(params.location.owner == 'you' && p.bot){
                    p2 = get(state).players.find(pl => !pl.bot);
                    if(!p2) p2 = get(state).players.find(pl => pl.captain != p.captain); // for BvB
                }
                // p2 = resolveOwner(getCard(params.card), params.location.owner);
                if(params.location.place == 'play'){
                    // put_in_play action instead
                    await doAction(p, 'put_in_play', {...params, noReactions: true});
                    return;
                }else if(params.location.place == 'action_area'){
                    deck = 'play';
                    params.place = 'play area';
                }else{
                    deck = params.location.place;
                    params.place = params.location.place;
                }
                
            }else if(params.on_name && params.on_name.card){
                p2 = resolveOwner(getCard(params.card), params.on_name.card.owner);
                let c = getCard(params.card);
                if(!params.on_name.card.place || params.on_name.card.place == 'deck' && params.on_name.card.owner == 'bot' && (/*!c.botCard*/ !get(state).inBotChart || !owner.bot)){
                    // Get the relevant deck for the card
                    // (because 'its' = 'bot' in parser, which obviously is only very occasionally true)
                    // (more context-aware parsing would be even better, but hey-ho)
                    deck = getLocation(getCard(params.obj));
                    params.place = `${deck.deck}`;
                }else{
                    if(params.on_name.card.place == 'action_area'){
                        deck = 'play';
                        params.place = 'play area';
                    }else{
                        deck = params.on_name.card.place;
                        params.place = 'deck';
                    }
                }
                
                if(params.on_name.card.placement == 'bottom') placement = -1;
            }
            if(typeof deck == 'object'){
                // it's a location info thing
                if(deck.hasOwnProperty('player')){
                    await moveTo(getCard(params.obj), `${deck.area}.${deck.deck}.${deck.player}`, placement);
                }else{
                    await moveTo(getCard(params.obj), `${deck.area}.${deck.deck}`, placement);
                }
            }else if(p2 && p2.decks[deck]){
                await moveTo(getCard(params.obj), `players.${deck}.${getPlayerIndex(p2)}`, placement);
            }else{
                alert('Unable to resolve deck to put card in: report this as a bug')
            }
        },
        log: (params) => {
            return `Put ${cc(params.obj)} into ${params.place}`;
        }
    },
    {
        type: 'shuffle_back',
        action: async (p, params) => {
            setDefault(params);
            if(!params.location && params.obj.location) params.location = params.obj.location;
            let p2 = resolveOwner(getCard(params.card), params.location.owner);
            let deck;
            if(params.location.place == 'action_area'){
                deck = 'play';
                params.place = 'play area';
            }else{
                deck = params.location.place;
                params.place = 'deck';
            }
            if(p2 && p2.decks[deck]){
                for(let c of possArray(params.obj)){
                    await moveTo(getCard(c), `players.${deck}.${getPlayerIndex(p2)}`, -1);
                }
                shuffle(p2.decks[deck]);
            }
        },
        log: (params) => {
            return `Shuffled ${cc(params.obj)} into ${params.place}`;
        }
    },
    {
        type: 'reshuffle_poss_enlist',
        // Placeholder basically so it hands over where it's the other player
        action: async (p, params) => {
            await reshuffleDeck(p, params);
        } // Logging handled within reshuffle function
    },
    {
        type: 'endgame_return',
        listAs: 'return',
        action: async (p, params) => {
            // 'Find' can't reach the log (unless a passive allows it) or the assimilated pile
            let unreachable = [...(p.decks.assimilated || [])];
            if(!ongoingPlayer(p).includes('can_target_log_incidents')) unreachable.push(...(p.decks.log || []));
            let incidents = allScoreableCards(p).filter(c => c.suits.includes('incident') && !unreachable.some(u => u.uniqueID == c.uniqueID));
            if(incidents.length == 0) throw 'uncompleted';
            incidents = await chooseCards(`Select up to ${params.toReturn} [[incident]] to return`, incidents, {lookSpecific: true, number: {min: 0, max: params.toReturn}});
            params.returned = incidents.map(c => c.uniqueID);
            for(let i of incidents){
                await doAction(p, 'return', {obj: i.uniqueID});
            }
            //logText(`Returning ${incidents.length} [[incidents]] thanks to card special effects`)
        },
        log: (params) => `Returned ${params.returned ? params.returned.map(c => cc(c)) : ''} thanks to card special effects`
    },
    /*{
        type: 'shuffle_deck',
        action: async (p, params) => {
            shuffle(p.decks.deck);
            state.update(s => {
                return s;
            })
        },
        log: (params) => 'shuffled their deck'
    },*/
    {
        type: 'shuffle',
        action: async (p, params) => {
            if(params.loc.owner == 'bot' && get(state).players.some(p => !p.bot)){
                p = get(state).players.find(p => p.bot);
            }else if(params.loc.owner == 'opponent'){
                p = otherPlayer(p);
            }
            if(p.decks.hasOwnProperty(params.loc.place)){
                shuffle(p.decks[params.loc.place]);
                state.update(s => {
                    return s;
                })
            }else{
                logText(`Unable to shuffle deck ${params.loc.place}: cannot find it!`);
                throw 'uncompleted';
            } 
        },
        log: (params) => `shuffled ${params.loc.owner} ${params.loc.place} deck`
    },
    {
        name: 'Put into play (no trigger)',
        type: 'put_in_play',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(c.suits && (c.suits.includes('status'))){
                await moveTo(c, `players.fleet.${getPlayerIndex(p)}`, -1);
            }else{
                await moveTo(c, `players.play.${getPlayerIndex(p)}`, -1);
                await doAction(p, `put_in_staging`, {obj: c.uniqueID}); // just to trigger specific reactions
            }
            
        },
        log: (params) => {
            return `Put ${cc(params.obj)} into play area`
        }
    },
    {
        name: 'Put in fleet',
        type: 'put_in_fleet',
        action: async (p, params) => {
            setDefault(params);
            await moveTo(getCard(params.obj), `players.fleet.${getPlayerIndex(p)}`, -1);
        },
        log: (params) => {
            return `Put ${cc(params.obj)} into fleet area`
        }
    },
    {
        // Discard the top Bot deck card; a market suit junks the top hidden card of that suit's Market deck
        type: 'bot_discard_junk_suit',
        action: async (p, params) => {
            let bot = get(state).players.find(pl => pl.bot);
            let c = bot?.decks.deck[0];
            if(!c) throw 'uncompleted';
            await doAction(bot, 'discard', {obj: c.uniqueID});
            params.discarded = c;
            let suit = (c.suits || []).find(s => get(res).marketTypes[s]);
            if(!suit) return;
            let target;
            if(get(prefs).separateMarkets){
                target = get(state).commons[get(res).marketTypes[suit]]?.[1];
            }else{
                target = get(state).commons.market.find(m => m.suits && m.suits[0] == suit);
            }
            if(target && canJunk(target)){
                await doAction(p, 'junk', {obj: target.uniqueID});
                params.junked = target;
            }
        },
        log: (params) => `discarded ${params.discarded ? cc(params.discarded) : 'nothing'} from the top of the Bot deck${params.junked ? `, junking ${cc(params.junked)} from the top of its Market deck` : ''}`
    },
    {
        type: 'discard_bot_deck',
        action: async (p, params) => {
            let deck = [...p.decks.deck];
            for(let c of deck){
                await doAction(p, 'discard', {obj: c.uniqueID});
            }
        }
    },
    {
        type: 'riker_ally',
        action: async (p, params) => {
            // If able to do both, gain [[res-focus]]/[[inf-focus]]/[[mil-focus]] and dismiss the Duty Officer
            if(!getMarketCards().some(c => matches(c, ['res-focus', 'inf-focus', 'mil-focus'])) || p.decks.duty.length == 0) throw 'uncompleted';
            params.could = true;
            let eligible = getMarketCards().filter(c => matches(c, ['res-focus', 'inf-focus', 'mil-focus']));
            eligible = botFavouriteCards(p, eligible);
            await doAction(p, 'gain', {obj: eligible[0].uniqueID});
            await doAction(p, 'dismiss', {obj: p.decks.duty[0].uniqueID});
        }
    },
    {
        type: 'convert',
        action: async (p, params) => {
            let num = await chooseNum('convert', params.fromType, params.num, p[params.fromType]);
            p[params.fromType] -= num;
            p[params.toType] += num;
            params.result = num;
        },
        log: (params) => `converted ${params.result || params.num} [[${params.fromType}]] into [[${params.toType}]]`
    },
    {
        type: 'koloth_snw',
        action: async (p, params) => {
            let eligible = cardsInPlay(p).filter(c => matches(c, 'ship') && !ongoingEffects(c).includes('cannot_log'));
            if(eligible.length == 0){
                if(p.bot) throw 'uncompleted';
                cancel(params.card, 'No eligible locations')
            }
            if(p.bot){
                let num = params.num;
                if(botAwayOut(p) < num) throw 'uncompleted';
                if(get(state).commons.encounters.length == 0) throw 'uncompleted';
                await doAction(p, 'log', {obj: eligible[0].uniqueID});
                await removeBotAway(p, num); // will throw uncompleted if impossible
                if(params.takeVerb == 'take'){
                    await doAction(p, 'take', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
                }else{
                    await doAction(p, 'gain_card', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
                }
                if(params.logDuty && params.dutyFirst && p.decks.duty.length > 0){
                    await doAction(p, 'log', {card: params.card, obj: p.decks.duty[0].uniqueID});
                }
                await doAction(p, 'log', {card: params.card, obj: params.card});
                if(params.logDuty && !params.dutyFirst && p.decks.duty.length > 0){
                    await doAction(p, 'log', {card: params.card, obj: p.decks.duty[0].uniqueID});
                }
                return;
            }
            // Bot only so shouldn't need anything else...!
        }
    },
    {
        // If able to do both, dismiss [[ship]] and remove an [[away team]] from the same [[location]] 
        // to take top [[encounter]] card, and if this card is [[cargo]] log this card.
        type: 'soval_snw',
        action: async (p, params) => {
            if(get(state).commons.encounters.length == 0) throw 'uncompleted';
            let eligibleShips = p.decks.fleet.filter(c => {
                if(!matches(c, 'ship')) return false;
                if(!c.ships || c.ships.length == 0) return false;
                if(!c.orbitingCard || Object.keys(c.orbitingCard).length == 0) return false;
                let locations = c.ships.filter(s => c.orbitingCard[s]).map(s => getCard(c.orbitingCard[s]));
                if(locations.filter(l => myAway(p, l)).length == 0) return false;
                return true;
            })
            if(eligibleShips.length == 0) throw 'uncompleted';
            let ship = eligibleShips[0];
            let location = ship.ships.filter(s => ship.orbitingCard[s]).map(s => getCard(ship.orbitingCard[s]))[0];
            await doAction(p, 'dismiss', {card: params.card, obj: ship.uniqueID});
            await doAction(p, 'remove_away', {card: params.card, from: location.uniqueID, obj: {num: params.numAway || 1}});
            await doAction(p, 'take', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
            let thisCard = getCard(params.card);
            if(thisCard.suits.includes('cargo')) await doAction(p, 'log', {card: params.card, obj: thisCard.uniqueID});
        }
    },
    {
        type: 'swap_junk',
        action: async (p, params) => {
            let eligible =  get(state).commons.junk.filter(c => getMarketCards().some(cd => cd.suits[0] == c.suits[0]));
            if(params.obj && params.obj.types){
                eligible = get(state).commons.junk.filter(c => matches(c, params.obj.types) && getMarketCards().some(cd => matches(cd, params.obj.types)));
            }
            let card = await chooseCards(`Select a junked card to swap back into the market`, eligible, {cancellable: true});
            if(!card || card == 'cancelled') throw 'cancelled';
            let matchingMarket = getMarketCards().find(cd => cd.suits[0] == card.suits[0]);
            let info = get(state).cardLog[matchingMarket.uniqueID];
            /*let deck = getDeckForCard(matchingMarket);
            let s = deck[0];
            deck[0] = card;*/
            // swap resources
            for(let r of ['glory', 'dilithium', 'latinum']){
                if(matchingMarket[r]){
                    card[r] = matchingMarket[r];
                    matchingMarket[r] = 0;
                }
            }
            await moveTo(matchingMarket, 'commons.junk');
            await moveTo(card, `commons.${info.deck}`, 0);
            params.swappedToJunk = matchingMarket.uniqueID;
            params.swappedToMarket = card.uniqueID;
        },
        log: (params) => {
            if(params.swappedToJunk){
                return `Swapped ${cc(params.swappedToMarket)} in junk with ${cc(params.swappedToJunk)} in market`;
            }else{
                return `Swapped card in junk with card in market`;
            }
        }
    },
    {
        // Remove a [[drone]] each from a neutral, a controlled, and an opponent controlled [[location]]
        // cost of Resistance is Futile
        type: 'resistance_drone_remove',
        action: async (p, params) => {
            let neutral = getNeutralZone().filter(c => countSpecificTokens(c, p, 'drone') > 0);
            let controlled = p.decks.locations.filter(c => countSpecificTokens(c, p, 'drone') > 0);
            let opp = otherPlayer(p).decks.locations.filter(c => countSpecificTokens(c, p, 'drone') > 0);
            if(neutral.length == 0 || controlled.length == 0 || opp.length == 0){
                cancel(params.card, 'Not enough [[drone]] out to trigger effect');
            }
            for(let l of [neutral, controlled, opp]){
                let removeFrom = l[0].uniqueID;
                if(l.length > 1){
                    let card = await chooseCards(`Select [[location]] to remove [[drone]] from`, l, {cancellable: true});
                    if(!card || card == 'cancelled') throw 'cancelled';
                    removeFrom = card.uniqueID;
                }
                await doAction(p, 'remove_drones', {from: [removeFrom]});
            }
            // All done!
        }
    },
    {
        //select a controlled [[location]]: remove one away team from it, dismiss one [[ship]] present at it, and log the [[location]]. 
        //if you do all three, gain 1 [[research]] and look at the top 2 cards of the [[encounter]] deck and take one of them.
        name: 'Strange New Worlds',
        type: 'snw',
        action: async (p, params) => {
            let eligible = p.decks.locations.filter(c => matches(c, 'location'));
            if(params.notType){
                eligible = eligible.filter(c => !matches(c, params.notType))
            }
            if(eligible.length == 0){
                if(p.bot){
                    if(params.logLocation) throw 'uncompleted';
                }else{
                    cancel(params.card, 'No eligible locations')
                } 
            }

            if(p.bot){
                let num = params.num;
                if(botAwayOut(p) < num) throw 'uncompleted';
                if(get(state).commons.encounters.length == 0) throw 'uncompleted';
                
                if(params.logLocation) await doAction(p, 'log', {obj: eligible[0].uniqueID});
                await removeBotAway(p, num);
                if(params.takeVerb == 'take'){
                    await doAction(p, 'take', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
                }else if(params.takeVerb == 'gain'){
                    await doAction(p, 'gain_card', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
                }
                
                if(params.logThis){
                    await doAction(p, 'log', {card: params.card, obj: params.card});
                }
                if(params.logDuty && p.decks.duty.length > 0){
                    await doAction(p, 'log', {card: params.card, obj: p.decks.duty[0].uniqueID});
                }
                return;
            }
            let card;
            if(get(state).target){
                let obj = await resolveObject(get(state).target, 'snw', params, p);
                state.update(s => {
                    delete s.target;
                    return s;
                })
                if(!obj) throw 'uncompleted';
                card = getCard(obj);
                
                //card = getCard(params.obj);
            }else{
                card = await chooseCards(`Select a controlled [[location]] for card effect`, eligible, {cancellable: true});
                if(!card || card == 'cancelled') throw 'cancelled'; // Necessary?
            }
            let canTrigger = true;
            if(!allAway(card)) canTrigger = false;
            if(!card.orbiting || card.orbiting.length == 0) canTrigger = false;
            await doAction(p, 'log', {obj: card.uniqueID});
            await doAction(p, 'gain_track', {track: 'research', amount: 1});
            if(!canTrigger){
                cardMessage(params.card, `Unable to trigger effect: location didn't have both Away Teams and a Ship`);
            }else{
                let eligibleEncounters = get(state).commons.encounters.slice(0, 2);
                let disc = await chooseCards(`Choose a encounter to take`, eligibleEncounters, {lookSpecific: true, cancellable: true});
                if(disc) await doAction(p, 'take', {card: params.card, obj: disc.uniqueID});
            } 
            params.result = card.uniqueID;
        }
    },
    {
        //Log a controlled [[location]]. If there was a [[ship]] dismissed from this [[location]] by this, take the top card of the [[encounter]] deck.
        name: 'Strange New World',
        type: 'freeman_snw',
        action: async (p, params) => {
            let eligible = p.decks.locations.filter(c => matches(c, 'location'));
            if(eligible.length == 0) cancel(params.card, 'No eligible locations')
            let card = await chooseCards(`Select a controlled [[location]] for card effect`, eligible, {cancellable: true});
            if(!card || card == 'cancelled') throw 'cancelled'; // Necessary?
            let canTrigger = true;
            if(!card.orbiting || card.orbiting.length == 0) canTrigger = false;
            await doAction(p, 'log', {obj: card.uniqueID});
            if(!canTrigger || get(state).commons.encounters.length == 0){
                cardMessage(params.card, `Unable to trigger effect: location didn't have both Away Teams and a Ship`);
            }else{
                await doAction(p, 'take', {card: params.card, obj: get(state).commons.encounters[0].uniqueID});
            } 
            params.result = card.uniqueID;
        }
    },
    {
        //"Action: All players may draw a card. Gain 2 [[dilithium]] for each controlled [[location]] you have in play and 1 [[dilithium]] for each [[ship]] at a controlled [[location]].
        type: 'utilize_gain',
        listAs: 'gain tokens',
        action: async (p, params) => {
            let locations = p.decks.locations.filter(c => matches(c, 'location'));
            let numShips = 0;
            for(let l of locations){
                numShips += myOrbiting(p, l);
            }
            await doAction(p, `gain_tokens`, {token: 'dilithium', amount: locations.length * 2});
            await doAction(p, `gain_tokens`, {token: 'dilithium', amount: numShips });
        }
    },
    {
        // gain 1 on the Specialty track corresponding to one of those icons
        type: 'utilize_card_single',
        listAs: 'gain on track',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            let available = [];
            if(!c.values) throw 'uncompleted'
            for(let v of c.values){
                if(ongoingPlayer(p).includes('skill_conversion')){
                    available = [...available, ...expandSkills(p, v).filter(s => !available.includes(s))]
                }else if(v == 'wild'){
                    available = ['research', 'influence', 'military'];
                    break;
                }else if(!available.includes(v)){
                    available.push(v);
                }
            }
            let chosen = available[0];
            
            if(available.length > 1){
                chosen = await choose(`Select a track to gain 1 on`, available.map(a => `[[${a}]]`));
                if(!chosen || chosen == 'cancelled') throw 'cancelled';
                chosen  = available.find(a => chosen == `[[${a}]]`);
            }
            await doAction(p, 'gain_track', {track: chosen, amount: 1});
        }

    },
    {
        //Gain 1 on the corresponding Specialty track for each icon on the card (choose one track for each [[wild-skill]])"
        type: 'utilize_card',
        listAs: 'gain on track',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            let values = {
                wild: 0
            };
            for(let t of get(res).trackTypes){
                values[t] = 0;
            }
            if(c.values){
                for(let v of c.values){
                    values[v]++;
                }
            }
            for(let t of get(res).trackTypes){
                if(!values[t]) continue;
                await doAction(p, 'gain_track', {track: t, amount: values[t]});
            }
            for(let i = 0; i < values.wild; i++){
                let options = get(res).trackTypes.map(k => `[[${k}]]`)
                let which = await choose(`Assigning [[wild-skill]] ${i+1} (of ${values.wild}): select track to increase`, options);
                let chosen = get(res).trackTypes.find(k => which == `[[${k}]]`);
                await doAction(p, 'gain_track', {track: chosen, amount: 1});
            }
        }
    },
    {
        //Action: All players may draw a card. Gain on one power track for each matching icon you have in play. "
        type: 'utilize_track',
        listAs: 'gain on track',
        action: async (p, params) => {
            let values = {};
            for(let t of get(res).trackTypes){
                values[t] = 0;
            }
            values.wild = 0; 
            for(let c of cardsInPlay(p).filter(cd => !allBeamed(p).some(c => c.uniqueID == cd.uniqueID))){
                for(let v of c.values){
                    if(ongoingPlayer(p).includes('skill_conversion')){
                        let skills = expandSkills(p, v);
                        for(let s of skills){
                            values[s]++;
                        }
                    }else{
                        values[v]++;
                    }
                }
            }
            let chosen;
            if(params.chosen){
                // Already there
                if(get(state).cache && get(state).cache.chosen){
                    chosen = get(state).cache.chosen.split('-')[0];
                    chosen = get(res).trackTypes.find(t => t.startsWith(chosen));
                }else{
                    alert('Error: no chosen type!')
                    return 0;
                }
            }else{
                let options = get(res).trackTypes.map(k => `[[${k}]] (gain ${values[k] + values.wild})`)
                let which = await choose(`Select a track to increase:`, options);
                chosen = get(res).trackTypes.find(k => which == `[[${k}]] (gain ${values[k] + values.wild})`);
                if(!chosen) throw 'cancelled';
            }
            
            await doAction(p, 'gain_track', {track: chosen, amount: values[chosen] + values.wild});
        }
    },
    /*{
        //Action: All players may draw a card. Gain on one power track for each matching icon you have in play. "
        type: 'general_utilize_track',
        listAs: 'gain on track',
        action: async (p, params) => {
            let values = {};
            for(let t of possArray(params.tracks)){
                values[t] = 0;
            }
            for(let c of cardsInPlay(p).filter(cd => !allBeamed(p).some(c => c.uniqueID == cd.uniqueID))){
                for(let t of possArray(params.tracks)){
                    values[t] += matches(c, params.types); // For now
                }
            }
            let chosen;
            if(params.chosen){
                // Already there
                if(get(state).cache && get(state).cache.chosen){
                    chosen = get(state).cache.chosen.split('-')[0];
                    chosen = get(res).trackTypes.find(t => t.startsWith(chosen));
                }else{
                    alert('Error: no chosen type!')
                    return 0;
                }
            }else{
                let options = get(res).trackTypes.map(k => `[[${k}]] (gain ${values[k] + values.wild})`)
                let which = await choose(`Select a track to increase:`, options);
                chosen = get(res).trackTypes.find(k => which == `[[${k}]] (gain ${values[k] + values.wild})`);
                if(!chosen) throw 'cancelled';
            }
            
            await doAction(p, 'gain_track', {track: chosen, amount: values[chosen] + values.wild});
        }
    },*/
    {
        //Action: All players may draw a card. Gain on one power track for each matching icon you have in play. "
        type: 'utilize_track_all',
        listAs: 'gain on track',
        action: async (p, params) => {
            let values = {};
            for(let t of get(res).trackTypes){
                values[t] = 0;
            }
            values.wild = 0; 
            for(let c of cardsInPlay(p).filter(cd => !allBeamed(p).some(c => c.uniqueID == cd.uniqueID))){
                for(let v of c.values){
                    if(ongoingPlayer(p).includes('skill_conversion')){
                        let skills = expandSkills(p, v);
                        if(skills.length > 1){
                            let type = await choose(`Select which skill you want to count on this card`, skills.map(s => `[[${s.slice(0, 2)}-skill]] ${s}`), {card: c, cancellable: true})
                            if(!type || type == 'cancelled') throw 'cancelled';
                            let val = skills.find(s => type == `[[${s.slice(0, 2)}-skill]] ${s}`);
                            values[val]++;
                        }else{
                            values[v]++;
                        }
                    }else{
                        values[v]++;
                    }
                }
            }
            for(let t of get(res).trackTypes){
                if(!values[t]) continue;
                await doAction(p, 'gain_track', {track: t, amount: values[t]});
            }
            for(let i = 0; i < values.wild; i++){
                let options = get(res).trackTypes.map(k => `[[${k}]]`)
                let which = await choose(`Assigning [[wild-skill]] ${i+1} (of ${values.wild}): select track to increase`, options);
                let chosen = get(res).trackTypes.find(k => which == `[[${k}]]`);
                await doAction(p, 'gain_track', {track: chosen, amount: 1});
            }
        }
    },
    {
        name: 'Reaction',
        type: 'reaction',
        action: async (p, params) =>{
            if(!isMe(getPlayerIndex(p)) && !p.bot) return params; // bot-applicable Specials run locally
            let card = getCard(params.card);
            let origP = get(state).players[params.p];
            let effects = getCardEffect(card, 'reaction').filter(r => meetsThreshold(p, r));
            let savedV = get(ui).viewing;
            let res;
            if(savedV != getPlayerIndex(p)){
                await changeView(getPlayerIndex(p))
            }

           // await checkForReactions(p, 'reaction', {...params.params, card: card.uniqueID}, 'before');

            cardOnStack(card);

            if(params.manAuto == 'manual'){
                for(let effect of effects){
                    if(await doReaction(effect, origP, p, card, params.type, params.params) == 'replaced') res = 'replaced';
                }
            }else{
                await autoReaction(p, origP, card, params.effect, params.type, params.params, params.timing, params.attack)
                console.log(get(state).cache);
                if(get(state).cache.replacedOriginal) res = 'replaced';
            }

            cardOffStack(card);

            //await checkForReactions(p, 'reaction', {...params.params, card: card.uniqueID}, 'after');
            
            if(get(ui).viewing != savedV){
                await changeView(savedV);
            }
            if(res){
                return res;
            }else{
                return false; //{p: origP, type: params.type, params: params.params};
            }
            
        },
        log: (params) => {
            return `${get(state).players[params.p].captain}'s action triggered card ${cc(params.card)}`
        }
    },
    {
        name: 'Free play',
        type: 'freeplay',
        cardShortcut: 'shift+p',
        action: async (p, params) => {
            setDefault(params);
            params.free = true;
            await playCard(p, getCard(params.obj), params);
        },
        log: (params) => {
            if(params.obj) return `free played ${cc(params.obj || params.card)}`;
        }
    },
    {
        type: 'continue_resolution',
        action: async (p, params) => {
            // Resolve next bot icon
            state.update(s => {
                s.continueResolution = true;
                return s;
            })
            throw 'continue_resolution';
        }
    },
    {
        name: 'Dismiss',
        type: 'dismiss',
        listAs: 'dismiss',
        cardShortcut: 'd',
        action: async (p, params) => {
            setDefault(params);
            if(get(state).campaign && get(state).campaignInfo && get(state).campaignInfo.onlyShip){
                let c = getCard(params.obj);
                if(cardOwner(c) == p && !p.bot && c.area == 'Deployed' && matches(c, 'ship')){
                    let go = await choose(`Only Ship in the Quadrant: if this [[ship]] is dismissed you will lose the game immediately. Continue?`, ['Yes', 'No']);
                    if(go != 'Yes') throw 'cancelled';
                    endGame('Challenge');
                }
            }
            let c = getCard(params.obj);
            let info = get(state).cardLog[params.obj];
            if(info.area != 'beamed' && (!isInPlay(c) || info.deck == 'play')){
                console.log(`Cannot dismiss ${cc(c.uniqueID)} because it is not in play (or is in your Staging area): ${p.decks.duty.map(d => d.uniqueID)}`);
                throw 'uncompleted';
            }
            if(info.area == 'beamed'){
                let host = getCard(info.deck);
                if(ongoingEffects(host).includes('no_mission_dismissal')){
                    logText(`Cannot dismiss ${cc(c.uniqueID)} because it is beamed to ${cc(host.uniqueID)}`);
                    throw 'uncompleted';
                }
            }
            await dismissCard(p, c);
            params.did = true;
            if(!get(res).BvB) await tick();
            
        },
        log: (params) => {
            if(params.did) return `dismissed ${cc(params.obj || params.card)}`;
        }
    },
    {
        type: 'discard_multi',
        action: async (p, params) => {
            let eligibleCards = p.decks.hand.filter(c => matches(c, params.types));
            let types = params.types;
            let cards = await chooseCards(`You may discard up to one each of ${types.map(t => `[[${t}]]`).join(',')}. Select cards to discard:`, eligibleCards, {
                number: 'any',
                cancellable: true,
                specialCondition: (ui, state) => {
                    let selected = ui.multiSelection;
                    let possibleTypes = {};
                    let typeAssignment = {};
                    for(let s of selected){
                        let poss = [];
                        for(let t of types){
                            if(matches(s, t)) poss.push(t);
                        }
                        if(poss.length == 0){
                            continue;
                        }else if(poss.length == 1){
                            if(typeAssignment[poss[0]]) return false; // Too many single types
                            typeAssignment[poss[0]] = s.uniqueID;
                        }else{
                            possibleTypes[s.uniqueID] = poss;
                        }
                    }
                    let cardsToAssign = Object.keys(possibleTypes).sort((a,b) => possibleTypes[b].filter(t => !typeAssignment[t]).length - possibleTypes[a].filter(t => !typeAssignment[t].length));
                    for(let c of cardsToAssign){
                        let typesLeft = possibleTypes[c].filter(t => !typeAssignment[t]);
                        if(typesLeft.length == 0) return false;
                        typeAssignment[typesLeft[0]] = c;
                    }
                    console.log('assigned types successfully', typeAssignment, cardsToAssign)
                    
                    /*
                    for(let t of types){
                        let count = 0;
                        for(let c of selected){
                            if(matches(c, t) && count < 1){

                            }
                            count += matches(c, t);
                        }
                        if(count > 1) return false;
                    }*/
                    return true;
                }
            });
            if(!cards || cards == 'cancelled') throw 'cancelled';
            params.obj = cards.map(c => c.uniqueID);
            for(let c of cards){
                await doAction(p, 'discard', {obj: c.uniqueID});
            }
        },
        log: (params) => {
            return `could discard up to one each of ${params.types.map(t => `[[${t}]]`).join(',')}; chose to discard ${cc(params.obj)}`
        }
    },
    {
        type: 'hand_size',
        action: async (p, params) => {
            //if(!params.num) throw 'uncompleted';
            if(!p.tempHandSizeIncrease) p.tempHandSizeIncrease = 0;
            if(params.hand_dynamic){
                params.num = await dynamicHandSize(p, getCard(params.card), params.hand_dynamic);
            }
            p.tempHandSizeIncrease += params.num;
        },
        log: (params) => {
            return `temporarily increased hand size by ${params.num}`;
        }
    },
    {
        name: 'Increase whim limit',
        type: 'increase_whim',
        action: async (p, params) => {
            await doAction(p, 'whim_limit', {num: 1})
        }
    },
    {
        name: 'Reduce whim limit',
        type: 'reduce_whim',
        action: async (p, params) => {
            await doAction(p, 'whim_limit', {num: -1})
        }
    },
    {
        type: 'whim_limit',
        action: async (p, params) => {
            if(!p.hasOwnProperty('whim_limit')) throw 'uncompleted';
            p.whim_limit += params.num;
            if(p.whim > p.whim_limit){
                let diff = p.whim - p.whim_limit;
                logText(`lost ${diff} [[whim]] because limit was reduced`);
                await doAction(p, 'gain', {card: params.card, obj: {num: -diff, type: 'tokens', specific: 'whim'}});
            }
        },
        log: (params) => `${params.num > 0 ? 'increased' : 'decreased'} [[whim]] limit by ${Math.abs(params.num)}`
    },
    {
        type: 'discard_dismiss',
        action: async (p, params) => {
            let info = getLocation(getCard(params.obj));
            if(info.area == 'players' && ['hand', 'deck', 'discard', 'reserve'].includes(info.deck)){
                await doAction(p, 'discard', {...params});
            }else{
                await doAction(p, 'dismiss', {...params});
            }
        }
    },
    {
        type: 'find_recall',
        action: async (p, params) => {
            params.also_recall = true;
            await doAction(p, 'find', params);
        }
    },
    {
        name: 'Discard',
        type: 'discard',
        cardShortcut: 'd',
        action: async (p, params) => {
            setDefault(params);
            //checkFrom('players', params);
            if(!params.obj) throw 'uncompleted';
            let info = getLocation(getCard(params.obj));
            if(info.area == 'commons' && (info.deck == 'incidents' || info.deck == 'redshirts')){
                params.skipped = true;
                return;
            }
            if(info.deck == 'hand' && p.bot){
                if(await choose(`Action involving bot hand: Succeed or Fail?`, ['Succeed', 'Fail']) == 'Succeed'){
                    if(p.decks.discard.length > 0 && await choose(`Do you want to put top card of Bot discard onto deck?`, ['Yes', 'No']) == 'Yes'){
                        await moveTo(p.decks.discard[0], `players.deck.${getPlayerIndex(p)}`, 0);
                    }
                    throw 'completed';
                }else{
                    throw 'uncompleted';
                }
            }
            await moveTo(getCard(params.obj), `players.discard.${rightPlayerIndex(p, getCard(params.obj))}`);
            // No longer 'dismiss card' so that dismiss effects don't trigger!
            //await dismissCard(p, getCard(params.obj));
             //await tick();
        },
        log: (params) => {
            return `${params.skipped ? 'card was returned, so did not discard': `discarded ${cc(params.obj || params.card)}`}`;
        }
    },
    {
        name: 'Enlist',
        type: 'enlist',
        action: async (p, params) => {
             setDefault(params);
             let c;
             let enlisted = [];
             if(Array.isArray(params.obj)){
                c = getCard(params.obj[0]);
             }else{
                c = getCard(params.obj);
             }             
             let info = getLocation(c);
             if(info.deck == 'reserve'){
                if(!Array.isArray(params.obj)) params.obj = [params.obj];
                for(let c of params.obj){
                    await moveTo(getCard(c), `players.deck.${getPlayerIndex(p)}`, 0);
                    enlisted.push(getCard(c));
                }
                for(let c of enlisted){
                    let action = ongoingEffects(c, 'on_enlist');
                    if(action.length > 0){
                        logText(`${cc(c.uniqueID)} was enlisted, so performing enlist effect`);
                        await doActionPause(); await resolveEffects(c, action, action.some(a => a.attack), false); 
                    }
                }
             }else{
                params.noEnlistReactions = true;
                await doAction(p, 'develop', params);
                //params.obj = await autoDevelop(p, params.free, params.reduction, params.obj);
                //c = getCard(params.obj);
                //enlisted.push(c);
             }
        },
        log: (params) => {
            return `enlisted ${cc(params.obj || params.card)}`
        }
    },
    {
        name: 'Develop (pay manually)',
        type: 'develop_manual',
        listAs: 'develop',
        cardShortcut: 'shift+D',
        action: async (p, params) => {
            let c = getCard(params.card);
            if(c && ongoingEffects(c).includes(`develop_drones`)){
                let num = ongoingEffects(c, `develop_drones`)[0];
                logText(`Adding ${num} drones to [[captain]] card for developing this card`);
                if(!p.decks.captain[0].drones || !p.decks.captain[0].drones[p.captain]){
                    p.decks.captain[0].drones = {};
                    p.decks.captain[0].drones[p.captain] = 0;
                }
                p.decks.captain[0].drones[p.captain] += num;
            }
            await moveTo(c, `players.deck.${getPlayerIndex(p)}`, 0);
            let action = ongoingEffects(c, 'on_enlist');
            if(action.length > 0){
                logText(`${cc(c.uniqueID)} was enlisted, so performing enlist effect`);
                await doActionPause(); await resolveEffects(c, action, action.some(a => a.attack), false); 
            }
            if(!get(res).BvB) await tick();
            params.obj = params.card;
        },
        log: (params) => {
            return `developed ${cc(params.card)}`;
        }
    },
    {
        name: 'Develop',
        type: 'develop',
        listAs: 'develop',
        action: async (p, params) => {
            let c = false;
            
            /*if(c && params.free){ // don't do free because not all free are really fre
                if(get(prefs).gainToHand){
                    await dismissCard(p, c);
                }else{
                    await moveTo(c, `players.deck.${getPlayerIndex(p)}`, 0);
                }
                if(!get(res).BvB) await tick();
            }else{*/
            if(params.obj && params.with && params.with_name && params.with_name.types){
                params.obj = params.obj.filter(c => matches(getCard(c), params.with_name.types) >= params.with_name.num);
            }
            params.obj = await autoDevelop(p, params.free || params.free_only, params.reduction, params.obj, params.noEnlistReactions || false);
            /*}*/
            if(params.obj && !Array.isArray(params.obj)){
                /*if(Array.isArray(params.obj)){
                    c = getCard(params.obj[0]);
                }else{
                    c = getCard(params.obj);
                }*/
                c = getCard(params.obj);
            }
            if(c){
                let action = ongoingEffects(c, 'on_enlist');
                if(action.length > 0){
                    logText(`${cc(c.uniqueID)} was enlisted, so performing enlist effect`);
                    await doActionPause(); await resolveEffects(c, action, action.some(a => a.attack), false); 
                }
                if(ongoingEffects(c).includes(`develop_drones`)){
                    let num = ongoingEffects(c, `develop_drones`)[0];
                    logText(`Adding ${num} drones to [[captain]] card for developing this card`);
                    if(!p.decks.captain[0].drones || !p.decks.captain[0].drones[p.captain]){
                        p.decks.captain[0].drones = {};
                        p.decks.captain[0].drones[p.captain] = 0;
                    }
                    p.decks.captain[0].drones[p.captain] += num;
                }
            }
        },
        log: (params) => {
            return `developed ${cc(params.obj)} ${params.free ? 'for free' : ''}`;
        }
    },
    {
        type: 'develop_to_hand',
        action: async (p, params) => {
            await doAction(p, 'develop', {...params, doReactions: true});
            await doAction(p, 'hand', {...params, doReactions: true});
        }
    },
    {
        type: 'choose_any_option',
        action: async (p, params) => {
            if(!get(state).cache || !get(state).cache.prevConditions){
                throw 'No previous conditions to choose between!'
            }
            let prev = get(state).cache.prevConditions;
            let choices = [];
            for(let i = 0; i < prev.length; i++){
                let c = prev[i];
                let el = {}
                if(Array.isArray(c)){
                    el.text = c.map(c => c && c.text ? c.text : '').join(' ');
                    el.route = c;
                }else{
                    el.text = c.text;
                    el.route = c;
                }
                choices.push(el);
            }
            //let choices = prev.map(c => Array.isArray(c) ? c.map(c => c && c.text ? c.text : '').join(' ') : c.text);
            let choice = await choose(`Choose action:`, choices.map(c => c.text), {cancellable: true});
            if(!choice || choice == 'cancelled') throw 'cancelled';
            let found = choices.find(c => c.text == choice);//get(state).cache.prevConditions.find(c => choice == Array.isArray(c) ? c.map(c => c && c.text ? c.text : '').join(' ') : c.text);
            if(!found.route) throw 'Cannot find choice';
            let route = found.route;
            await resolveEffects(getCard(params.card), route, route.attack);
        }
    },
    {
        type: 'attack_cancel',
        listAs: 'cancel attack',
        action: async (p, params) => {
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(!get(prefs).cancelWholeAttacks || get(state).players[get(state).currentPlayer].bot){
                    s.cache.attackCancelled = params.card;
                }else{
                    s.cache.replacedOriginal = params.card;
                }
                return s;
            })
        },
        log: (params) => {
            return `cancelled the effect of an attack`;
        }
    },
    {
        name: 'Log card',
        type: 'log',
        listAs: 'log',
        cardShortcut: 'l',
        action: async (p, params) => {
            setDefault(params);
            if(!params.obj) throw 'uncompleted';
            let card = getCard(params.obj);
            let info = get(state).cardLog[params.obj];
            if(info.area == 'commons' && info.deck == 'destroyed'){
                logText(`Cannot log destroyed cards`); // Amanda Rogers
                throw 'uncompleted';
            }
            if(get(state).noLogCards && get(state).noLogCards.some(c => c == card.uniqueID)){
                // Skip any logging effects
                logText(`Surrounding duplicate operation ignores any effects that would log this card, so skipping log effect`);
                // Skipped log is a failed log: 'log this card to gain X' gives no X. Flag so the cost
                // isn't offered as a 'Cancel/Continue' cheat prompt (duplicate op resets the cache)
                state.update(s => {
                    s.cache.skippedLog = true;
                    return s;
                })
                throw 'uncompleted';
            }
            if(ongoingPlayer(otherPlayer(p)).includes('no_log_drone_locations') && drones(otherPlayer(p), card)){
                logText(`Cannot log [[location]] with [[drone]] present`);
                throw 'uncompleted';
            }
            if(ongoingPlayer(p).includes('log_assimilate_or_destroy') && !matches(card, ['location', 'mission'])){
                params.returned = true;
                params.noReactions = true;
                let options = numExpendableDrones(p) > 0
                    ? ['Expend a [[drone]] to assimilate it', 'Destroy it']
                    : ['Destroy it'];
                let choice = await choose('Choose how to replace logging this card:', options);
                if(!choice || choice == 'cancelled') throw 'cancelled';
                if(choice == 'Expend a [[drone]] to assimilate it'){
                    await doAction(p, 'expend', {obj: {num: 1}});
                    await doAction(p, 'assimilate', {...params, noReactions: false, doReactions: true});
                }else{
                    await doAction(p, 'destroy', {...params, noReactions: false, doReactions: true});
                }
                return;
            }
            if(ongoingPlayer(p).includes('log_expend') && !matches(card, 'location')){
                logText(`Borg logging card: discards it and expends a [[drone] if able`);
                params.returned = true;
                let info = get(state).cardLog[card.uniqueID];
                let abandon = false;
                if(info && info.deck != 'destroyed'){
                    await doAction(p, 'discard', {...params, doReactions: true});
                }else{
                    logText(`Not discarding as card has already been destroyed`);
                    abandon = true;
                }
                
                if(numExpendableDrones(p) > 0) await doAction(p, 'expend', {obj: {num: 1}});
                //params.noReactions = true;
                if(abandon) throw 'uncompleted';
                return;
            }
            if(ongoingPlayer(p).includes('assimilate_locations_missions') && matches(card, ['location', 'mission'])){
                logText(`Assimilating [[locations]]/[[missions]] instead`);
                params.returned = true;
                
                await doAction(p, 'assimilate', {...params, doReactions: true});
                params.noReactions = true;
                return;
            }
            if(ongoingEffects(card).includes('draw_instead_of_log')){
                logText('This card is drawn instead of logged');
                params.returned = true;
                
                await doAction(p, 'hand', {...params, doReactions: true}); //moveTo(getCard(params.obj), `players.hand.${rightPlayerIndex(p, card)}`);
                params.noReactions = true;
                return;
            }
            
            if(p.bot && card.suits.includes('incident') && !params.forced){ // Doesn't happen if you're forcing them
                logText(`Bot would log an [[incident]], so instead it returns it`);
                params.returned = true;
                params.noReactions = true;
                await doAction(p, 'return', {obj: params.obj});
                return; // Without this the card is returned and *then* still moved into the bot's Log below
            }
            if(p.bot && p.captain == 'Q' && matches(card, ['qsuit', 'wildcard'], false) && p.decks.deck.length > 0 && p.decks.deck[0].uniqueID == card.uniqueID){
                logText(`Q special rule: a [[qsuit]]/[[wildcard]] would be logged from top of deck, so putting it on bottom of deck instead`);
                await doAction(p, 'bottom', {...params, place: 'deck', doReactions: false});
            }
            if(p.bot && p.captain == 'Soval' && matches(card, 'path of surak') && p.decks.deck.length > 0 && p.decks.deck[0].uniqueID == card.uniqueID){
                logText(`Bot would log [[path of surak]] card from top of deck, so instead it discards it`);
                params.noReactions = true;
                params.returned = true;
                await doAction(p, 'discard', {...params, doReactions: true});
            }else if(p.bot && p.captain == 'Boimler' && matches(card, 'crossover', false) && p.decks.deck.length > 0 && p.decks.deck[0].uniqueID == card.uniqueID){
                logText(`Bot would log [[crossover]] card from top of deck, so instead it discards it`);
                params.noReactions = true;
                params.returned = true;
                await doAction(p, 'discard', {...params, doReactions: true});
            }else if(p.bot && p.captain == 'Dal & Gwyn' && matches(card, 'protostar', false) && p.decks.deck.length > 0 && p.decks.deck[0].uniqueID == card.uniqueID){
                logText(`Bot would log [[protostar]] card from top of deck, so instead it discards it`);
                params.noReactions = true;
                params.returned = true;
                await doAction(p, 'discard', {...params, doReactions: true});
            
            }else if(p.bot && p.captain == 'Freeman' && get(state).players[get(state).currentPlayer].captain == p.captain && matches(card, 'lower decker') && p.decks.deck.length > 0 && p.decks.deck[0].uniqueID == card.uniqueID && (!get(state).cache || get(state).cache.cardID != card.uniqueID)){
                logText(`[[lower decker]] at top of deck would be logged by another card's effect, so discarding it instead`)
                await doAction(p, 'discard', {obj: card.uniqueID});
                params.noReactions = true;
            }else if(p.bot && p.captain == 'Janeway' && matches(card, 'uss voyager')){
                logText(`Janeway bot would log *USS Voyager*, so instead discard top card of bot deck and put *Voyager* on top`);
                if(p.decks.deck.length > 0){
                    await doAction(p, 'discard', {obj: p.decks.deck[0].uniqueID});
                }
                await doAction(p, 'top', {obj: card.uniqueID, place: 'deck'});
            }else if(p.captain != get(state).players[get(state).currentPlayer].captain && get(state).players[get(state).currentPlayer].bot && params.botAttack){
                // It is a 'you' effect, so it is put in your log regardless
                await moveTo(card, `players.log.${getPlayerIndex(p)}`);
            }else{
                // Bot rule: a card with a Surprise operation triggers it one last time when the bot logs it.
                // Not when the card is logging itself, as its Surprise operation is already resolving
                if(p.bot && params.card != card.uniqueID) await resolveSurpriseOnLog(p, card);
                await moveTo(card, `players.log.${rightPlayerIndex(p, card)}`);
            }
            
            
        },
        log: (params) => {
            if(params.returned) return ``;
            return `logged ${cc(params.obj)}`;
        }
    },
    {
        name: 'Assimilate card',
        type: 'assimilate',
        action: async (p, params) => {
            setDefault(params);
            if(!params.obj) throw 'uncompleted';
            let card = getCard(params.obj);
            if(!p.decks.assimilated) throw 'uncompleted';
            if(p.bot && card.suits.includes('incident')){
                logText(`Bot would assimilate an [[incident]], so instead it returns it`);
                params.returned = true;
                await doAction(p, 'return', {obj: params.obj});
            }else{
                // First check if you have any species of this already
                let assimilatedSpecies = Array.from(new Set(p.decks.assimilated.flatMap(c => c.traits).filter(t => get(res).species.includes(t))));
                let newSpecies = getCard(params.obj).traits.filter(t => get(res).species.includes(t) || t == 'wildcard');
                let newAssimilation = newSpecies.some(s => !assimilatedSpecies.includes(s));
                if(newAssimilation){
                    await checkForReactions(p, 'new_assimilate', {}, 'before');
                }

                // ...and also check if you are assimilating from beamed
                let info = get(state).cardLog[params.obj];
                if(info.area == 'beamed'){
                    state.update(s => {
                        if(!s.cache.beamed_assimilated) s.cache.beamed_assimilated = [];
                        s.cache.beamed_assimilated = [params.obj, ...s.cache.beamed_assimilated];
                        return s;
                    })
                }

                await moveTo(getCard(params.obj), `players.assimilated.${getPlayerIndex(p)}`); // Assimilate goes to your own pile, even with attacks
                if(newAssimilation){
                    await checkForReactions(p, 'new_assimilate', {}, 'after');
                }
            }
            
            
        },
        log: (params) => {
            if(params.returned) return ``;
            return `assimilated ${cc(params.obj)}`;
        }
    },
    {
        name: 'Regenerate drones',
        type: 'regenerate',
        action: async (p, params) => {
            if(!params.obj || !params.obj.num){
                params.obj = {num: 1};
            }
            let alcoves = cardsInPlay(p).find(c => ongoingEffects(c).includes('drone_alcoves'));
            let captain = cardsInPlay(p).find(c => c.suits.includes('captain'));
            if(!alcoves) throw 'No Alcoves card!'
            if(!alcoves.drones || !alcoves.drones[p.captain]){
                logText(`No [[drone]]s in Alcoves to regenerate`);
                params.obj.num = 0;
                throw 'uncompleted';
            }
            let numExhausted = alcoves.drones[p.captain];
            if(typeof params.obj.num == 'number' && params.obj.num > numExhausted) params.obj.num = numExhausted;
            if(params.obj.num.max && params.obj.num.max > numExhausted) params.obj.num = numExhausted;
            if(params.obj.num.max && params.obj.num.max <= numExhausted) params.obj.num = params.obj.num.max;
            if(params.obj.num == 'all') params.obj.num = numExhausted;
            if(typeof params.obj.num != 'number'){
                throw 'Wrong type of number for regenerating [[drone]]s: report as a bug';
            }
            alcoves.drones[p.captain] -= params.obj.num;
            if(alcoves.drones[p.captain] == 0) delete alcoves.drones[p.captain];
            if(alcoves.drones == {}) delete alcoves.drones;
            if(!captain.drones) captain.drones = {};
            if(!captain.drones[p.captain]) captain.drones[p.captain] = 0;
            captain.drones[p.captain] += params.obj.num;
        },
        log: (params) => {
            return `Regenerated ${params.obj.num} [[drone]]s`;
        }
    },
    {
        name: 'Expend drones',
        type: 'expend',
        action: async (p, params) => {
            if(!params.obj){
                params.obj = {num: 1};
            }
            if(!params.from && !params.auto && params.card){
                params.from = [ params.card ];   
            }  

            if(p.glory > 0 && ongoingPlayer(p).includes('glory_expend')){
                let possibleMax = Math.min(params.obj.num, p.glory);
                let choice = await choose(`You may spend up to ${possibleMax} [[glory]] to avoid expending [[drone]]s. Choose:`, ['Spend [[glory]]', 'Expend [[drones]]']);
                if(!choice || choice == 'cancelled') throw 'cancelled';
                if(choice == 'Spend [[glory]]'){
                    let options = [];
                    for(let i = 0; i <= possibleMax; i++){
                        options.push(`${i} [[glory]] (expend ${possibleMax - i} [[drone]])`);
                    }
                    let amount = await choose(`Choose how much [[glory]] to spend:`, options);
                    if(!amount || amount == 'cancelled') throw 'cancelled';
                    let glory = options.indexOf(amount);
                    logText(`spent ${glory} [[glory]] to avoid expending [[drone]]s`)
                    await doAction(p, `spend_tokens`, {token: 'glory', amount: glory});
                    params.obj.num -= glory;
                    if(params.obj.num == 0){
                        params.glory = true;
                        return true;
                    }
                }
            }

            if(!params.from){
                // Let the user select
                let eligible = placesWithDrones(p);
                if(eligible.length == 0){
                    logText('No [[drone]]s to expend')
                    throw 'uncompleted';
                }
                if(!testNum(params.obj.num, eligible.reduce((a,c) => a + c.drones[p.captain], 0))){
                    logText('Not enough [[drone]]s to expend')
                    throw 'uncompleted';
                }
                params.from = [];
                params.num = 0;

                do{
                    eligible = placesWithDrones(p);
                    let card = eligible[0];
                    if(p.decks.captain[0] && eligible.some(c => c.uniqueID == p.decks.captain[0].uniqueID)){
                        // Just pull from BQ by default
                        card = eligible.find(c => c.uniqueID == p.decks.captain[0].uniqueID);
                    }else if(eligible.length > 1){
                        card = await chooseCards(`Choose a location to remove a [[drone]] from`, eligible);
                        if(!card || card == 'cancelled') throw 'cancelled';
                    }
                    if(!params.from.includes(card.uniqueID)) params.from = [...params.from, card.uniqueID ];
                    await expendDrones(p, card, 1);
                    params.num++;
                    if(typeof params.obj.num == 'number' && params.num == params.obj.num){
                        break;
                    }else if(params.obj.num.min && params.num == params.obj.num){
                        let stop = await choose(`Continue removing [[drone]]s?`, ['Yes', 'No']);
                        if(stop == 'cancelled') throw 'cancelled';
                        if(stop != 'Yes') break;
                    }else if(params.obj.num.max && params.num == params.obj.num){
                        break;
                    }else if(params.obj.num == 'all' || params.obj.num == 'any'){
                        throw 'Wrong type of number for drone removal: report this as a bug';
                    }
                }while(true);
            }else{
                if(!Array.isArray(params.from)) params.from = [ params.from ];
                for(let o of params.from){
                    await expendDrones(p, o, params.obj.num);
                }
                params.num = params.obj.num;
            }
            params.result = params.from; // for prev_obj
        },
        log: (params) => {
            if(!params.from && params.auto) return `No [[drone]]s to expend`;
            if(params.glory && params.obj.num == 0) return `Spent [[glory]] instead of expend drones`;
            return `expended ${cn(params.obj ? params.obj.num : 1)} [[drone]]${params.obj && params.obj.num == 1 ? '' : 's'}  from ${cc(params.from || params.card)}`
        }
    },
    {
        name: 'Evaluate',
        type: 'evaluate',
        listAs: 'evaluate location',
        action: async (p, params) => {
            setDefault(params);
            if(!params.obj) throw 'uncompleted';
            let c = getCard(params.obj);
            if(canControlLocation(p, c)){
                params.claimed = true;
                //await claimLocation(p, c);
                await doAction(p, 'gain_control', {obj: c.uniqueID});
            }
        },
        log: (params) => {
            return `evaluated ${cc(params.obj)}: ${params.claimed ? 'claimed and took control' : 'was not able to claim'}`
        }
    },
    {
        name: 'Reserve',
        type: 'reserve',
        cardShortcut: 'shift+R',
        action: async (p, params) => {
            setDefault(params);
            //params.hidden = isFacedown(getCard(params.obj));
            await moveTo(getCard(params.obj), `players.reserve.${getPlayerIndex(p)}`);
        },
        log: (params) => {
            return `put ${cc(params.obj)} on top of reserve pile`;
        }
    },
    {
        name: 'Top of deck',
        type: 'top',
        cardShortcut: 't',
        action: async (p, params) => {
            setDefault(params);
            //params.hidden = isFacedown(getCard(params.obj));
            if(!params.place || params.place == 'draw') params.place = 'deck'
            if(!params.obj) throw 'uncompleted';
            let card = getCard(params.obj);
            let info = get(state).cardLog[card.uniqueID]
            let owner = getPlayerIndex(p);
            
            if(info.area == 'players') owner = info.player;
            if(info.area == 'beamed'){
                let bc = parseInt(info.deck);
                let bInfo = get(state).cardLog[bc];
                if(bInfo.area == 'players') owner = bInfo.player;
            }
            if(params.owner == 'opponent') owner = [0, 1].find(o => o != owner); // to opponent's!
            await moveTo(card, `players.${params.place}.${owner}`);
        },
        log: (params) => {
            return `put ${cc(params.obj)} on top of ${params.deck || params.place || 'deck'}`;
        }
    },
    {
        name: 'Put to bottom',
        type: 'bottom',
        cardShortcut: 'shift+B',
        action: async (p, params) => {
            setDefault(params);
            //params.hidden = isFacedown(getCard(params.obj));
            if(params.auto && (!params.place || params.place == 'draw')) params.place = 'deck'
            //if(params.owner == 'opponent') p = otherPlayer(p); // to opponent's!
            await bottom(p, getCard(params.obj), params);
        },
        log: (params) => {
            return `put ${cc(params.obj)} on bottom of deck`;
        }
    },
    {
        name: '←',
        type: 'shift_left',
        cardShortcut: 'left',
        action: async (p, params) => {
            params.keepLooksOpen = true;
            await shiftLeft(getCard(params.card))
        }
    },
    {
        name: '→',
        type: 'shift_right',
        cardShortcut: 'right',
        action: async (p, params) => {
            params.keepLooksOpen = true;
            await shiftRight(getCard(params.card))
        }
    },
    {
        name: 'Take in hand',
        type: 'hand',
        cardShortcut: 'down',
        action: async (p, params) => {
            setDefault(params);
            //params.hidden = isFacedown(getCard(params.obj));
            let c = getCard(params.obj);
            await moveTo(c, `players.hand.${rightPlayerIndex(p, c)}`, -1);
        },
        log: (params) => {
            return `took ${cc(params.obj)} into hand`;
        }
    },
    {
        name: 'Keep',
        type: 'keep',
        action: async (p, params) => {
            /*setDefault(params);
            params.hidden = isFacedown(getCard(params.obj));
            let c = getCard(params.obj);
            await moveTo(c, `players.hand.${rightPlayerIndex(p, c)}`, -1);*/
            // No effect for now, but could involve taking into hand explicitly if need be
        },
        log: (params) => {
            return `kept ${cc(params.obj)}`;
        }
    },
    {
        name: 'Snap',
        type: 'snap',
        action: async (p, params) => {
            if(p.captain != 'Q') throw 'uncompleted';
            setDefault(params);
            let c = getCard(params.obj);
            let playerInd = rightPlayerIndex(p, c)
            
            await moveTo(c, `players.deck.${playerInd}`, -1);
        }
    },
    {
        name: 'Recall',
        type: 'recall',
        cardShortcut: 'down',
        listAs: 'recall',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj)
            let playerInd = rightPlayerIndex(p, c)
            if(get(state).players[playerInd].bot){
                await moveTo(c, `players.discard.${playerInd}`);
            }else{
                await moveTo(c, `players.hand.${playerInd}`);
            }
            
        },
        log: (params) => {
            return `recalled ${cc(params.obj)}`;
        }
    },
    {
        type: 'conditional_promote',
        action: async (p, params) => {
            if(matches(getCard(params.card), 'person')) await doAction(p, 'duty', {card: params.card});
        }
    },
    {
        name: 'Promote to Duty Officer',
        type: 'duty',
        cardShortcut: 'y',
        action: async (p, params) => {
            setDefault(params);
            if(!params.obj || (Array.isArray(params.obj) && (params.obj.length == 0 || !params.obj[0]))){
                if(params.from) params.obj = params.from;
            }
            if(!Array.isArray(params.obj)) params.obj = [params.obj];
            let cards = params.obj.map(c => getCard(c));
            cards = cards.filter(c => matches(c, 'person')); // Only people can be promoted to duty officer unless forced
            let from = [];
            for(let c of cards){
                let deck = get(state).cardLog[c.uniqueID].deck;  
                if(deck == 'play') deck = 'action_area'; // for promoted_from checking 
                if(!from.includes(deck)) from.push(deck);
            }
            cacheItem('promotedFrom', from);
            if(cards.length == 0) throw 'uncompleted';
            await duty(p, cards);
        },
        log: (params) => {
            return `promoted ${cc(params.obj)} to Duty Officer`;
        }
    },
    {
        type: 'force_duty',
        action: async (p, params) => {
            setDefault(params);
            if(!params.obj || (Array.isArray(params.obj) && (params.obj.length == 0 || !params.obj[0]))){
                if(params.from) params.obj = params.from;
            }
            if(!Array.isArray(params.obj)) params.obj = [params.obj];
            let cards = params.obj.map(c => getCard(c));
            await duty(p, cards);
        },
        log: (params) => {
            return `promoted ${cc(params.obj)} to Duty Officer`;
        }
    },
    /*{
        type: 'promote_multiple',
        action: async (p, params) => {
            let choice = await choose(`Do you want to promote ${cc(params.obj)}`)
        }
    },*/
    {
        name: 'Select for Clean-up Duty',
        type: 'cleanup',
        action: async (p, params) => {
            setDefault(params);
            await moveTo(getCard(params.obj), `players.cleanup.${rightPlayerIndex(p, getCard(params.obj))}`);
        },
        log: (params) => {
            return `put ${cc(params.obj)} on Clean-up Duty`;
        }
    },
    {
        type: 'cleanup_action',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            await autoCardActions(c, getHints(c, 'cleanup'));
        },
        log: (params) => {
            return `Performed Clean-up action of ${cc(params.obj)}`
        }
    },
    {
        type: 'resupply',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            await autoCardActions(c, getHints(c, 'resupply'));
        },
        log: (params) => {
            return `Received supply from ${cc(params.obj)}`
        }
    },
    {
        name: 'Return to pile',
        type: 'return',
        cardShortcut: 'r',
        listAs: {
            return_incident: 'return incident',
            return_Redshirt: 'return Redshirt',
        },
        action: async (p, params) => {
            if(ongoingPlayer(p).includes('no_incident_return')){
                //cancel(params.card, 'Ongoing effect: player cannot return incidents!');
                logText(`Ongoing effect: player cannot return incidents!`);
                throw 'uncompleted';
            }
            setDefault(params);
            let c = getCard(params.obj);
            if(c){
                if(c.suits.includes('incident')) params.exactType = 'incident';
                if(matches(c, 'redshirt')) params.exactType = 'Redshirt';
            }
            /*if(p.bot && c.deck == 'Khan'){
                logText(`Khan [[incident]]: giving to other player instead of returning`)
                await doAction(p, 'give', {obj: params.obj});
            }else{*/
                await returnCard(getCard(params.obj))
            //}
            
        },
        log: (params) => {
            return `returned ${cc(params.obj)}`;
        }
    },
    {
        name: 'Look at any face-down deck',
        type: 'quinn_look',
        action: async (p, params) => {
            let facedownCommons = ['people', 'cargo', 'ships', 'allies', 'locations', 'encounters', 'incidents'];
            let facedownPlayers = ['deck', 'reserve', 'missions', 'continuum']
            let facedownDecks = [];
            for(let d of facedownCommons){
                let deckInfo = {
                    name: `${upperInitial(d)} deck`,
                    deck: get(state).commons[d],
                    topCardIndex: ['people', 'cargo', 'ships', 'allies'].includes(d) ? 1 : 0,
                    button: ['people', 'cargo', 'ships', 'allies', 'locations'].includes(d)
                }
                if(deckInfo.deck.length < deckInfo.topCardIndex + 1) continue; // Nothing there
                deckInfo.value = deckInfo.deck[deckInfo.topCardIndex];
                facedownDecks.push(deckInfo);
            };
            for(let p of get(state).players){
                for(let d of facedownPlayers){
                    if(d == 'deck' && faceupDraw(p)) continue; // can't look then
                    if(d == 'deck' && p.decks.deck.length == 0){
                        // Allow for reshuffle
                        facedownDecks.push({
                            name: `${p.captain} draw deck (triggering reshuffle)`,
                            deck: p.decks[d],
                            topCardIndex: 0,
                            button: true,
                            value: 'reshuffle_'+p.captain
                        })
                    }else if(p.decks[d] && p.decks[d].length > 0){
                        facedownDecks.push({
                            name: `${p.captain} ${d == 'deck' ? 'draw' : d} deck`,
                            deck: p.decks[d],
                            topCardIndex: 0,
                            value: p.decks[d][0]
                        })
                    }
                }
            }

            let cardsToOffer = facedownDecks.filter(d => !d.button).map(d => d.value);
            let extraChoices = facedownDecks.filter(d => d.button).map(d => {
                return {
                    name: d.name,
                    value: d.value
                }
            });
            let chosen = await chooseCards(`Click the top card of a deck to view it`, cardsToOffer, {extraChoices});
            
            if(!chosen || chosen == 'cancelled') throw 'cancelled';
            if(typeof chosen == 'string' && chosen.startsWith('reshuffle')){
                let captain = chosen.split('_')[1];
                let p = get(state).players.find(pl => pl.captain == captain);
                await reshuffleDeck(p, {});
                if(p.decks.deck.length == 0) throw 'uncompleted';
                chosen = p.decks.deck[0];
                params.chosenDeck = `${p.captain} draw deck (triggering reshuffle)`;
            }else if(chosen && chosen.uniqueID){
                let info = [...cardsToOffer, ...extraChoices].find(d => d && d.uniqueID == chosen.uniqueID || d.value && d.value.uniqueID == chosen.uniqueID)
                params.chosenDeck = info.name || 'unknown deck';
            }
            await doAction(p, 'look at', {card: params.card, obj: chosen.uniqueID});
            let bottom = await choose(`Put it on the bottom of its deck?`, ['Yes', 'No']);
            if(bottom == 'Yes'){
                await doAction(p, 'bottom', {card: params.card, obj: chosen.uniqueID});
            }
        },
        log: (params) => params.chosenName ? `Looked at top card of ${params.chosenName}` : ''
    },
    {
        name: 'Give to other player',
        type: 'give',
        action: async (p, params) => {
            setDefault(params);
            // April 2025: the below is now generalised in moveTo, so ditch it here
            /*state.update(s => {
                if(!s.cache) s.cache = {};
                if(!s.cache.cardOwner) s.cache.cardOwner = {};
                s.cache.cardOwner[params.obj] = getPlayerIndex(cardOwner(getCard(params.obj))); // So that if you give the played card to the other player, it still resolves as-is
                return s;
            })*/
            // need to add some logic for tokens!!
            if(params.obj.type == 'tokens'){
                let tok = params.obj.specific;
                let num = params.obj.num;
                let fail = false;
                if(params.obj.fromCard){
                    let c = getCard(params.obj.fromCard);
                    if(!c || !c[tok]) throw 'uncompleted';
                    if(c[tok] < num){
                        num = c[tok];
                        fail = true;
                    }
                    c[tok] -= num;
                }else{
                    // just from your store
                    
                    if(p[tok] < num){
                        num = p[tok];
                        fail = true;
                    }
                    p[tok] -= num;
                    
                }
                await doAction(otherPlayer(p), 'gain', {card: params.card, obj: {num, type: 'tokens', specific: tok}})
                //otherPlayer(p)[tok] += num; // reactions??
                if(fail) throw 'uncompleted'; // So costs fail
            }else{
                params.to = await giveCard(p, getCard(params.obj));
            }
            
        },
        log: (params) => {
            if(params.obj.type == 'tokens') return `gave ${params.obj.num} [[${params.obj.specific}]] to opponent`
            return `gave ${cc(params.obj)} ${params.to ? ' to '+params.to : ''}`;
        }
    },
    {
        name: 'Force other player to take',
        type: 'force_take',
        action: async (p, params) => {
            setDefault(params);
            params.to = await giveCard(p, getCard(params.obj));
        },
        log: (params) => {
            return `forced ${params.to ? ' to '+params.to : ''} to take ${cc(params.obj)} `;
        }
    },
    {
        name: 'Junk one of each suit',
        type: 'junk_each',
        action: async (p, params) => {
            for(let c of getMarketCards()){
                if(canJunk(c)) await doAction(p, 'junk', {obj: c.uniqueID});
            }
        },
        log: (params) => `junked one of each suit from the Market (where able)`
    },
    {
        name: 'Junk',
        type: 'junk',
        listAs: 'junk',
        cardShortcut: 'j',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj); 
            // Cards with tokens on them can never be junked
            if(!canJunk(c)){
                params.log = `couldn't junk ${cc(c)}: it has tokens on it`;
                throw 'uncompleted';
            }
            if(!c.left) c.left = {};
            c.left.turn = get(state).turn;
            c.left.location = 'junk';
            await moveTo(getCard(params.obj), 'commons.junk');
            if(p.gain_when_junk){
                for(let g of p.gain_when_junk){
                    logText(`Campaign reward: triggering junk benefit`);
                    await doAction(p, 'gain_tokens', {specific: g.specific, num: g.num});
                }
            }
        },
        log: (params) => {
            return params.log || `junked ${cc(params.obj)}`;
        }
    },
    {
        type: 'destroy',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj); 
            if(!c.left) c.left = {};
            c.left.turn = get(state).turn;
            c.left.location = 'destroyed';
            await moveTo(getCard(params.obj), 'commons.destroyed');
            // placeholder
        },
        log: (params) => {
            return `destroyed ${cc(params.obj)}`;
        }
    },
    {
        name: 'Gain',
        type: 'gain',
        action: async (p, params) => {
            setDefault(params);
            //let gains = await resolveObject(params.obj, 'gain', params, p);
            if(params.obj.type == 'tokens'){
                let fromCard = params.obj.fromCard || params.obj.from;
                if(Array.isArray(fromCard) && fromCard.length > 0){
                    if(fromCard.length == 1){
                        fromCard = fromCard[0];
                    }
                    // May 2025: will we need to add 'all' or choice handling for from multiples?   
                }
                if(params.obj.specific == 'resource' && fromCard){
                    await doAction(p, 'gain_card_tokens', {obj: fromCard, num: params.obj.num})
                }else{
                    await doAction(p, 'gain_tokens',{fromSupply: params.obj.fromSupply || false, ...params, fromCard: params.obj.fromCard || false, token: params.obj.specific || params.obj.types, amount: params.obj.num, noReactions: true});
                }
            }else if(params.obj.type == 'track'){
                await doAction(p, 'gain_track', {...params, track: params.obj.specific || params.obj.types, amount: params.obj.num, noReactions: true});
            }else{
                console.log('gaining '+params.obj)
                let copyParams = {...params, noReactions: true};
                await doAction(p, 'gain_card', copyParams)
                if(copyParams.to) params.to = copyParams.to;
            }
        }
            
    },
    {
        name: 'Steal',
        type: 'steal',
        listAs: 'steal',
        action: async(p, params) => {
            // presume it's always resources (no reason to believe otherwise)
            if(get(state).practice){
                // Just do it...
                p[params.obj.specific] += 1;
                params.toSteal = 1;
            }
            let opps = get(state).players.filter(o => o.captain != p.captain);
            let toSteal = params.obj.num;
            
            let type = params.obj.specific;
            for(let o of opps){
                if(get(state).practice) continue;
                if(params.obj.num == 'all') toSteal = o[type];
                if(o.bot){
                    if(o.captain == 'Burnham' && type == 'dilithium'){
                        logText(`Cannot steal ${o.captain}'s [[${type}]]`);
                        throw 'uncompleted';
                    }else{
                        params.toSteal = toSteal;
                        p[type] += toSteal;
                    } 
                    continue;
                }
                if(ongoingPlayer(o).includes('no_steal') && ongoingPlayer(o, 'no_steal').includes(type)){
                    logText(`Cannot steal ${o.captain}'s [[${type}]]`);
                    continue;
                }
                if(o[type] < toSteal) toSteal = o[type];
                params.toSteal = toSteal;
                if(toSteal == 0){
                    logText(`Opponent has no [[${type}]] to steal`);
                    throw 'uncompleted';
                }
                o[type] -= toSteal;
                p[type] += toSteal;
                if(params.auto){
                    ui.update(ui => {
                        ui.flash = [...ui.flash, {p:o, r: type}];
                        return ui;
                    })
                } 
            }      
            ui.update(ui => {
                ui.flash = [...ui.flash, {p:p, r: type}];
                return ui;
            })
        },
        log: (params) => {
            return `${params.hasOwnProperty('toSteal') && !params.toSteal ? `tried to steal ${params.obj.num} [[${params.obj.specific}]] from opponent, but opponent had none to steal` : `stole ${params.toSteal || params.obj.num} [[${params.obj.specific}]] from opponent.`}`
        }
    },
    {
        name: 'Spend',
        type: 'spend', // TODO should it just be for tokens, and lose for track?
        action: async(p, params) => {
            // TODO here is where to handle the cost adjustments where needed.
            if(typeof params.obj.num != 'number'){
                // We have to choose the amount. Should be a spinner, but for now multichoice
                if(params.obj.num.max){
                    let min = params.obj.num.min || 0;
                    let options = [];
                    for(let i = min; i <= params.obj.num.max; i++){
                        options.push(`${i} [[${params.obj.specific}]]`);
                    }
                    let choice = await choose(`How much do you want to spend?`, options);
                    console.log(params.obj)
                    if(!choice) throw 'uncompleted';
                    params.obj.num = parseInt(choice.split(' ')[0]);
                }
                
            }
            let num = params.obj.num;
            let incomplete = false;
            let noConversion = false;
            if(params.obj.type == 'tokens'){
                if(params.from){
                    let from = params.from;
                    if(Array.isArray(from)) from = from[0];
                    let c = getCard(from);
                    let tok = params.obj.specific;
                    num = await resolveNum(params.obj.num);
                    if(num == 'all'){
                        num = c[tok];
                        noConversion = true;
                        delete c[tok];
                    }else if(c[tok] < num){
                        incomplete = true;
                        num = 0;
                    }else{
                        c[tok] -= num;
                    }
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        if(!s.cache.lastSpend) s.cache.lastSpend = {};
                        s.cache.lastSpend[params.obj.specific] = num;
                        return s;
                    })
                    //result = await pay(c, [{type: 'spend', resource: params.obj.specific, num: params.obj.num}]);
                }else{
                    //await doAction(p, 'gain_tokens', {...params, token: params.obj.specific, amount: 0 - params.obj.num});
                    // Whim standing in for an action used to be paid out here, ahead of the real
                    // cost; pay() understands substitution now, so it settles both together and
                    // spends the action you have before reaching for whim.
                    if(params.obj.num){
                        let result = await pay(p, [{type: 'spend', resource: params.obj.specific, num: params.obj.num, noConversion: params.obj.num == 'all'}]); // TODO handle purposes if need be
                        if(!result){
                            incomplete = true;
                            num = 0;
                        }
                    }
                    
                }
                
            }else if(params.obj.type == 'track'){
                await doAction(p, 'spend_track', {...params, track: params.obj.specific, amount: params.obj.num});
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    if(!s.cache.lastSpend) s.cache.lastSpend = {};
                    s.cache.lastSpend[params.obj.specific] = num;
                    return s;
                })
            }
            
            if(incomplete) throw 'uncompleted';
            if(params.auto){
                ui.update(ui => {
                    ui.flash = [...ui.flash, {p, r: params.token}];
                    return ui;
                })
            }       
        }
    },
    {
        type: 'gain_gloriest_card',
        listAs: 'gain card',
        action: async (p, params) => {
            let cards = botFavouriteCards(p, getMarketCards().filter(c => c));
            let favOrder = [...cards];
            cards = cards.sort((a,b) => {
                let aGlory = a.glory || 0;
                let bGlory = b.glory || 0;
                if(aGlory != bGlory) return bGlory - aGlory;
                return favOrder.indexOf(a)  - favOrder.indexOf(b);
                //return bGlory - aGlory;
            })
            await doAction(p, 'gain_card', {obj: cards[0].uniqueID});
        }
    },
    {
        type: 'gain_one_less',
        listAs: 'gain_track',
        action: async (p, params) => {
            //ain one fewer"i _ types:Types _ "than" _ eachTypes:Types 
            let count = 0;
            let types = params.types;
            for(let c of cardsInPlay(p).filter(cd => !allBeamed(p).some(c => c.uniqueID == cd.uniqueID))){
                count += matches(c, params.eachTypes);
            }
            if(count > 0) count--;
            if(!Array.isArray(types)) types = [types];
            for(let t of types){
                await doAction(p, 'gain_track', {...params, track: t, amount: count})
            }
        }
    },
    {
        type: 'gain_most_card',
        listAs: 'gain card',
        action: async (p, params) => {
            let cards = botFavouriteCards(p, getMarketCards().filter(c => c));
            let favOrder = [...cards];
            cards = cards.sort((a,b) => {
                for(let t of params.types){
                    let aAmount = a[t] || 0;
                    let bAmount = b[t] || 0;
                    if(aAmount != bAmount) return bAmount - aAmount;
                }
                return favOrder.indexOf(a)  - favOrder.indexOf(b);
            })
            await doAction(p, 'gain_card', {obj: cards[0].uniqueID});
        }
    },
    {
        type: 'gain_card_tokens',
        action: async (p, params) => {
            // Implicitly from here
            if(!params.obj) params.obj = params.card;
            if(!params.hasOwnProperty('num')) params.num = 'all';
            let obj;
            if(params.obj == 'market'){
                let cards = getMarketCards().filter(c => allTokenTypes().some(t => c[t]));
                if(cards.length == 0) throw 'uncompleted';
                obj = await chooseCards(`Select a card to gain ${params.num} resources from it`, cards);
            }else{
                obj = getCard(params.obj);
            }
            await removeTokens(obj, p, true, params.num);
        },
        // No log because it's handled via the gain effects
        /*log: (params) => {
            return `Gained all resources from ${cc(params.from || params.card)}`;
        }*/
    },

    {
        type: 'gain_top',
        listAs: 'gain card',
        action: async (p, params) => {
            if(!params.types && params.obj && getCard(params.obj)){
                let suit = getCard(params.obj).suits[0];
                params.types = Object.keys(get(res).marketTypes).find(k => k == suit);
                if(!params.types){
                    logText(`Unable to find market category [[${suit}]]`);
                    throw 'uncompleted';
                }
            }
            let types = params.types;
            if(!Array.isArray(types)) types = [types];
            let available = types.filter(t => get(state).commons[get(res).marketTypes[t]].length > 1);
            let choice = available[0];
            if(available.length > 1){
                choice = await choose(`Choose type to gain from top of deck`, available.map(a => `[[${a}]]`));
                if(!choice || choice == 'cancelled') throw 'cancelled';
                choice = available.find(a => choice == `[[${a}]]`);
            }
            if(!choice) throw 'uncompleted';
            await doAction(p, 'gain_card', {...params, doReactions: true, obj: get(state).commons[get(res).marketTypes[choice]][1].uniqueID});
        }
    },
    {
        type: 'gain_highest_card',
        /// ("gain the highest value card of the top" _ num:Num _ types:Types _ "and destroy the other" _ destroyNum:Num {return {verb: 'gain_highest_card', types, num, destroyNum}})
        action: async (p, params) => {
            let types = params.types;
            if(!Array.isArray(types)) types = [types];
            let available = types.filter(t => get(state).commons[get(res).marketTypes[t]].length > 1);
            let choice = available[0];
            if(available.length > 1){
                choice = await choose(`Choose type to gain from top of deck`, available.map(a => `[[${a}]]`));
                if(!choice || choice == 'cancelled') throw 'cancelled';
                choice = available.find(a => choice == `[[${a}]]`);
            }
            if(!choice) throw 'uncompleted';
            let num = await resolveNum(params.num);
            //let destroyNum = await resolveNum(params.destroyNum);
            let topCards = get(state).commons[choice].slice(0, num);
            if(topCards.length == 0) throw 'uncompleted'; // No card to gain!
            topCards = botFavouriteCards(p, topCards); // So that tiebreakers are there too
            //let valP = botValuer(p);
            //topCards = topCards.sort((a,b) => valP(b) - valP(a));
            // Gain best
            let toGain = topCards[0];
            let toDestroy = topCards.slice(1);
            await doAction(p, 'gain_card', {obj: toGain.uniqueID});
            if(params.destroy){
                for(let c of toDestroy){
                    await doAction(p, 'destroy', {obj: c.uniqueID});
                }
            }
        }
    },
    {
        type: 'pike_focus_gain',
        //If Bot has X or more [[research]]/[[influence]]/[[military]] and if able, gain a card with matching Focus, including from the Junk
        action: async (p, params) => {
            let matchingTracks = [];
            for(let t of get(res).trackTypes){
                if(testNum(params.num, p[t])) matchingTracks.push(t);
            }
            if(matchingTracks.length == 0) throw 'uncompleted';
            let eligible = [...getMarketCards(), ...get(state).commons.junk].filter(c => c.stripe && c.stripe == 'wild' || matchingTracks.includes(c.stripe));
            if(eligible.length == 0) throw 'uncompleted';
            eligible = botFavouriteCards(p, eligible);
            params.cardGained = eligible[0].uniqueID;
            await doAction(p, 'gain_card', {obj: params.cardGained})
        },
        log: (params) => {
            if(!params.cardGained) return `tried to gain a card with matching tokens, but none available`
            return `gained a card with matching Focus, which was ${cc(params.cardGained)}`
        }
    },
    {
        name: 'Gain card',
        type: 'gain_card',
        listAs: 'gain card',
        cardShortcut: 'down',
        action: async (p, params) => {
            setDefault(params);
            //params.hidden = isFacedown(getCard(params.obj));
            let c = getCard(params.obj);
            let suit = c.suits[0];
            let redshirt = false;

            if(getMarketCards().some(cd => cd.uniqueID == c.uniqueID) && ongoingPlayer(p).includes('ignore_gain_types')){
                let types = ongoingPlayer(p, 'ignore_gain_types').flat(2);
                if(matches(c, types, false)){
                    await pause(`Your Passive prevents you from gaining a card of this type – cancelling...`);
                    cancel(c, 'Cannot gain this type of card due to passive');
                }
            }

            if(matches(c, 'redshirt')){
                redshirt = true;
                if(!p.stats.cardsGained['redshirt']) p.stats.cardsGained['redshirt'] = 0;
                p.stats.cardsGained['redshirt']++;
            }else if(suit){
                if(!p.stats.cardsGained[suit]) p.stats.cardsGained[suit] = 0;
                p.stats.cardsGained[suit]++;
            }else{
                if(!p.stats.cardsGained.none) p.stats.cardsGained.none = 0;
                p.stats.cardsGained.none++;
            }
            if(!c.left) c.left = {};
            c.left.turn = get(state).turn;
            c.left.location = p.captain;
            if(!params.to){
                let place = 'Discard'; // As default for bot
                //zif(c.suits.includes('incident')) place = 'Top of deck';
                if(!p.bot){
                    place = await choose(`Gain card to top of deck or discard?`, ['Top of deck', 'Discard'], {cancellable: true, card: [params.obj]})
                    if(!place || place == 'cancelled') throw 'cancelled';
                }
                
                
                if(place == 'Top of deck'){
                    params.to = {place: 'deck', placement: 'top'}
                }else{
                    params.to = {place: 'discard', placement: 'top'}
                }
            }
            if(params.to_name) params.to = params.to_name; // to revert parsing logic

            if(params.to?.card?.place){
                params.to = params.to.card; // to zoom in on the specific card
            }
            
            await moveTo(c, `players.${params.to.place}.${getPlayerIndex(p)}`, 0);

            params.gainedFrom = get(state).cardLog[c.uniqueID].deck == 'junk' ? 'junk' : 'market';
            
            if(p.captain == 'Khan' && c.traits && collectableTraits(c.traits, p).length > 0){
                // You can mark a trait as collected!
                let yes = await choose(`You may mark one of this card's traits (${collectableTraits(c.traits, p).map(t => `[[${t}]]`).join('/')}) as collected. Do you want to?`, ['Yes', 'No']);
                if(yes == 'Yes') await doAction(p, 'mark_collected', {obj: c.uniqueID})
            }
            
        },
        log: (params) => {
            return `gained ${cc(params.obj || params.card)} ${params.to ? `to ${params.to.placement ? `${params.to.placement} of` : ''} ${params.to.place}` : ''}`;
        }
    },
    {
        type: 'initiate_shutdown',
        action: async (p, params) => {
            await takeFromGloryPile(get(state).glory);
            //endGame('Resolution');
        },
        log: (params) => {
            return `initiated Shutdown`
        }
    },
    {
        type: 'score_now',
        action: async (p, params) => {
            endGame('Immediate scoring'); // should hopefully trigger necessary things etc.
        },
        log: (params) => {
            return `went immediately to scoring`
        }
    },
    {
        type: 'shuffle_back_market',
        action: async (p, params) => {
            let c = await chooseCards(`Select a card to shuffle back into its Market deck`, get(state).commons.junk.filter(c => c && c.deck == 'Common' && c.suits && ['person', 'cargo', 'ship', 'ally'].includes(c.suits[0])), {lookSpecific: true});
            if(!c || c == 'cancelled') throw 'cancelled';
            params.obj = c.uniqueID;
            await moveTo(c, `commons.${get(res).marketTypes[c.suits[0]]}`, -1);
            let top = get(state).commons[get(res).marketTypes[c.suits[0]]][0];
            shuffle(get(state).commons[get(res).marketTypes[c.suits[0]]]);
            state.update(s => {
                s.commons[get(res).marketTypes[c.suits[0]]] = [top, ...s.commons[get(res).marketTypes[c.suits[0]]].filter(c => c.uniqueID != top.uniqueID)];
                return s;
            })
        },
        log: (params) => `shuffled ${params.obj ? cc(params.obj) : 'a card'} back into its Market deck`
    },
    {
        type: 'shuffle_deck_draw',
        action: async (p, params) => {
            for(let c of params.obj){
                await moveTo(getCard(c), `players.deck.${getPlayerIndex(p)}`);
            }
            shuffle(p.decks.deck);
            await drawToHandSize(p);

        },
        log: (params) => `shuffled ${cc(params.obj)} into draw deck, then drew back up to hand size`
    },
    {
        type: 'remove_stardate_glory',
        listAs: 'remove Stardate [[glory]]',
        action: async (p, params) => {
            await takeFromGloryPile(params.num);
        },
        log: (params) => {
            return `removed ${params.num} [[glory]] from Stardate card`;
        }
    },
    {
        type: 'add_stardate_glory',
        listAs: 'add Stardate [[glory]]',
        action: async (p, params) => {
            let num = await resolveNum(params.num);
            state.update(s => {
                s.glory += num;
                //s.gloryTaken -= num;
                return s;
            })
            if(sdCards()[get(state).stardatePlayed]) sdCards()[get(state).stardatePlayed].glory += num;
        },
        log: (params) => {
            return `added ${params.num} [[glory]] to Stardate card`;
        }
    },
    {
        type: 'move_stardate_glory',
        listAs: 'move Stardate [[glory]]',
        action: async (p, params) => {
            let num = await resolveNum(params.num);
            if(p.glory < num) throw 'uncompleted';
            p.glory -= num;
            state.update(s => {
                s.glory += num;
                //s.gloryTaken -= num;
                return s;
            })
            if(sdCards()[get(state).stardatePlayed]) sdCards()[get(state).stardatePlayed].glory += num;
        },
        log: (params) => {
            return `moved ${params.num} [[glory]] to Stardate card`;
        }
    },
    {
        type: 'gain_tokens',
        listAs: 'gain tokens',
        action: async (p, params) => {
            if(p[params.token]+params.amount < 0) throw 'cancelled';
            if(params.fromCard){
                let card = getCard(params.fromCard);
                if(params.amount == 'all') params.amount = card[params.token];
                if(!card[params.token]){
                    logText(`${cc(params.fromCard)} has no [[${params.token}]] on it, so gaining none`);
                    throw 'uncompleted';
                }

                // Extra safeguard against stringification, though not sure why needed
                if(typeof params.amount == 'string') params.amount = parseInt(params.amount);
                if(typeof card[params.token] == 'string') card[params.token] = parseInt(card[params.token]);

                if(card[params.token] < params.amount){
                    logText(`${cc(params.fromCard)} only has ${card[params.token]} [[${params.token}]], so gaining that many instead of ${params.amount}`);
                    params.amount = card[params.token];
                }
                card[params.token] -= params.amount;
            }

            if(p.captain == 'Q' && p.bot && p.whim + params.amount > p.whim_limit){
                // gain excess as glory
                let toGlory = (p.whim + params.amount) - p.whim_limit;
                await doAction(p, 'gain_tokens', {...params, amount: toGlory, token: 'glory'});
                params.amount -= toGlory;
            }
            params.obj = {
                types: params.token,
                num: params.amount
            }
            await gainTokens(p, params.token, params.amount, params.fromSupply, params.fromCard, params.manual); 
            if(params.auto){
                ui.update(ui => {
                    ui.flash = [...ui.flash, {p, r: params.token}];
                    return ui;
                })
            }       
        },
        log: (params) => {
            return `${params.amount > 0 ? 'gained' : 'spent'} ${Math.abs(params.amount)} [[${params.token}]] ${params.fromCard ? 'from card '+cc(params.fromCard) : ''}`;
        }
    },
    {
        type: 'spend_tokens',
        action: async (p, params) => {
            if(p[params.token]+params.amount < 0) throw 'cancelled';
            params.obj = {
                types: params.token,
                num: params.amount
            }
            await gainTokens(p, params.token, 0 - params.amount); 
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(!s.cache.lastSpend) s.cache.lastSpend = {};
                s.cache.lastSpend[params.token] = params.amount;
                return s;
            })
            if(params.auto){
                ui.update(ui => {
                    ui.flash = [...ui.flash, {p, r: params.token}];
                    return ui;
                })
            }       
        },
        log: (params) => {
            return `spent ${params.amount} [[${params.token}]] ${params.fromCard ? 'from card '+cc(params.fromCard) : ''}`;
        }
    },
    {
        type: 'gain_track',
        listAs: 'gain on track',
        action: async (p, params) => {
            params.obj = {
                types: params.track,
                num: params.amount
            }
            if(!p.hasOwnProperty(params.track)){
                logText(`Player has no [[${params.track}]] track: abandoning`);
                throw 'uncompleted';
            }
            if(params.track == 'collective'){
                if(get(res).collectiveMax && p[params.track] + params.amount > get(res).collectiveMax){
                    params.amount = get(res).collectiveMax - p[params.track];
                    if(params.amount < 0) params.amount = 0;
                    if(params.amount == 0) params.trackAtMax = true;
                }
            }else{
                if(get(res).trackMax && p[params.track] + params.amount > get(res).trackMax){
                    params.amount = get(res).trackMax - p[params.track];
                    if(params.amount < 0) params.amount = 0;
                    if(params.amount == 0) params.trackAtMax = true;
                }
            }

            // Extra safeguard against stringification, though not sure why needed
            if(typeof params.amount == 'string') params.amount = parseInt(params.amount);
            if(typeof p[params.track] == 'string') p[params.track] = parseInt(p[params.track]);

            
            if(p[params.track]+params.amount < 0) throw 'cancelled';
            await gainTrack(p, params.track, params.amount);        
        },
        log: (params) => {
            if(params.trackAtMax) return `[[${params.track}]] at maximum: did not gain any more`;
            return `${params.amount > 0 ? 'gained' : 'lost'} ${Math.abs(params.amount)} [[${params.track}]]`;
        }
    },
    {
        type: 'gain_lowest',
         listAs: 'gain on track',
        action: async (p, params) => {
            let lowest = Infinity;
            let tracks = [];
            let track = null;
            for(let t of params.obj.types){
                console.log(p[t], lowest)
                if(p[t] < lowest){
                    tracks = [t];
                    lowest = p[t];
                }else if(p[t] == lowest){
                    tracks.push(t);
                }
            }
            track = tracks[0];
            if(tracks.length > 1){
                let chosen = await choose(`Which track do you want to gain on?`, tracks.map(t => `[[${t}]]`));
                track = tracks.find(t => chosen == `[[${t}]]`);
            }
            params.track = track;
            //await gainTrack(p, track, params.obj.num);  
            await doAction(p, 'gain_track', {track, amount: params.obj.num})      
        },
        /*log: (params) => {
            return `${params.obj.num > 0 ? 'gained' : 'lost'} ${Math.abs(params.obj.num)} [[${params.track ? params.track : params.obj.types}]]`;
        }*/
    },
    {
        type: 'gain_highest',
         listAs: 'gain on track',
        action: async (p, params) => {
            let highest = 0;
            let tracks = [];
            let track = null;
            for(let t of params.obj.types){
                console.log(p, params.obj.types, t, p[t], highest)
                if(p[t] > highest){
                    tracks = [t];
                    highest = p[t];
                }else if(p[t] == highest){
                    tracks.push(t);
                }
            }
            track = tracks[0];
            if(tracks.length > 1){
                let chosen = await choose(`Which track do you want to gain on?`, tracks.map(t => `[[${t}]]`));
                track = tracks.find(t => chosen == `[[${t}]]`);
            }
            params.track = track;
            await gainTrack(p, track, params.obj.num);        
        },
        log: (params) => {
           return `${params.obj.num > 0 ? 'gained' : 'lost'} ${Math.abs(params.obj.num)} [[${params.track ? params.track : params.obj.types}]]`;
        }
    },
    {
        type: 'junk_best',
        listAs: 'junk',
        action: async (p, params) => {
            let opp = get(state).players.find(pl => pl.captain != p.captain)//!p.bot)
            let eligible = [...getMarketCards()].filter(c => countAllTokens(c) == 0);
            if(eligible.length == 0){
                logText(`Tried to junk the most valuable card in the Market, but they all had tokens`);
                throw 'uncompleted';
            }
            let valOpp = botValuer(opp);
            eligible = eligible.sort((a,b) => valOpp(b) - valOpp(a));
            console.log('valuable sort', eligible);
            params.cardJunked = eligible[0].uniqueID;
            await doAction(p, 'junk', {obj: params.cardJunked})
        },
        log: (params) => {
            if(!params.cardJunked) return `tried to junk the most valuable card in the market, but they all had tokens`
            return `junked the most valuable (tokenless) card in the Market, which was ${cc(params.cardJunked)}`
        }
    },
    {
        type: 'gain_best',
        listAs: 'gain card',
        action: async (p, params) => {
            //let opp = get(state).players.find(pl => pl.captain != p.captain)//!p.bot)
            let eligible = botFavouriteCards(p, [...getMarketCards()]);//eligible.sort((a,b) => botValue(b, p) - botValue(a, p));
            console.log('valuable sort', eligible);
            if(eligible.length == 0){
                logText(`Tried to gain the most valuable card in the Market, but none available`);
                throw 'uncompleted';
            }
            params.cardGained = eligible[0].uniqueID;
            await doAction(p, 'gain_card', {obj: params.cardGained})
        },
        log: (params) => {
            if(!params.cardGained) return `tried to gain the most valuable card in the market, but none available`
            return `gained the most valuable card in the Market, which was ${cc(params.cardGained)}`
        }
    },
    {
        type: 'spend_track',
        action: async (p, params) => {
            params.obj = {
                types: params.track,
                num: params.amount
            }
            if(p[params.track]+params.amount < 0) throw 'uncompleted';
            await gainTrack(p, params.track, 0 - params.amount);        
        },
        log: (params) => {
            return `'lost' ${Math.abs(params.amount)} [[${params.track}]]`;
        }
    },
    {
        type: 'gain_1',
        tokenShortcut: 'up',
        action: async (p, params) => {
            await gainTokens(p, params.token, 1);        },
        log: (params) => {
            return `gained 1 [[${params.token}]]`;
        }
    },
    {
        type: 'lose_1',
        tokenShortcut: 'down',
        action: async (p, params) => {
            await gainTokens(p, params.token, 1);        },
        log: (params) => {
            return `spent 1 [[${params.token}]]`;
        }
    },
    {
        type: 'draw_reveal',
        action: async (p, params) => {
            await doAction(p, 'draw', {...params, doReactions: true});
            await doAction(p, 'reveal', {obj: possArray(params.drawn), doReactions: true});
        }
    },
    {
        name: 'Draw card',
        type: 'draw',
        listAs: 'draw',
        allShortcut: 'w',
        action: async (p, params) => {
            if(!params.obj) params.obj = {num: 1};
            if(params.limit_suits){
                let types = await getPrevTypes(p);
                if(types){
                    params.obj.types = types;
                }else{
                    logText('No previous suit to match, so abandoning action');
                    throw 'uncompleted';
                }
            }
            if(Array.isArray(params.obj) || typeof params.obj == 'number'){
                await doAction(p, 'hand', {...params, doReactions: true});
            }else if(params.from && params.from.length == 0){
                // In this case, drawing from somewhere empty (but hopefully not the top card of your deck!), so whiffing
                throw 'uncompleted';
            }else if(params.from && params.from[0] != 'deck' && params.from.some(c => !c || !getCard(c) || !getCard(c).uniqueID || get(state).cardLog[getCard(c).uniqueID].deck != 'deck')){
                // March 2026: added params.from.some stuff above to filter out choices if all the cards are coming from your draw deck
                // (fixes Rom)
                if(params.obj.types) params.from = params.from.filter(c => matches(c, params.obj.types));
                // Jan 2026: add filtering below to see!
                let eligible = params.from.map(c => getCard(c));
                // Commented out until resolveAnother respects 'it'
                eligible = await resolveFilters(p, params.obj, params, eligible, 'draw');
                params.from = eligible.map(c => c.uniqueID);
                if(params.from.length == 0){
                    params.drawn = [];
                    params.result = null;
                }else if(params.from.length == 1){
                    params.drawn = params.from;
                    params.result = params.from;
                    await moveTo(getCard(params.from[0]), `players.hand.${getPlayerIndex(p)}`);
                }else{
                    let card;
                    console.log(params)
                    if(params.obj.num == params.from.length && get(prefs).autoChoose){
                        card = params.from.map(c => getCard(c))
                    }else{
                        card = await chooseCards(`Choose ${params.obj.num} card(s) to draw`, params.from.map(c => getCard(c)), {lookSpecific: true, number: params.obj.num});
                    } 
                    if(Array.isArray(card)){
                        for(let c of card){
                            //if(isFacedown(c)) params.hidden = true;
                            await moveTo(c, `players.hand.${getPlayerIndex(p)}`);
                        }
                        params.drawn = card.map(c => c.uniqueID);
                        params.result = card.map(c => c.uniqueID);
                    }else if(card){
                        await moveTo(card, `players.hand.${getPlayerIndex(p)}`);
                        params.drawn = [card.uniqueID];
                        params.result = [card.uniqueID];
                    }
                }
            }else{
                //params.hidden = true;
                params.drawn = await drawCard(p, params.obj.num, params);
                params.result = params.drawn;
                console.log('drawn', params.result)
                // TODO fix!
                /*if(params.obj){
                    await resolveAction(p, 'draw', params, async (card) => {await drawCard(p, 1)});      
                }else{
                    if(!params.num) params.num = 1;
                    params.drawn = await drawCard(p, params.num)
                } */
            }
        },
        log: (params) => {
            return `drew ${params.drawn && Array.isArray(params.drawn) ? params.drawn.length : 1} card(s) ${params.from && params.from.place ? params.from_place  : '' }: ${params.drawn ? params.drawn.map(c => cc(c)) : ''}`;
        }
    },
    {
        name: 'Find',
        type: 'find',
        listAs: 'find',
        action: async (p, params) => {
            if(p.bot){
                if(get(res).BvB) throw 'completed';
                if(await choose(`Action involving bot finding a card does nothing: Succeed or Fail?`, ['Succeed', 'Fail']) == 'Succeed'){
                    if(p.decks.discard.length > 0 && await choose(`Do you want to put top card of Bot discard onto deck?`, ['Yes', 'No']) == 'Yes'){
                        await moveTo(p.decks.discard[0], `players.deck.${getPlayerIndex(p)}`, 0);
                    }
                    throw 'completed';
                }else{
                    throw 'uncompleted';
                }
            }
            let from = [...p.decks.hand, ...p.decks.discard, ...p.decks.deck];
            if(params.include_log) from = [...from, ...p.decks.log];
            if(params.also_recall) from = [...from, ...p.decks.duty, ...p.decks.locations, ...p.decks.fleet, ...p.decks.missions, ...p.decks.play, ...allBeamed(p)];
            if(!params.not_reserve) from = [...from, ...p.decks.reserve];
            if(params.in) from = params.in; // Check this works!
            //if(params.from) 
            if(params.obj && params.obj.location){
                from = [];
                let loc = params.obj.location;
                if(!Array.isArray(loc)) loc = [loc];
                for(let l of loc){
                    if(l.place) l = l.place;
                    // TODO if there's ever a 'find a card in someone else's deck' this should change
                    if(p.decks.hasOwnProperty(l)){
                        from = [...from, ...p.decks[l]];
                    }
                }
            }
            let eligible = from;
            let num = 1;
            
            if(params.limit_suits || params.obj && params.obj.card && params.obj.card == 'same_suit'){
                let suits = await getPrevTypes(p);
                if(!suits){
                    alert('No previous action to look for same suit: action fails');
                    throw 'uncompleted';
                }
                
                eligible = eligible.filter(c => suits.some(s => c.suits.includes(s)));
            }
            
            if(params.obj){
                if(params.obj.types){
                    eligible = eligible.filter(c => matches(c, params.obj.types)); // TODO what about joint types??
                    if(params.obj.types == 'incident' || Array.isArray(params.obj.types) && params.obj.types.some(t => t == 'incident')){
                        if(ongoingPlayer(p).includes('can_target_log_incidents')) eligible = [...eligible, ...p.decks.log.filter(c => matches(c, 'incident'))];
                    }
                }else if(params.obj.card && params.obj.card.card){
                    eligible = eligible.filter(c => matches(c, params.obj.card.card));
                }

                // replace with resolveFilters() in future?
                
                if(params.obj.filter){
                    eligible = eligible.filter(c => matches(c, params.obj.filter)); // TODO what about joint types??
                }

                if(params.obj.another){
                    // Filter out prev obj stuff
                    eligible = await resolveAnother(eligible);
                }

                if(params.obj.qualifier){
                    eligible = await resolveQualifier(p, params.obj.qualifier, params, eligible);
                }
                
                num = await resolveNum(params.obj.num) || 1;
            }

            if(params.with && params.with_name && params.with_name.types){
                eligible = eligible.filter(c => matches(c, params.with_name.types) >= params.with_name.num);
            }
            
            if(eligible.length == 0){
                // Unable to find any
                cardMessage(getCard(params.card), 'Unable to find card!')
                throw 'uncompleted'; // Needed to stop seqVerbs firing?
                //return; 
            }
            let chosen;
            if(typeof num != 'number' || eligible.length > num){
                chosen = await chooseCards(`Choose ${cn(num)} card${num == 1 ? '' : 's'} to find`, eligible, {lookSpecific: true, number: num});
                if(!chosen || chosen == 'cancelled') throw 'cancelled';
            }else{
                chosen = eligible;
                cardMessage(chosen, `Card(s) ${chosen.map(c => c.name)} found!`);
            }
            shuffle(p.decks.deck);
            shuffle(p.decks.reserve);
            if(!Array.isArray(chosen)) chosen = [chosen];
            params.result = chosen.map(c => c.uniqueID);
            for(let c of chosen){
                let deck = get(state).cardLog[c.uniqueID].deck;
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    if(!s.cache.foundIn) s.cache.foundIn = [];
                    s.cache.foundIn.push(deck);
                    return s;
                })
                await moveTo(c, `players.hand.${getPlayerIndex(p)}`);
            }
        },
        log: (params) => {
            return `searched for ${params.obj && params.obj.types ? possArray(params.obj.types).map(t => `[[${t}]]`).join('') : 'a card'}: ${params.result ? cc(params.result)+' found' : ''}`
        }
    },
    {
        type: 'reveal',
        action: async (p, params) => {
            await doAction(otherPlayer(p), 'look at', {obj: params.obj});
        },
        log: (params) => `revealed ${params.obj.map(o => `${cc(o)}`).join(' ')}`
    },
    {
        type: 'look at',
        action: async (p, params) => {
            setDefault(params);
            // Placeholder because the rest should be handled automatically by the next action using prev_obj
            let look = params.obj;
            if(!Array.isArray(params.obj)) look = [look];
            //lookAtCards(look.map(c => getCard(c)));
            //await choose(`Looking at card: press OK to continue`, ['OK']);  
            if(look.flat(2).length == 0) throw 'uncompleted';
            if(params.reorder){
                //let top = [];
                let bottom = [];
                let extraChoices = [];
                /*if(params.reorder.includes('top')){
                    extraChoices = [...extraChoices, 
                        {
                            name: 'Put on top',
                            condition: () => get(ui).selection,
                            action: () => {
                                if(!get(ui).selection) return;
                                top = [get(ui).selection, ...top];
                                ui.update(ui => {
                                    let s = ui.selection;
                                    ui.selection = 0;
                                    ui.waiting[0].cards = ui.waiting[0].cards.filter(c => c.uniqueID != s.uniqueID);
                                    return ui;
                                })
                            }
                        }
                    ];
                }*/
                if(params.reorder.includes('bottom')){
                    extraChoices = [...extraChoices, 
                        {
                            name: 'Put on bottom',
                            condition: () => get(ui).selection,
                            action: () => {
                                if(!get(ui).selection) return;
                                //bottom = [get(ui).selection, ...bottom];
                                let {area, deck, player} = get(state).cardLog[get(ui).selection.uniqueID];
                                let d = getDeck(get(state), area, deck, player);
                                let i = d.findIndex(c => c.uniqueID == get(ui).selection.uniqueID);
                                if(i == -1) return; // Card not where the log says: don't splice(-1) and eat the bottom card
                                d.splice(i, 1);
                                //console.log(d);
                                d.push(get(ui).selection);
                                ui.update(ui => {
                                    let s = ui.selection;
                                    ui.selection = 0;
                                    ui.waiting[0].cards = ui.waiting[0].cards.filter(c => c.uniqueID != s.uniqueID);
                                    return ui;
                                })
                            }
                        }
                    ];
                }
                
                
                await chooseCards('Reordering cards: choose where to put each card and then press OK to continue', look.map(c => getCard(c)), {
                    optional: true,
                    //specialCondition: (ui, state) => ui.waiting[0].cards.length == 0,
                    extraChoices,
                    noCard: 'OK', look: true, reorder: true
                });
                
                /*let {area, deck, player} = get(state).cardLog[look[0]];
                let d = getDeck(get(state), area, deck, player);
                // Now top and bottom tell us what to do
                for(let t of [...bottom]){
                    let i = d.findIndex(c => c.uniqueID == t.uniqueID);
                    if(i == -1) throw 'card not found!';
                    d.splice(i, 1);
                }*/
                // Now put back (we are just presuming that the deck is the same for all)
                //d.unshift(...top);
               // d.push(...bottom);
                state.update(s => {
                    return s; // Just to flag the change
                })
            }else if(params.take){
                let cards =  await chooseCards(`Choose ${cn(params.take)} cards to take:`, look.map(c => getCard(c)), {number: params.take, lookSpecific: true});
                let finalObj = [];
                let unselected = look.filter(c => !cards.some(cd => cd.uniqueID == c));
                state.update(s => {
                    s.cache.notTaken = unselected;
                    return s;
                })
                for(let c of cards){
                    await doAction(p, 'take', {card: params.card, obj: c.uniqueID});
                    finalObj.push(c.uniqueID);
                }
                params.result = finalObj;
                if(params.shuffle){
                    if(params.shuffle == 'encounter'){
                        shuffle(get(state).commons.encounters);
                    }else if(params.shuffle == 'locations'){
                        shuffle(get(state).commons.locations);
                    }
                    logText(`Shuffled [[${params.shuffle}]] deck`);
                }else if(params.destroy){
                    // Destroy them!
                    for(let c of look.filter(cd => !cards.some(c => cd == c.uniqueID)).map(c => getCard(c))){
                        if(!c.left) c.left = {};
                        c.left.turn = get(state).turn;
                        c.left.location = 'destroyed';
                        await moveTo(c, 'commons.destroyed');
                    }
                }else{
                    // Put them back on bottom
                    let type = 'encounters';
                    if(cards.some(c => !c.suits.includes('encounter') && matches(c, 'location'))) type = 'locations';
                    for(let c of look.filter(cd => !cards.some(c => cd == c.uniqueID)).map(c => getCard(c))){
                        await moveTo(c, `commons.${type}`, -1);
                    }
                }
            }else{
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    s.cache.showCards = look
                    return s;
                })
                await chooseCards('Looking at card(s): press OK to continue', look.map(c => getCard(c)), {optional: true, noCard: 'OK', lookSpecific: true});
                // Jan 2026: folded below into general reorder above
                /*if(params.choose_bottom){
                    let bottom = await choose(`Put card back on top or bottom of deck?`, ['Top', 'Bottom'], {cancellable: true});
                    if(!bottom || bottom == 'cancelled') throw 'cancelled';
                    if(bottom == 'bottom'){
                        for(let c of look){
                            await doAction(p, 'bottom', {obj: c});
                        }
                    }
                }*/
            }
        },
        log: (params) => {
            return `looked at ${cc(params.obj)}`
        }
    },
    {
        type: 'draw_discard_log',
        action: async(p, params) => {
            setDefault(params);
            //console.log
           // let l = lookAtCards(getCard(params.obj));
            /*ui.update(ui => {
                ui.selection = getCard(params.obj);
                return ui;
            })*/
            let choice = await choose(`Choose what to do with ${cc(params.obj)}:`, ['Draw', 'Discard', 'Log'], {card: [getCard(params.obj)]});
            if(choice == 'Draw'){
                await doAction(p, 'draw', {...params, doReactions: true});
            }else if(choice == 'Discard'){
                await doAction(p, 'discard', {...params, doReactions: true});
            }else if(choice == 'Log'){
                await doAction(p, 'log', {...params, doReactions: true});
            }
            //closeLook(l);
        }
    },
    {
        name: 'Beam',
        type: 'beam',
        cardShortcut: 'b',
        listAs: 'beam',
        action: async (p, params) => {
            /*if(params.to || params.location){
                params.to = await resolveLocation(params.to || params.location, 'beam', params, p);
            }*/
            setDefault(params);
            if(!params.to) params.to = params.location;
            if(params.location == 'here') params.to = params.card;
            let cards = possArray(params.obj).map(c => getCard(c));
            let from = [];
            if(params.to){
                let to = Array.isArray(params.to) ? params.to[0] : params.to;
                to = getCard(to);
                if(!isInPlayMarketNZ(to)){
                    // can't beam here!
                    logText(`Card is not in play/market/NZ, so you can't beam here!`);
                    throw 'uncompleted';
                }
            }
            for(let c of cards){
                let deck = get(state).cardLog[c.uniqueID].deck;  
                if(deck == 'play') deck = 'action_area'; // for promoted_from checking 
                if(!from.includes(deck)) from.push(deck);
            }
            cacheItem('beamedFrom', from);
           await beamCard(p, params);
        },
        log: (params) => {
            return `beamed ${cc(params.obj || params.card)} ${params.to ? ' to '+cc(params.to) : '' }`;
        }

    },
    {
        name: 'Beam/Commit to card',
        type: 'beam_to_card',
        listAs: 'beam',
        action: async (p, params) => {
            params.beamer = await beamToCard(p, getCard(params.card), params.filter, params.multiple);
        },
        log: (params) => {
            return `beamed ${cc(params.beamer)} to ${cc(params.card)}`;
        }
    },
    {
        type: 'control',
        listAs: 'take control',
        action: async (p, params) => {
            setDefault(params);
            await takeControl(p, getCard(params.obj), params);
         },
         log: (params) => {
             return `triggered the control effect of ${cc(params.obj)}`;
         }
    },
    {
        type: 'select_location_control',
        listAs: 'take control',
        action: async (p, params) => {
            let num = await resolveNum(params.num);
            let poss = get(state).commons.locations.slice(0, num);
            let chosen = await chooseCards(`Choose a location to take control of`, poss, {lookSpecific: true, cancellable: true});
            if(!chosen || chosen == 'cancelled') throw 'cancelled';
            let returned = poss.filter(c => c.uniqueID != chosen.uniqueID);
            params.obj = chosen.uniqueID;
            /*await takeControl(p, chosen, params);
            for(let c of returned){
                await moveTo(c, 'commons.locations', -1);
            }*/
           await doAction(p, 'gain_control', {obj: params.obj});
           for(let c of returned){
                await moveTo(c, 'commons.locations', -1);
            }
        }
    },
    {
        type: 'control_best',
        listAs: 'take control',
        action: async (p, params) => {
            let locs = getNeutralZone();
            if(params.bot){
                if(params.min) locs = locs.filter((c) => countPlayerTokens(c, p) >= params.min);
                locs = locs.sort((a,b) => countPlayerTokens(b, p) - countPlayerTokens(a, p));
            }else{
                if(params.min) locs = locs.filter((a, b) => countAllTokens(b) >= params.min);
                locs = locs.sort((a,b) => countAllTokens(b) - countAllTokens(a));
            }
            if(locs.length > 0){
                params.obj = locs[0].uniqueID;
                //await claimLocation(p, locs[0]);
                await doAction(p, 'gain_control', {obj: locs[0].uniqueID});
            }else{
                logText(`tried to take control of [[location]] with most tokens, but none to claim`);
                throw 'uncompleted';
            }
        }
    },
    {
        name: 'Accept',
        type: 'accept',
        cardShortcut: 'up',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(p.decks.missions.filter(m => !m.complete).length >= 2){
                logText(`Cannot have more than 2 uncompleted missions at at time: abandoning`);
                throw 'uncompleted'; // Cannot accept more than 2 at once
            }
            if(!matches(c, 'mission')){
                logText(`Cannot accept ${cc(params.obj)}, as it is not a [[mission]]`);
                throw 'uncompleted';
            }
            await moveTo(c, `players.missions.${rightPlayerIndex(p, c)}`, -1); // for testing
            let hints = getHints(c, 'accept');
            if(hints && hints.length > 0){
                await autoCardActions(c, getHints(c, 'accept')); // do all the relevant stuff
            }
        },
        log: (params) => `accepted ${cc(params.obj)}`
    },
    {
        name: 'Take control',
        type: 'gain_control',
        listAs: 'take control',
        cardShortcut: 'down',
        action: async (p, params) => {
            setDefault(params);
            if(!canGainControl(getCard(params.obj))) throw 'uncompleted';
            if(getNeutralZone().some(c => c.uniqueID == getCard(params.obj).uniqueID) && !params.fromClaim){
                await claimLocation(p, getCard(params.obj));
            }else{
                //await pause(`Can't gain control of a location you already have!`);
                //throw 'uncompleted';
                await takeControl(p, getCard(params.obj), {...params/*, takingControl: true*/});
            }
            
         },
         log: (params) => {
             return `took control of ${cc(params.obj)}`;
         }
    },
    {
        name: 'Activate',
        type: 'activate',
        action: async (p, params) => {
            setDefault(params);
            //params.chosenHint = getHints(getCard(params.obj), 'activate');
            await activateCard(getCard(params.obj), params);
        },
        log: (params) => {
            return `activated ${cc(params.obj)}`;
        }
    },
    {
        name: 'Mark',
        type: 'mark',
        // Rules of Acquisition only
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(!matches(c, 'rule of acquisition')) throw 'uncompleted';
            if(p.marked_roa){
                let m = getCard(p.marked_roa);
                if(m) delete m.marked;
            }
            p.marked_roa = c.uniqueID;
            c.marked = true;
        },
        log: params => `marked ${cc(params.obj)}`
    },
    {
        name: 'mark_next_roa',
        action: async (p, params) => {
            let index = 0;
            let roas = p.decks.fleet.filter(c => matches(c, 'rule of acquisition'));
            if(p.marked_roa){
                index = roas.findIndex(r => r.uniqueID == p.marked_roa);
                if(index == -1){
                    index = 0;
                }else{
                    index++;
                }
            }
            let toMark = roas[index];
            await doAction(p, 'mark', {obj: toMark.uniqueID});
        }
    },
    {
        name: 'Refresh',
        type: 'refresh',
        listAs: 'refresh',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(!tableEffectsActive(c)){
                logText(`Can't refresh ${cc(c)} because it is not in the play area!`);
                throw 'uncompleted';
            }
            if(p.activations != -1) p.activations++;
            await deactivateCard(c);
        },
        log: (params) => {
            return `refreshed ${cc(params.obj)}`;
        }
    },
    {
        type: 'no_effect',
        action: async (p, params) => {
            console.log('no effect');
        }
    },
    {
        type: 'skip_control',
        action: async (p, params) => {
            state.update(s => {
                s.skipNextControl = true;
                return s;
            })
        }
    },
    {
        type: 'support',
        action: async (p, params) => {
            console.log('placeholder aciton');
        }
    },
    {
        type: 'put_in_staging',
        action: async (p, params) => {
            console.log('placeholder aciton');
        }
    },
    {
        type: 'all_incident',
        action: async (p, params) => {
            for(let p of get(state).players){
                await doAction(p, 'take', {card: params.card, obj: {num: params.num || 1, types: 'incident'}});
            }
        }
    },
    {
        name: 'Take',
        type: 'take', // incident
        listAs: {
            take_incident: 'take incident',
            take_encounter: 'take encounter',
            take_Redshirt: 'take redshirt'
        },
        cardShortcut: 'down',
        action: async (p, params) => {
            // TODO multiple redshirt etc.
            let num = 1;
            let selected = false;
            let type = 'incident';
            setDefault(params);
            if(Array.isArray(params.obj)){
                if(typeof params.obj[0] == 'number'){
                    type = getCard(params.obj[0]).suits[0];
                }else if(params.obj[0].types) type = params.obj[0].types;
            }else if(params.obj){
                if(typeof params.obj == 'number'){
                    type = getCard(params.obj).suits[0];
                }else if(params.obj.types){
                    type = params.obj.types;
                }
            }
            /*if(params.extra_num && possArray(params.extra_num.types).includes(type)){
                // Look at extras!
                let num = params.extra_num.num + 1;
                let deck = getDeckForCard(getCard(params.obj));
                let card = await chooseCards(`Select a [[${type}]] to take`, deck.slice(0, num), {lookSpecific: true});
                if(!card) throw 'uncompleted';
                params.obj = card.uniqueID;
            }*/
            if(type != 'incidents' && type != 'incident'){
                //params.hidden = isFacedown(getCard(params.obj));
                let c = getCard(params.obj)
                let suit = c.suits[0];
                params.exactType = suit;
                console.log('took card', suit, p.stats.cardsGained)
                if(suit){
                    if(!p.stats.cardsGained[suit]) p.stats.cardsGained[suit] = 0;
                    p.stats.cardsGained[suit]++;
                }else{
                    if(!p.stats.cardsGained.none) p.stats.cardsGained.none = 0;
                    p.stats.cardsGained.none++;
                }
                if(!c.left) c.left = {};
                c.left.turn = get(state).turn;
                c.left.location = p.captain;
                if(params.to_name){
                    // presume owner always == 'you'
                    await moveTo(c, `players.${params.to_name.place}.${getPlayerIndex(p)}`, 0);
                }else if(p.bot){
                    await moveTo(c, `players.deck.${getPlayerIndex(p)}`, 0);
                }else{
                    await moveTo(c, `players.hand.${getPlayerIndex(p)}`, -1);
                }
            }else{
                params.exactType = 'incident';

                if(ongoingPlayer(p).includes('ignore_incident_effect')){
                    let eff = ongoingPlayer(p, 'ignore_incident_effect');
                    for(let e of eff){
                        let c = getCard(params.card);
                        if(c && matches(c, e.ignoreType) && (!e.withTypes || matches(c, {types: e.withTypes}))){
                            let doIt = await choose(`You may choose to ignore this [[incident]] take effect. What do you want to do?`, ['Ignore', 'Take incident']);
                            if(doIt == 'Ignore') throw 'uncompleted';
                        }
                    }
                }

                if(!get(res).BvB && canBurn() && get(state).commons.incidents.length == 1 && activePlayer().captain == currentPlayer().captain && !get(state).players[get(state).currentPlayer].bot){
                    playSound('burn_warning');
                    let doIt = await choose(`Taking the final [[incident]] will end the game immediately in a Burn. Are you sure you want to do this?`, ['Yes 🔥', 'No']);
                    if(doIt != 'Yes 🔥') cancel(get(state).commons.incidents[0], 'Wisely stepped back from the brink of catastrophe');
                }
                //if(params.obj && params.obj.num) num = params.obj.num;
                if(params.obj && params.obj.types == 'incident') params.obj = get(state).commons.incidents[0].uniqueID;
                setDefault(params);
                let c = getCard(params.obj);
                if(c.suits.includes('incident') && (params.select || ongoingPlayer(p).includes('choose_for_look_incidents'))){
                    let eligible = get(state).commons.incidents;
                    if(params.select) eligible = eligible.slice(0, params.select);
                    params.obj = await chooseCards(`Choose an incident to keep (the others will be returned to the bottom of the pile)`, eligible, {lookSpecific: true});
                    if(!params.obj) throw 'cancelled';
                    params.obj = params.obj.uniqueID;
                    selected = true;
                    for(let e of eligible.filter(c => c.uniqueID != params.obj)){
                        await moveTo(e, `commons.incidents`, -1); // Move to bottom
                    }
                }
                //params.hidden = true;
                if(!p.stats.cardsGained.incident) p.stats.cardsGained.incident = 0;
                p.stats.cardsGained.incident += num;
            }
            if(!Array.isArray(params.obj)) params.obj = [params.obj];
            for(let o of params.obj){
                if(params.to_name && (params.to_name.place || params.to_name.card && params.to_name.card.place)){
                    // presume owner always == 'you'
                    await moveTo(getCard(o), `players.${params.to_name.place || params.to_name.card.place}.${getPlayerIndex(p)}`, 0);
                }else if(p.bot){
                    await moveTo(getCard(o), 'players.deck.'+getPlayerIndex(p), 0);
                }else{
                    await moveTo(getCard(o), 'players.hand.'+getPlayerIndex(p), -1);
                }
            }
            if(selected) shuffle(get(state).commons.incidents);
           //await moveTo(getCard(params.obj), 'players.hand.'+getPlayerIndex(p), -1);
        },
        log: (params) => {
            return `took ${cc(params.obj || '')}`;
        }
    },
    {
        name: 'Restore Away Teams',
        type: 'reset_ats',
        action: async (p, params) => {
            let num = parseInt(prompt('How many away teams/drones should I put on the captain?'));
            let c = p.decks.captain[0];
            if(!c) throw 'uncompleted';
            let pool = atPool(p);
            if(!c[pool]) c[pool] = {};
            c[pool][p.captain] = num;
            
        }
    },
    {
        type: 'activate_toggle',
        cardShortcut: 'a',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            //if(!canActivate(c))
            if(!c.activated && (p.activations > 0 || p.activations == -1)){
                params.done = 'activated';
                await activateCard(c, params);
            }else{
                if(p.activations != -1) p.activations++;
                params.done = 'refreshed';
                await deactivateCard(c);
            }
        },
        log: (params) => {
            return `${params.done} ${cc(params.obj)}`;
        }
    },
    {
        name: 'Play or activate (as appropriate)',
        type: 'play_activate',
        hide: true,
        cardShortcut: 'up',
        action: async (p, params) => {
            setDefault(params);
            params.done = 'activated';
            let c = getCard(params.obj);
            if(inHand(c)){
                /*if(c.playText && c.playText.toLowerCase().includes('free action:')){
                    params.done = 'free played';
                    params.actionDone = 'freeplay';
                    await playCard(p, getCard(params.card), {...params, free: true});
                }else if(p.actions > 0){
                    params.done = 'played';
                    params.actionDone = 'play';
                    //p.actions--;
                    await playCard(p, getCard(params.card), params);
                }*/
                params.done = 'played';
                params.actionDone = 'play';
                //p.actions--;
                await playCard(p, getCard(params.card), params);
            }else if(canActivate(c, p) && !c.activated && (p.activations > 0 || p.activations == -1)){
                params.done = 'activated';
                params.actionDone = 'activate';
                await activateCard(c, params);
            }else if(c.activated){
                params.done = 'refreshed';
                params.actionDone = 'refresh';
                if(p.activations != -1) p.activations++;
                await deactivateCard(c);
            }else{
                //return 'failed';
                //throw 'cancelled'; // Really?
            }
        },
        log: (params) => {
            return `${params.done || 'activated'} ${cc(params.obj)}`; // TODO no idea why activated is problematic...
        }
    },
    {
        type: 'token_on_card',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            await tokenOnCard(c, params.token, params.amount, params.from);
            await checkForReactions(p, 'card_tokens', {obj: params.obj}, 'before');
        },
        log: (params) => {
            if(params.amount > 0){
                return `placed ${params.amount} [[${params.token}]] on ${cc(params.obj || params.card)}`;
            }else{
                return `removed ${Math.abs(params.amount)} [[${params.token}]] from ${cc(params.obj || params.card)}`;
            }
            
        }
    },
    {
        //name: `View Captain's Log`,
        type: 'view_log',
        action: async (p, params) => {
            if(p.decks.log.length > 0) look(p.decks.log[0]);
        }
    },
    {
        name: 'View hand',
        type: 'view_hand',
        action: async (p, params) => {
            if(p.decks.hand.length > 0) look(p.decks.hand[0]);
        }
    },
    {
        name: 'View Staging area',
        type: 'view_staging',
        action: async (p, params) => {
            if(p.decks.play.length > 0) look(p.decks.play[0]);
        }
    },
    {
        type: 'junk_market',
        listAs: 'junk',
        action: async (p, params) => {
            let eligible = get(state).commons.market_zone.filter(c => c && canJunk(c));
            if(eligible.length > 0){
                let card = await chooseCards('Choose a card in the market to junk', eligible, {optional: params.optional});
                if(card && card != 'cancelled'){
                    await doAction(p, 'junk', { card: card.uniqueID });
                }
            }else if(get(state).commons.market.length > 0){
                params.log = 'no junkable market card, so junked top card market deck';
                await doAction(p, 'junk', {card: get(state).commons.market[0].uniqueID});
            }else{
                params.log = 'unable to junk any card: nothing eligible in market zone, and market deck empty';
            }
        },
        log: (params) => {
            return params.log || 'junked market card';
        }
    },
    {
        name: 'Teleport',
        type: 'teleport',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(ongoingPlayer(p).includes('only_self_teleport') && params.card != params.obj){
                // only by effects on their own cards
                cancel('Currently [[qsuit]] can only be teleported by effects on their own card')
            }
            let eligible = [...getNeutralZone(), ...getMarketCards(), ...cardsInPlay(p, false), ...cardsInPlay(otherPlayer(p), false)];
            if(params.to){
                eligible = possArray(params.to).map(t => getCard(t));
            }
            let toCard;
            if(c.whereAmI) eligible = eligible.filter(e => c.whereAmI != e.uniqueID); // Can't teleport to the same place
            if(eligible.length > 1 || !params.to){
                toCard = await chooseCards(`Select a card to teleport ${cc(c)} to`, eligible);
                if(!toCard || toCard == 'cancelled') throw 'cancelled';
            }else if(eligible.length == 0){
                throw 'uncompleted';
            }else{
                toCard = eligible[0];
            }
            params.to = toCard.uniqueID;
            if(params.to == c.uniqueID) cancel(c, `You can't teleport a Q to itself`)
            if(c.whereAmI){
                // remove from existing visiting card
                let v = getCard(c.whereAmI);
                if(v.visiting){
                     v.visiting = v.visiting.filter(s => s != c.uniqueID);
                    if(v.visiting.length == 0) delete v.visiting;
                }
               
            }

            if(!toCard.visiting) toCard.visiting = [];
            toCard.visiting = [...toCard.visiting, c.uniqueID];
            c.whereAmI = toCard.uniqueID;
        },
        log: (params) => `teleported ${cc(params.obj)} to ${params.to ? cc(params.to) : 'tbc'}`
    },
    {
        name: 'Orbit',
        type: 'orbit',
        cardShortcut: 'p',
        listAs: 'warp',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(c.ships && c.ships.length > 0){
                if(c.ships.length == 1){
                    params.ship = c.ships[0]
                }else{
                    let ship = await choose(`Choose a ship to warp:`, c.ships, {cancellable: true});
                    if(ship == 'cancelled') throw 'cancelled';
                    params.ship = ship;
                }
                params.to = await orbit(p, c, params.ship, params.to, false, params);
            }
            
        },
        log: (params) => {
            return `placed [[${params.ship || 'ship'}]] into orbit ${params.to ? 'around '+cc(params.to) : ''}`;
        }
    },
    {
        name: 'Select trait',
        type: 'select_trait',
        action: async (p, params) => {
            if(params.obj){
                let c = getCard(params.obj);
                let choice = await choose(`Select a trait from this card:`, c.traits.map(t => `[[${t}]]`), {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                params.selectedTrait = c.traits.find(t => choice == `[[${t}]]`);
                if(params.selectedTrait){
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.selectedTrait = params.selectedTrait;
                        return s;
                    })
                }
            }
        },
        log: (params) => {
            return `Selected ${params.selectedTrait ? `[[${params.selectedTrait}]]` : 'a trait'} from ${cc(params.obj)}`;
        }
    },
    {
        type: 'do_both',
        action: async (p, params) => {
            if(!get(state).cache || !get(state).cache.otherOptions) throw 'uncompleted';
            // Still need to allow for not all
            let effect = get(state).cache.otherOptions;
            if(!Array.isArray(effect)) effect = [effect];
            if(effect.length > 1){
                let choices = effect.map((c,i) => {
                    return {
                        text: `${upperInitial(joinText(c))}`,
                        numText: `${i}_${c}`,
                        value: c
                    }
                });
                if(params.upTo) choices.push('Finish choosing');
                let chosen = [];
                while(choices.some(c => c != 'Finish choosing' && !chosen.includes(c.numText))){
                    let priceAdjusted = [];
                    for(let c of choices){
                        priceAdjusted.push({
                            origText: c.text,
                            numText: c.numText,
                            text: `${(await canAfford(p, c.value, getCard(params.card)) && !chosen.includes(c.numText))? '': '!'}${c.text}`,
                            value: c.value
                        })
                    }
                    let which = await choose(`Choose action to take (you may take all of them):`, priceAdjusted.map(c => c.text), {cancellable: true, card: get(state).cache.showCards ? getCard(get(state).cache.showCards) : false});
                    if(which == 'Finish choosing') break;
                    if(!which || which == 'cancelled') throw 'cancelled';
                    which = priceAdjusted.find(c => which == c.text);
                    if(!which) throw 'uncompleted';
                    chosen.push(which.numText);
                    await resolveEffects(getCard(params.card), which.value, get(state).cache.otherAttack, get(state).cache.otherForced);
                }
            }else{
                await resolveEffects(getCard(params.card), effect, get(state).cache.otherAttack, get(state).cache.otherForced);
            }
            
        }
    },
    {
        name: 'Mark trait',
        type: 'mark_collected',
        action: async (p, params) => {
            //setDefault(params);
            if(!params.obj && params.card && !params.auto) params.obj = params.card
            let opp = get(state).players.find(o => o.captain != p.captain); 
            if(!p.collected_traits){
                p.collected_traits = [];
            }
            let traits = [];
            if(params.obj){
                let c = getCard(params.obj);
                if(c && c.traits){
                    traits = c.traits;
                }
            }else{
                // Just choose
               traits = countableTraits(get(res).traits).filter(t => t != 'wildcard'); 
            }
            traits = collectableTraits(traits, p, opp); //traits.filter(t => !p.collected_traits.includes(t));
            closeAllLooks();
            if(traits.length == 0){
                logText(`No available trait to mark as collected`);
                throw 'uncompleted';
            }else if(traits.length == 1){
                params.trait_collected = traits[0];
            }else{
                let choice = await choose(`Select trait to mark as collected:`, traits.map(t => `[[${t}]]`), {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                params.trait_collected = traits.find(t => choice == `[[${t}]]`);
            }
            await markCollected(params.trait_collected, p, opp);
            //p.collected_traits = [...p.collected_traits, params.trait_collected];
        },
        log: (params) => {
            if(params.trait_collected){
                return `marked trait [[${params.trait_collected}]] as collected ${params.obj ? `from ${cc(params.obj)}` : ''}`;
            }else{
                return `tried to collect a trait, but none available to collect`;
            }
        }
    },
    { /// (obj:Object _ "gain" "s"? _ type:Types _ "for the rest of the turn" { return {verb: 'trait_gain', obj, type}})
        type: 'trait_gain',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            if(!c.temporaryTraits) c.temporaryTraits = [];
            if(!Array.isArray(params.traits)) params.traits = [params.traits]
            for(let t of params.traits){
                c.temporaryTraits = [...c.temporaryTraits, t];
                c.traits = [...c.traits, t]
            }
        },
        log: (params) => {
            return `${cc(params.obj)} gained ${Array.isArray(params.traits) ? params.traits.map(t => `[[${t}]]`) : `[[${params.traits}]]`} for the remainder of the turn`;
        }
    },
    {
        type: 'wipe_card',
        action: async (p, params) => {
            let c = getCard(params.obj);
            if(!c.left) c.left = {};
            c.left.turn = get(state).turn;
            if(c.suits.includes('location')){
                c.left.location = 'destroyed';
                await moveTo(c, 'commons.destroyed'); // Destroy them now!
            }else{
                c.left.location = 'junk';
                await moveTo(c, 'commons.junk');
            }
            await doActionPause();
        },
        log: (params) => `wiped ${cc(params.obj)}`
    },
    {
        type: 'wipe_market',
        action: async (p, params) => {
            await wipeMarket(p, params.all);
        },
        log: (params) => `wiped ${params.all ? 'the Market and neutral [[location]]' : 'the Market'}`
    },
    {
        type: 'clear_badlands',
        action: async (p, params) => {
            await clearBadlands();
        },
        log: (params) => `cleared the *Badlands*`
    },
    {
        type: 'end_game',
        action: async (p, params) => {
            endGame('Resolution');
        },
        log: (params) => `triggered the end of the game`
    },
    {
        type: 'junk_top_distinct',
        action: async (p, params) => {
            params.result = await junkTopOfDistinctMarketDecks(p, params.num);
        },
        // Rendered from the working log before the action runs, so result may not exist yet
        log: (params) => `junked the top card of ${params.result ? params.result.length : `up to ${params.num.max ?? params.num}`} different Market deck(s)`
    },
    {
        type: 'junk_top_each',
        action: async (p, params) => {
            await removeTopOfEachMarketDeck(p, 'junk', params.num || 1);
        },
        log: (params) => `junked the top ${params.num > 1 ? `${params.num} cards` : 'card'} of each Market deck`
    },
    {
        type: 'destroy_stardate',
        action: async (p, params) => {
            // no-op, nothing happens
        }
    },
    {
        type: 'destroy_top_each',
        action: async (p, params) => {
            await removeTopOfEachMarketDeck(p, 'destroy', params.num || 1);
        },
        log: (params) => `destroyed the top ${params.num > 1 ? `${params.num} cards` : 'card'} of each Market deck`
    },
    {
        type: 'defer_stardate',
        action: async (p, params) => {
            if(!resolvingStardate) return; // only meaningful while a Stardate card is resolving
            deferStardate(resolvingStardate, params.owner, p);
        },
        log: (params) => `put the Stardate card in ${params.owner == 'you' ? 'their own' : `the inactive player's`} Staging Area`
    },
    {
        name: '',
        type: 'select',
        action: async (p, params) => {
            /*if(p.bot){
                if(confirm(`Action involving bot choosing a card does nothing: press OK to succeed, Cancel to fail`)){
                    throw 'completed';
                }else{
                    throw 'uncompleted';
                }
            }*/
            setDefault(params);
            state.update(s => {
                if(!s.cache) s.cache = {};
                s.cache.showCards = params.obj;
                if(!Array.isArray(s.cache.showCards)) s.cache.showCards = [s.cache.showCards];
                return s;
            })
            // Placeholder because the rest should be handled automatically by the next action using prev_obj  
        }
    },
    {
        name: '',
        type: 'choose',
        action: async (p, params) => {
            let choice = await choose(`Choose one of the following:`, params.obj.map(o => `[[${o}]]`));
            if(!choice || choice == 'cancelled') throw 'cancelled';
            let chosen = params.obj.find(o => choice == `[[${o}]]`);
            cacheItem('chosen', chosen);
        }
    },
    {
        name: 'Force away',
        type: 'force_away',
        action: async (p, params) => {
            await doAction(p, 'away', {...params, ignoring_ships: true, doReactions: true});
        }
    },
    {
        type: 'extra_away',
        action: async (p, params) => {
            if(params.owner) p = resolveOwner(getCard(params.card), params.owner);
            if(!p.decks.captain[0]) throw 'uncompleted';
            // Drones are this player's away teams, so an 'add an [[away team]]' effect adds a
            // drone - and takes the drone cap with it (see extra_drones above).
            let pool = atPool(p);
            let hrPool = pool == 'drones' ? '[[drone]]' : '[[away team]]';
            let current_total = availableAT(p, {}, pool);
            let max_away = pool == 'drones' ? 14 : 6;
            if(params.num + current_total > max_away){
                let diff = max_away - current_total;
                if(diff <= 0){
                    logText(`Unable to add more ${hrPool} beyond limit of ${max_away}: abandoning`);
                    throw 'uncompleted';
                }else{
                    logText(`Can only add ${diff} ${hrPool} before hitting limit of ${max_away}`);
                    params.num = diff;
                }
            }
            if(!p.decks.captain[0][pool]) p.decks.captain[0][pool] = {};
            if(!p.decks.captain[0][pool][p.captain]) p.decks.captain[0][pool][p.captain] = 0;
            p.decks.captain[0][pool][p.captain] += params.num;
        },
        log: (params) => `added ${params.num} [[away team]] to [[captain]]`
    },
    {
        type: 'extra_drones',
        action: async (p, params) => {
            let max_drones = 14; // hard-coded limit
            let current_total = availableAT(p, {}, 'drones');
            if(params.num + current_total > max_drones){
                let diff = max_drones - current_total;
                if(diff <= 0){
                    logText(`Unable to add more [[drone]] beyond limit of ${max_drones}: abandoning`);
                    throw 'uncompleted';
                }else{
                    logText(`Can only add ${diff} [[drone]] before hitting limit of ${max_drones}`);
                    params.num = diff;
                }
            }
            if(params.owner) p = resolveOwner(getCard(params.card), params.owner);
            if(!p.decks.captain[0]) throw 'uncompleted';
            p.decks.captain[0].drones[p.captain] += params.num;
        },
        log: (params) => `added ${params.num} [[drone]] to [[captain]]`
    },
    {
        type: 'destroy_tokens',
        action: async (p, params) => {
            let type = params.tokenType;
            if(type == 'drone') type = 'drones';
            if(type == 'away team') type = 'away_teams';
            let current_total = availableAT(p, {}, type);
            if(params.num > current_total) params.num = current_total;
            if(params.num == 0) throw 'uncompleted';
            if(!p.decks.captain[0]) throw 'uncompleted';
            if(p.decks.captain[0][type] && p.decks.captain[0][type][p.captain] < params.num){
                await returnTokensToCaptainCard(p, {}, params.num, type);
            }
            p.decks.captain[0][type][p.captain] -= params.num;
        },
        log: (params) => `returned ${params.num} [[${params.tokenType}]] to supply`
    },
    {
        type: 'send_murf',
        name: 'send [[murf]]',
        listAs: 'send away team',
        action: async (p, params) => {
            if(params.to) params.on = params.to;
            if(params.obj && params.obj.toCard){
                params.on = params.obj.toCard;
            }
            try{
                let o = params.on;
                if(Array.isArray(o)) o = o[0];
                await sendMurf(p, getCard(o), params.ignoring_ships);
                params.sent = true;
            }catch(e){
                if(e != 'uncompleted') throw e;
            }
        },
        log: (params) => {
            if(!params.sent) return `Unable to send [[murf]] to ${cc(params.on)}`;
            return `sent [[murf]] to ${cc(params.on)}`;
        }
    },
    {
        type: 'send_murf_at',
        name: 'send [[murf]] or [[away team]]',
        listAs: 'send away team',
        action: async (p, params) => {
            if(!p.decks.captain[0]) throw 'uncompleted';
            if(p.decks.captain[0].murf || availableAT(p, false, atPool(p)) == 0){
                await doAction(p, 'send_murf', {...params, obj: {num: 1}});
            }else{
                await doAction(p, 'away', {...params, obj: {num: 1}});
            }
        },
    },
    {
        type: 'send_defp',
        name: 'send [[defp]]',
        listAs: 'send away team',
        action: async (p, params) => {
            if(params.to) params.on = params.to;
            if(params.obj && params.obj.toCard){
                params.on = params.obj.toCard;
            }
            try{
                let o = params.on;
                if(Array.isArray(o)) o = o[0];
                let defp = defpCard(p);
                o = getCard(o);
                if(!defp){
                    logText(`Cannot send [[defp]]: don't have the relevant card`);
                    throw 'uncompleted';
                }
                if(defp.whereIsDefP){
                    let where = getCard(defp.whereIsDefP);
                    delete where.defp;
                }
                o.defp = defp.uniqueID;
                defp.whereIsDefP = o.uniqueID;
                params.sent = true;
            }catch(e){
                if(e != 'uncompleted') throw e;
            }
        },
        log: (params) => {
            if(!params.sent) return `Unable to send [[defp]] to ${cc(params.on)}`;
            return `sent [[defp]] to ${cc(params.on)}`;
        }
    },
    {
        name: 'Send drone here',
        type: 'send_drone',
        action: async (p, params) => {
            await doAction(p, 'away', {...params, obj: {num: 1, type: 'drone'}})
        }
    },
    {
        name: 'Remove drone',
        type: 'remove_drone',
        action: async (p, params) => {
            await doAction(p, 'remove_away', {...params, ATtype: 'drone', obj: {num: 1, type: 'drone'}})
        }
    },
    {
        name: 'Send away team here',
        type: 'away',
        listAs: 'send away team',
        cardShortcut: 'y',
        action: async (p, params) => {
            setDefault(params);
            if(params.at) params.on = params.at;
            if(params.to) params.on = params.to;
            if(params.obj && params.obj.toCard){
                params.on = params.obj.toCard;
            }
            
            params.atName = `${params.obj && params.obj.specific || params.obj.type ?  params.obj.specific || params.obj.type : '[[away team]]'}`
            if(!params.on){
                params.on = [ params.card ];
            }  
            params.to = params.on;
           if(atPool(p) == 'drones' && !(params.obj && (params.obj.specific || params.obj.type))){
                params.atName = '[[drone]]'
           }
            if(!Array.isArray(params.on)) params.on = [ params.on ]
            params.sent = 0;
            params.on = params.on.filter(c => canBeamTo(p, getCard(c), params));
            if(params.on.length == 0) throw 'uncompleted';
            for(let o of params.on){
                try{
                    let num = await awayTeam(p, getCard(o), params.obj.num, params.ignoring_ships, params.obj.specific || params.obj.type)
                    params.sent += num || params.obj.num;
                }catch(e){
                    if(e != 'uncompleted') throw e;
                }
            }
            params.result = params.on; // for prev_obj
            
        },
        log: (params) => {
            if(!params.sent) return `Unable to send ${params.atName} to ${cc(params.on)}`;
            return `sent ${cn(params.obj ? params.obj.num : 1)} ${params.atName} to ${cc(params.on)}`
        }
    },
    {
        name: 'Remove away team',
        type: 'remove_away',
        listAs: 'remove away team',
        action: async (p, params) => {
            if(!params.obj){
                params.obj = {num: 1};
            }
            // Drones are away teams, but an opponent's effect may only remove one if it explicitly
            // names a [[drone]]. `actor` is the player resolving the effect: p gets reassigned to
            // the token owner below, and your own effects may always spend your own drones.
            const actor = p;
            const droneTargeted = droneRemovalAllowed(params);
            const controller = params.card ? cardOwner(getCard(params.card)) : false;
            let type = params.ATtype || false; // For Murf; otherwise resolved per owner in removeAwayTeam
            if(params.obj.type == 'drone') type = 'drones';
            if(params.obj.type == 'platoon') type = 'platoon';
            if(params.obj.type == 'swarm') type = 'swarm';
            if(params.obj.types == 'opp_away'){
                params.obj.owner = 'opponent';
            }
            if(!params.from && params.obj.from){
                params.from = params.obj.from;
            }
            if(!params.from && !params.auto){
                params.from = [ params.card ];   
            }  
            if(params.from_resolved && (!params.from || Array.isArray(params.from) && params.from.length == 0))  throw 'uncompleted'; // if no card, don't finish
            //if(!params.from) throw 'uncompleted'; // if no card, don't finish
            if(!params.from){
                // Let the user select
                if(p.bot){
                    await removeBotAway(p, params.obj.num, params);
                    return; // Circumvent the below
                }else{
                    let eligible = [...getNeutralZone(), ...cardsInPlay(p).filter(c => matches(c, 'location'))];
                    eligible = eligible.filter(c => testNum(params.obj.num, myAway(p, c, 'remove_away')));
                    if(eligible.length == 0) throw 'uncompleted';
                    params.from = eligible.map(c => c.uniqueID).slice(0, 1);
                    if(eligible.length > 1){
                        let card = await chooseCards(`Choose a location to remove ${cn(params.obj.num)} Away Team(s) from it`, eligible);
                        if(!card || card == 'cancelled') throw 'cancelled';
                        params.from = [ card.uniqueID ];
                    }
                }
            }
            if(!Array.isArray(params.from)) params.from = [ params.from ];
            /*if(params.attack){
                // set p to be the enemy
                p = get(state).players.find(pl => pl != cardOwner(getCard(params.card)));
            }*/
            if(params.from){
                for(let o of params.from){
                    //console.log(o, params.obj.num, p);
                    if(params.obj.num == 'all' && !params.takingControl && !params.obj.owner && (!params.text || !params.text.includes('your [[away team]]'))){
                        // Above is a bit of a bodge
                        // Remove all all AT
                        let count = 0;
                        for(let p of get(state).players){
                            count += await removeAwayTeam(p, getCard(o), params.obj.num, type, {hostile: hostileRemoval(actor, p, controller, params), droneTargeted});
                        }
                        params.num = count;
                    }else{
                        if(params.obj.owner == 'opponent'){
                            p = get(state).players.find(pl => pl.captain != p.captain);
                        }
                        params.num = 0;
                        let num = params.obj.num || 1; 
                        if(num == 'all') num = myAway(p, getCard(o), 'remove_away');
                        if(getCard(o).murf && hasMurf(p) && !params.notMurf && (!params.attack || params.obj.owner != 'opponent' || params.takingControl)){
                            // Give the player the option if 
                            if(myAway(p, getCard(o), 'remove_away') > num){
                                let doIt = await choose(`Remove [[murf]] or [[away team]]?`, ['[[murf]]', '[[away team]]'], {cancellable: true});
                                if(!doIt || doIt == 'cancelled') throw 'cancelled';
                                if(doIt == '[[murf]]'){
                                    if(num.max){
                                        num.max--;
                                        num.num--;
                                    }else if(typeof num == 'number'){
                                        num--;
                                    }
                                    
                                    await removeAwayTeam(p, getCard(o), 1, 'murf');
                                }
                            }else{
                                // Just do it
                                if(num.max){
                                    num.max--;
                                    num.num--;
                                }else if(typeof num == 'number'){
                                    num--;
                                }
                                await removeAwayTeam(p, getCard(o), 1, 'murf');
                            }
                        }
                        if(typeof num != 'number' || num > 0) params.num += await removeAwayTeam(p, getCard(o), num, type, {hostile: hostileRemoval(actor, p, controller, params), droneTargeted});
                    }
                    
                }
            }else{
                let n = params.obj.num;
                if(n == 'all'){
                    // Get all out
                    n = 0;
                    for(let c of [...getNeutralZone(), ...p.decks.locations]){
                        n += myAway(p, c, 'remove_away');
                    }
                }
                for(let i = 0; i < n || n.min && i < n.min || n.max && i < n.max; i++){
                    let eligible = [...getNeutralZone(), ...p.decks.locations.filter(c => matches(c, 'location'))].filter(c => myAway(p, c, 'remove_away'));
                    let card = await chooseCards(`Select a location to remove an Away Team from (${i+1} of ${(n || n.min || n.max)+1})`, eligible);
                    params.num = await removeAwayTeam(p, card, 1, type, {hostile: hostileRemoval(actor, p, controller, params), droneTargeted});
                }  
            }
            //params.num = params.obj.num; // for prevVerb
            params.result = params.from; // for prev_obj
        },
        log: (params) => {
            if(!params.from && params.auto) return `No Away Teams to remove`;
            return `removed ${cn(params.num ? params.num : 1)} Away Team${params.num && params.num == 1 ? '' : 's'}  from ${cc(params.from || params.card)}`
        }
    },
    {
        name: 'Remove Drones',
        type: 'remove_drones',
        action: async (p, params) => {
            if(!params.obj){
                params.obj = {num: 1};
            }
            if(!params.from && params.obj.from){
                params.from = params.obj.from;
            }
            if(!params.from && !params.auto){
                params.from = [ params.card ];   
            }  
            //if(!params.from) throw 'uncompleted'; // if no card, don't finish
            if(!params.from){
                // Let the user select
                if(p.bot){
                    //await removeBotDrones(p, params.obj.num);
                    return; // Circumvent the below
                }else{
                    let eligible = [...getNeutralZone(), ...cardsInPlay(p).filter(c => matches(c, 'location') && c.drones)];
                    eligible = eligible.filter(c => testNum(params.obj.num, c.drones ? c.drones[p.captain] : 0));
                    if(eligible.length == 0) throw 'uncompleted';
                    params.from = eligible.map(c => c.uniqueID).slice(0, 1);
                    if(eligible.length > 1){
                        let card = await chooseCards(`Choose a location to remove ${cn(params.obj.num)} [[drone]]) from it`, eligible);
                        if(!card || card == 'cancelled') throw 'cancelled';
                        params.from = [ card.uniqueID ];
                    }
                }
            }
            if(!Array.isArray(params.from)) params.from = [ params.from ];
            /*if(params.attack){
                // set p to be the enemy
                p = get(state).players.find(pl => pl != cardOwner(getCard(params.card)));
            }*/
            if(params.from){
                for(let o of params.from){
                    //console.log(o, params.obj.num, p);
                    if(params.obj.owner == 'opponent'){
                        console.log('found!')
                        p = get(state).players.find(pl => pl.captain != p.captain);
                    }
                    params.num = await removeAwayTeam(p, getCard(o), params.obj.num, 'drone');
                }
            }else{
                let n = params.obj.num;
                for(let i = 0; i < n || n.min && i < n.min || n.max && i < n.max; i++){
                    let eligible = [...getNeutralZone(), ...p.decks.locations.filter(c => matches(c, 'location'))].filter(c => c.drones && c.drones[p.captain]);
                    let card = await chooseCards(`Select a location to remove a [[drone]] from (${i+1} of ${(n || n.min || n.max)+1})`, eligible);
                    params.num = await removeAwayTeam(p, card, 1, 'drone');
                }  
            }
            //params.num = params.obj.num; // for prevVerb
            params.result = params.from; // for prev_obj
        },
        log: (params) => {
            if(!params.from && params.auto) return `No [[drones]] to remove`;
            return `removed ${cn(params.num ? params.num : 1)} [[drone${params.num && params.num == 1 ? '' : 's'}]]  from ${cc(params.from || params.card)}`
        }
    },
    {
        name: 'Deploy & Warp',
        type: 'deploy_warp',
        action: async (p, params) => {
            await doAction(p, 'deploy', {...params, doReactions: true});
            await doAction(p, 'warp', {...params, doReactions: true});
        }
    },
    {
        type: 'new_mission',
        listAs: 'select new mission',
        action: async (p, params) => {
            let num = params.num;
            if(typeof num != 'number') num = 2;
            let eligible = get(state).commons.missions.slice(0, num);
            if(eligible.length == 0) throw 'uncompleted'; // None left
            let card = await chooseCards(`Choose a new mission to put into play`, eligible, {look: true, cancellable: true});
            if(!card || card == 'cancelled') throw 'cancelled';
            params.mission = card.uniqueID;
            await moveTo(card, `players.missions.${getPlayerIndex(p)}`);
        },
        log: (params => {
            return `chose a new mission (${cc(params.mission)})`;
        })
    },
    {
        name: 'Deploy',
        type: 'deploy',
        listAs: 'deploy',
        action: async (p, params) => {
            setDefault(params);
            if(ongoingPlayer(p).includes('only_deploy_types')){
                let c = getCard(params.obj)
                let all_odt = ongoingPlayer(p, 'only_deploy_types').filter(d => matches(c, d.relevant));
                let odt = all_odt.flatMap(t => t.types);
                if(odt.some(t => !matches(c, t))){
                    logText(`Passive effect: player can only deploy ${odt.map(c => `[[${c}]]`).join('/')}`);
                    throw 'uncompleted';
                }
            }
            await deploy(p, getCard(params.obj));
            if(params.exhaust) getCard(params.obj).activated = true;
        },
        log: (params => {
            return `deployed ${cc(params.obj || params.card)}${params.exhaust ? ', and exhausted it' : ''}`;
        })
    },
    {
        type: 'bot_resolve',
        action: async (p, params) => {
            let card = getCard(params.obj);
            p = cardOwner(card); // for 'you' choices that can set the wrong thing
            //if(!p.bot) p = get(state).players.find(p => p.bot);
            //if(get(state).players.every(p => p.bot)) p = cardOwner(card); // for BvB
            await moveTo(card, `players.play.${getPlayerIndex(p)}`, 0);
            await doAction(p, `put_in_staging`, {obj: card.uniqueID}); // just to trigger specific reactions
            await resolveBotCard(p, card, false);
            // Only the Bot's own action step sweeps its play area into the discard. Anywhere
            // else (e.g. a control effect) the card would sit there and be resolved again with
            // the cards drawn next action step, so discard it now
            let s = get(state);
            let inOwnActionStep = s.phase == 'action' && s.players[s.currentPlayer]?.captain == p.captain;
            if(!inOwnActionStep && getP(p).decks.play.some(c => c.uniqueID == card.uniqueID)){
                await moveTo(card, `players.discard.${getPlayerIndex(p)}`, 0);
            }
        },
        log: (params) => {
            return `resolved ${cc(params.obj)}`;
        }
    },
    {
        name: 'Duplicate bot row',
        type: 'resolve_bot_row',
        action: async (p, params) => {
            let chart = get(res).botCharts[p.captain][p.currentChart || 'chart'];
            let entry = chart.find(e => possArray(params.rowType).some(t => possArray(e.icon).some(i => i == t)));
            if(!entry){
                logText(`Unable to find row to duplicate`);
                throw 'uncompleted';
            }
            await doBotAction(p, getCard(currentCard()), entry);
        },
        log: (params) => `duplicated the ${possArray(params.rowType).map(t => `[[${t}]]`).join('/')} row`
    },
    {
        name: 'Resolve',
        type: 'resolve',
        listAs: 'resolve other card effect',

        action: async (p, params) => {
            let card = getCard(params.obj);
            //cardOnStack(card);
            //console.log(getAllPlayEffects(card))
            if(!params.effectType){
                // let them choose any...
                params.effectType = 'activation';
                params.otherEffect = ['play', 'resupply', 'cleanup', 'surprise']
            }
            params.effectType = params.effectType.toLowerCase();
            if(params.otherEffect && params.otherEffect.length > 0){
                let choice = await choose(`Which effect do you want to duplicate?`, [params.effectType, ...params.otherEffect].map(e => upperInitial(e)), {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                params.effectType = choice.toLowerCase();
            }

            if(get(state).resolvingFrom){
                logText(`Abandoning duplicate effect: you are already duplicating another effect`);
                throw 'uncompleted';
            }

            let oldRF, oldRT;
            state.update(s => {
                oldRF = s.resolvingFrom;
                oldRT = s.resolvingTo;
                s.resolvingFrom = params.obj;
                s.resolvingTo = params.card;
                //s.resolvingAs = get(state).players.findIndex(pl => pl.captain == p.captain);
                return s;
            })
            let savedCache = false;
            if(get(state).cache){
                savedCache = {...get(state).cache};
            }
            //let exceptEffect = false;
            if(params.inPlay && !inPlay(card)){
                logText(`Card is not in play, so cannot duplicate operations`);
                return;
            }
            let avoidChoice = get(state).avoidNextChoice;
            

            if(params.other && get(state).lastChoice){
                state.update(s => {
                    if(!s.avoidNextChoice) s.avoidNextChoice = [];
                    s.avoidNextChoice = [...s.avoidNextChoice, s.lastChoice];
                    return s;
                })
            }
            let savedNLC = get(state).noLogCards;
            if(params.noLog){
                state.update(s => {
                    if(!s.noLogCards) s.noLogCards = [];
                    s.noLogCards = [...s.noLogCards, params.card]; // This card cannot be logged for the duration of the effect
                    return s;
                })
            }
            let savedRL = get(state).replaceLog;
            if(params.subLog){
                // Has to resolve here because it has the cache context here
                let r = await resolveObject(params.subLog.obj, params.subLog.verb, {obj: params.subLog.obj}, p);
                state.update(s => {
                    if(!s.replaceLog) s.replaceLog = [];
                    s.replaceLog = [...s.replaceLog, {
                        ...params.subLog,
                        orig: params.card,
                        replacement: r,
                        /*verb: params.subLog.verb,
                        optional: params.subLog.optional,
                        stop: params.subLog.stop*/
                    }]
                    return s;
                })
            }
            let possibleEffects = [];

            if(params.effectType == 'activation') params.effectType = 'activate';

            if(params.effectType == 'action' || params.effectType == 'play'){
                possibleEffects = getAllPlayEffects(card);
            }else{
                possibleEffects = getHints(card, params.effectType);
            }
            let num = 1;
            if(params.numOps) num = params.numOps;
            if(num == 'any' || isNaN(num)) num = possibleEffects.length;
            let numTaken = 0;
            if(num > 1){
                state.update(s =>{
                    s.canStopActionChoices = true;
                    return s;
                })
            }
            while(numTaken < num && numTaken < possibleEffects.length && !get(state).stopDuplicating){
                
                let result = await autoCardActions(card, possibleEffects, true, getCard(params.card));
                if(result == 'stop') break;
                numTaken++;
                state.update(s => {
                    if(!s.avoidNextChoice) s.avoidNextChoice = [];
                    s.avoidNextChoice = [...s.avoidNextChoice, s.lastChoice];
                    return s;
                })
            }
            

            state.update(s => {
                delete s.canStopActionChoices;
                delete s.stopDuplicating;
                if(s.cache.cardOwner) savedCache.cardOwner = s.cache.cardOwner; // So that giving to an opponent isn't lost
                s.cache = {...savedCache}; // revert (check that this doesn't mess up stuff!)
                delete s.avoidNextChoice;
                if(avoidChoice) s.avoidNextChoice = avoidChoice;
                delete s.noLogCards;
                if(savedNLC) s.noLogCards = savedNLC; 
                delete s.replaceLog;
                if(savedRL) s.replaceLog = savedRL;
                return s;
            })

            state.update(s => {
                delete s.resolvingFrom;
                delete s.resolvingTo;
                if(oldRF) s.resolvingFrom = oldRF;
                if(oldRT) s.resolvingTo = oldRT;
                //delete s.resolvingAs;
                return s;
            })
            //cardOffStack(card);
        },
        log: (params) => {
            return `resolved the effect of ${cc(params.obj)}`
        }
    },
    {
        type: 'repeat_previous',
        action: async (p, params) => {
            if(get(state).cache && get(state).cache.prevEffects){
                let prev = get(state).cache.prevEffects;
                clearSlotsIn(prev.effects);
                await resolveEffects(getCard(params.card), prev.effects, prev.attack, prev.forced);
            }else if(get(state).cache && get(state).cache.prevAction){
                // Jan 2026: added {...params} so any new params get pasted in (only if they don't contradict)
                // ... if this gets more complex there might need to be a filtering system
                // (i.e. filter out obj, card, hidden, verb etc. from repeat_previous and just put rest in)
                clearSlotsIn(get(state).cache.prevAction.a);
                let copyParams = clone(params);
                delete copyParams.per;
                delete copyParams.obj;
                delete copyParams.hidden;
                delete copyParams.card;
                delete copyParams.verb;
                await resolveAction(p, getCard(params.card), {...copyParams, ...get(state).cache.prevAction.a}, get(state).cache.prevAction.attack, get(state).cache.prevAction.forced);
            }else{
                throw 'uncompleted'; // No previous action to complete
            }
        },
        log: (params) => {
            return `repeated previous effect`;
        }
    },
    {
        name: 'Complete mission',
        type: 'complete',
        listAs: 'complete mission',
        action: async (p, params) => {
            if(!params.obj) params.obj = params.card;
            let c = getCard(params.obj);
            await completeMission(c);
        },
        log: (params) => {
            return `completed mission ${cc(params.obj || params.card)}`;
        }
    },
    {
        name: 'Mark as complete (no actions)',
        type: 'mark_complete',
        listAs: 'complete mission',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            c.complete = true;
        }
    },
    {
        name: 'Recrystallize',
        type: 'recrystallize',
        action: async (p, params) => {
            let type = params.obj.specific;
            let num = params.obj.num;
            let holder = cardsInPlay(p).find(c => ongoingEffects(c).some(e => e == `${type}_holder`));
            if(!holder){
                logText(`Unable to find the [[${type}]] storage card, so abandoning effect`);
                throw 'uncompleted';
            }
            if(!holder[type]){
                logText(`Card has no [[${type}]] on it, so abandoning effect`);
                throw 'uncompleted';
            }
            if(num == 'all'){
                num = holder[type];
                params.recrystallized = num;
            }else if(typeof num != 'number'){
                if(num.max){
                    num = Math.min(num.max, holder[type]);
                    params.recrystallized = num;
                }else if(num.min){
                    if(holder[type] >= num.min){
                        num = holder[type];
                        params.recrystallized = num;
                    }else{
                        logText(`Not enough [[${type}]] to recrystallise, so abandoning`);
                        throw 'uncompleted';
                    }
                }else{
                    logText(`Don't know how to recrystallise this amount of [[${type}]], so abandoning (yes, it's a bug)`)
                    throw 'uncompleted'; // Can't do it
                }
            }
            if(holder[type] < params.obj.num){
                logText(`Card only has ${holder[type]} [[${type}]], so partially completing effect`)
                num = holder[type];
                params.recrystallized = num;
            }
            holder[type] -= num;
            p[type] += num;
            //gainTokens(p, type, num, true);
        },
        log: (params) => {
            return `recrystallized ${params.recrystallized || params.obj.num} [[${params.obj.specific}]]`;
        }
    },
    {
        name: 'Warp',
        type: 'warp',
        listAs: 'warp',
        action: async (p, params) => {
            // Now includes orbiting too, since they are the same (I think...?)
            setDefault(params);
            let c = getCard(params.obj);
            if(ongoingPlayer(p).includes('only_warp_by_types')){
                let owt = ongoingPlayer(p, 'only_warp_by_types');
                let card = getCard(params.card);
                if(params.obj != params.card && !matches(card, owt)){
                    logText(`Passive effect: you can only warp ships via effects on cards with ${owt.map(t => `[[${t}]]`).join('/')}`)
                }
            }
            let info = get(state).cardLog[c.uniqueID];
            if(info.deck != 'fleet') throw 'uncompleted'; // Can only warp deployed ships
           
            if(c.orbiting && c.orbiting.length > 0){
                if(c.orbiting.length == 1){
                    params.ship = c.orbiting[0].ship;
                }else{
                    let ship = await choose(`Choose a ship to warp:`, c.orbiting.map(s => s.ship), {cancellable: true});
                    if(ship == 'cancelled') throw 'cancelled';
                    params.ship = ship;
                }
                params.to = await warp(p, c, params.ship, params);
            }else if(c.ships && c.ships.length > 0){
                if(c.ships.length == 1){
                    params.ship = c.ships[0];
                }else{
                    let ship = await choose(`Choose a ship to warp:`, c.ships, {cancellable: true});
                    if(ship == 'cancelled') throw 'cancelled';
                    params.ship = ship;
                }
                 if(params.from && params.from_resolved){
                    // Check it's possible!
                    if(!c.orbitingCard || !c.orbitingCard[params.ship]) throw 'uncompleted';
                    let holder = c.orbitingCard[params.ship];
                    if(!possArray(params.from).some(cd => cd == holder)) throw 'uncompleted'; // so if from is specified it only fires if poss
                }
                params.to = await orbit(p, c, params.ship, params.to, params.behaviour, params); // END of orbit bit
            }
            
        },
        log: (params) => {
            return `warped [[${params.ship || 'ship'}]] ${params.to ? 'to '+cc(params.to) : ''}`;
        }
    },
    {
        name: 'Dismiss ship',
        type: 'dismiss_ship',
        // NB only for manual: use 'dismiss' for anything else!
        listAs: 'dismiss',
        action: async (p, params) => {
            setDefault(params);
            let c = getCard(params.obj);
            console.log(c);
            if(get(state).campaign && get(state).campaignInfo && get(state).campaignInfo.onlyShip){
                let c = getCard(params.obj);
                if(cardOwner(c) == p && !p.bot && c.area == 'Deployed' && matches(c, 'ship')){
                    let go = await choose(`Only Ship in the Quadrant: if this [[ship]] is dismissed you will lose the game immediately. Continue?`, ['Yes', 'No']);
                    if(go != 'Yes') throw 'cancelled';
                    endGame('Challenge');
                }
            }
            if(c.orbiting && c.orbiting.length > 0){
                if(!params.ship){
                    if(c.orbiting.length == 1){
                        params.ship = c.orbiting[0].ship;
                    }else{
                        let ship = await choose(`Choose a ship to dismiss:`, c.orbiting.map(s => s.ship), {cancellable: true});
                        if(ship == 'cancelled') throw 'cancelled';
                        params.ship = ship;
                    }
                }
                console.log(c, params);
                await dismissShip(p, c, params.ship);
            }
            
        },
        log: (params) => {
            return `dismissed [[${params.ship || 'ship'}]] from ${cc(params.obj)}`;
        }
    }
]

export let inPlayLocations = ['locations', 'fleet', 'duty', 'captain', 'play', 'missions']; // 'missions', 

export function playerResourceToken(p){
    if(p.bot && p.captain == 'Burnham'){
        return {
            token: 'dilithium',
            amount: 2
        }
    }
    let tok = ongoingPlayer(p).find(o => o.startsWith('cleanup_token_'));
    if(tok){
        let token = tok.slice('cleanup_token_'.length);
        let amount = 1;
        let a = ongoingPlayer(p).find(o => o.startsWith('cleanup_tokamount_'));
        if(a){
            amount = parseInt(a.slice('cleanup_tokamount_'.length));
        }
        return {token, amount};
    }
    return {
        token: 'glory',
        amount: 1
    }
}

export function isInPlay(c){
    for(let p of get(state).players){
        if(cardsInPlay(p).includes(c)) return true;
    }
    return false;
}

export function isInPlayMarketNZ(c){
    if(typeof c == 'number') c = getCard(c);
    if(!c) return false;
    return isInPlay(c) || [...getNeutralZone(), ...getMarketCards()].some(nz => nz.uniqueID == c.uniqueID);
}

export function numExpendableDrones(p){
    let eligible = placesWithDrones(p);
    return eligible.reduce((a,c) => a + c.drones[p.captain], 0);
}

function hasAway(c, ignore_neutral = false){
    if(!c) return false;
    // myAway() covers away teams, drones and murf, so ask it per player rather than reading
    // c.away_teams directly - otherwise the practice filter below never sees a drone-held card
    let holders = get(state).players.filter(p => myAway(p, c) > 0);
    if(holders.length == 0) return false;
    if(get(state).practice && ignore_neutral){
        if(!holders.some(p => p.captain != get(state).players[1].captain)) return false;
    }
    return true;
}

function hasShips(c){
    if(!c) return false;
    if(!c.orbiting) return false;
    if(c.orbiting.length == 0) return false;
    return true;
}

// Just the wipe now: what triggers it (a Stardate card, a card effect) is the caller's business.
// Resumable via state.wiping_market so an interruption partway through doesn't lose the rest.
async function wipeMarket(p, all = false){
    if(!get(state).wiping_market){
        state.update(s => {
            s.wiping_market = [...getMarketCards().map(c => c.uniqueID)];
            if(all) s.wiping_market = [...s.wiping_market, ...getNeutralZone().filter(c => !isBadlands(c)).map(c => c.uniqueID)];
            return s;
        })
    }
    for(let id of get(state).wiping_market){
        state.update(s => {
            s.wiping_market = s.wiping_market.filter(w => w != id); // clearing it first so that something happening in the middle doesn't torpedo it?
            return s;
        })
        if(getMarketCards().some(c => c.uniqueID == id)){ // So as not to double-wipe
            let c = getCard(id);
            await doAction(p, 'wipe_card', {obj: c.uniqueID});
        }else if(getNeutralZone().some(c => c.uniqueID == id)){
            let c = getCard(id);
            if(!hasTokens(c) || get(state).practice && countPlayerTokens(c, get(state).players[0]) == 0){
                await doAction(p, 'wipe_card', {obj: c.uniqueID});
            }
        }
    }

    state.update(s => {
        delete s.wiping_market;
        return s;
    })
}

// canControlLocation tests securing; a secured location may still forbid taking control.
export function canGainControl(c){
    if(!c || isBadlands(c)) return false;
    let ongoing = ongoingEffects(c, 'ongoing', true);
    return !ongoing.includes('cannot_control') && !ongoing.includes('cannot_gain_control');
}

export function canControlLocation(p, c){
    if(!c || !matches(c, 'location')) return false;
    let o = get(state).players.find(pl => pl.captain != p.captain);
    let mine = countPlayerTokens(c, p, true);
    let theirs = countPlayerTokens(c, o, true, (o.captain == 'Q' && get(state).currentPlayer == getPlayerIndex(p)));
    let minSecure = 3;
    let extra = 2;
    if(ongoingPlayer(p).includes('min_secure')){
        minSecure = Math.min(...ongoingPlayer(p, 'min_secure'))
    }
    if(ongoingPlayer(p).includes('min_extra_secure')){
        let newMin = minSecure;
        let newExtra = extra;
        for(let m of ongoingPlayer(p, 'min_extra_secure')){
            if(m.min < newMin) newMin = m.min;
            if(m.extra < newExtra) newExtra = m.extra;
        }
        minSecure = newMin;
        extra = newExtra;
    }
    if(mine >= minSecure && mine - theirs >= extra) return true;
    return false;
}


export function typeOfGain(t){
    //if(!t) return 'card';
    if(!t) return 'card';
    if(typeof t == 'object'){
        if(t.specific) t = t.specific;
        if(t.types) t = t.types;
    }
    if(Array.isArray(t)){
        let types = Array.from(new Set(t.map(type => typeOfGain(type))));
        if(types.length == 1) return types[0];
        return 'card'; // If in doubt default to this
    }
    
    if(!t.toLowerCase) return 'card';
    t = t.toLowerCase();
    if(t == 'collective') return 'track';
    if(t == 'treachery') return 'track';
    if(t == 'track') return 'track';
    if(t == 'wild') return 'track';
    if(get(res).trackTypes.includes(t)) return 'track';
    if(allResourceTypes().includes(t)) return 'tokens';
    if(t == 'action') return 'tokens';
    //if(t == 'command') return 'tokens';
    if(t == 'away' || t == 'opp_away' || t == 'away team') return 'away';
    if(t == 'murf') return 'away';
    if(t == 'drone') return 'drone'; // or away?
    if(t == 'resource') return 'tokens';
    if(t == 'token') return 'tokens';
    return 'card';
}

export function inMarket(deck){
    if(deck == get(state).commons.market_zone || deck == get(state).commons.allies || deck == get(state).commons.cargo || deck == get(state).commons.ships || deck == get(state).commons.people){
        return true;
    }
    return false;
}

export function cardsInPlay(p, include_beamed = true, include_dashboards = false){
    let cards = [];
    if(include_dashboards) cards = [...p.dashboard.passives];
    for(let k of Object.keys(p.decks)){
        if(inPlayLocations.includes(k)) cards = [...cards, ...p.decks[k]];
    }
    cards = cards.filter(c => c);

    if(!get(prefs).inPlayNotBeam && include_beamed){
        let toAdd = [];
        for(let c of cards){
            let possible = get(res).parsedCardText[c.id];
            if(c && c.beamed && c.beamed.length > 0 && possible && possible.effects){
                let ongoing = trawlFor(possible.effects.filter(e => (validEffect(c, e, p))), 'ongoing');
                if(ongoing.includes('things_beamed_here_are_not_in_play')) continue; // for Krulmuth
            }
            if(c.beamed && c.beamed.length > 0) toAdd = [...toAdd, ...c.beamed];
        }
        cards = [...cards, ...toAdd];
    }
    if(!include_dashboards) return cards;

    for(let m of [/*...p.decks.missions, */...p.dashboard.missions]){ // completed missions go into completed log now
        if(m.complete) cards = [...cards, m]; // So that table effects of missions count
    }

    return cards;
}

function isFacedown(c){
    if(!c) return false;
    let openMarketDecks = ['neutral_zone', 'junk'];
    let hiddenMarketDecks = ['encounters', 'incidents'];

    let info = get(state).cardLog[c.uniqueID];
    if(!info){
        console.log('error: card is nowhere!', c);
        return true;
    }
    if(info.area == 'beamed') return false;
    if(info.area == 'commons'){
        if(openMarketDecks.includes(info.deck)) return false;
        if(hiddenMarketDecks.includes(info.deck)) return true;
        let deck = getDeck(get(state), info.area, info.deck, info.player);
        if(deck.indexOf(c) == 0) return false;
    }
    if(info.area == 'players'){
        if(isInPlay(c)) return false;
        if(info.deck == 'discard' || info.deck == 'dev') return false;
    }
    return true;
}

export async function clearCards(c){
    // Remove all cards from orbit/beamed
    if(c.beamed && c.beamed.length){
        for(let b of c.beamed){
            await doAction(b.sourcePlayer, 'dismiss', {card: b.uniqueID});
        }
    }
    if(c.orbiting && c.orbiting.length){
        for(let o of c.orbiting){
            if(matches(getCard(o.card), 'ship')){
                // Is actually a ship, and not a captain
                await doAction(o.sourcePlayer, 'dismiss', {card: o.card.uniqueID});
            }
        }
    }
}

export function playerResourceTypes(p){
    let types = [...get(res).resourceTypes];
    if(get(res).extraTokenTypes && get(res).extraTokenTypes[p.captain]) types = [...types, ...possArray(get(res).extraTokenTypes[p.captain])];
    return types;
}

export function allResourceTypes(){
    let types = [...get(res).resourceTypes, 'action']; // messy...!
    for(let v of Object.values(get(res).extraTokenTypes || {})){
        for(let t of possArray(v)){
            if(!types.includes(t)) types = [...types, t];
        }
    }
    return types;
}

export function playerTokenTypes(p){
    let types = [...get(res).tokenTypes];
    if(get(res).extraTokenTypes && get(res).extraTokenTypes[p.captain]) types = [...types, ...possArray(get(res).extraTokenTypes[p.captain])];
    return types;
}

export function allTokenTypes(){
    let types = [...get(res).tokenTypes];
    for(let v of Object.values(get(res).extraTokenTypes || {})){
        for(let t of possArray(v)){
            if(!types.includes(t)) types = [...types, t];
        }
    }
    return types;
}

export function placesWithDrones(p){
    let eligible = [...getNeutralZone(), ...otherPlayer(p).decks.locations, ...cardsInPlay(p).filter(c => !ongoingEffects(c).includes('drone_alcoves'))];
    eligible = eligible.filter(c => c.drones && c.drones[p.captain]);
    return eligible;
}

export function trackTypes(p){
    let types = get(res).trackTypes;
    if(p.hasOwnProperty('collective')) types = [...types, 'collective'];
    if(get(res).modules.includes('Treachery')){
        types = [...types, 'treachery'];
    }
    return types;
}

export async function deploy(p, c, params){
    //if(p.bot && p.decks && p.decks.log && p.decks.log.some(cd => cd.uniqueID == c.uniqueID)) throw 'uncompleted'; // Cannot promote a card from log to DO
    if(matches(c, 'ship')){
        // possibly add ship token?
        if((!c.ships || c.ships.length == 0) && !ongoingEffects(c).includes('cannot_warp')){
            c.ships = [`${c.name.toLowerCase().replaceAll(` `, `_`)}`];
        }
    }
    let allowableDeploys = ['ship', 'ongoing', 'qsuit', 'continuum', 'amanda rogers']
    //if(!matches(c, 'amanda rogers') && !matches(c, 'ship', false) && !matches(c, 'qsuit', false) && !matches(c, 'ongoing', false) && !matches(c, 'on-going', false)) throw 'uncompleted'; // Cannot deploy except these types
    if(!allowableDeploys.some(a => matches(c, a, false))) throw 'uncompleted'; // don't count wildcards because Vadic shouldn't deploy
    await moveTo(c, `players.fleet.${rightPlayerIndex(p, c)}`, -1); // TODO make not locations!
    
}

export function hasDrones(c){
    if(!c.drones) return false;
    if(c.drones == {}) return false;
    let sum = 0;
    for(let k of Object.keys(c.drones)){
        sum += c.drones[k];
    }
    return sum;
}

export async function expendDrones(p, c, num){
    if(!c.drones || c.drones[p.captain] < num){
        logText(`Not enough drones available to expend`);
        throw 'uncompleted';
    }
    c.drones[p.captain] -= num;
    if(c.drones[p.captain] == 0 && !c.suits.includes('captain')) delete c.drones[p.captain];
    if(c.drones == {}) delete c.drones;
    let alcoves = cardsInPlay(p).find(c => ongoingEffects(c).includes('drone_alcoves'));
    if(alcoves){
        if(!alcoves.drones) alcoves.drones = {};
        if(!alcoves.drones[p.captain]) alcoves.drones[p.captain] = 0;
        alcoves.drones[p.captain] += num;
    }
}

// Which token this player sends as an [[away team]]. Drones ARE away teams (they can be
// sent as such and count as such), so a captain whose pool is drones uses drones throughout.
// Data-driven off the captain card so no captain name is hardcoded.
export function atPool(p){
    let cap = p && p.decks && p.decks.captain[0];
    if(cap && !cap.hasOwnProperty('away_teams') && cap.hasOwnProperty('drones')) return 'drones';
    return 'away_teams';
}

// A hostile effect may only remove a [[drone]] if it explicitly names one. Attack or not is
// irrelevant: naming the drone is what counts. A bare [[away team]] target excludes drones.
export function droneRemovalAllowed(params = {}){
    if(!params.obj) return false;
    if(params.obj.types && possArray(params.obj.types).includes('drone')) return true;
    if(params.obj.type && possArray(params.obj.type).includes('drone')) return true;
    if(params.obj.specific && possArray(params.obj.specific).includes('drone')) return true;
    return false;
}

// Is this removal someone reaching for another player's tokens? Two shapes:
//  - 'remove an opponent [[away team]]': p is reassigned to the owner, so actor differs
//  - 'force your opponent to remove an [[away team]]': resolves AS the owner, so actor
//    matches - but it is still an opponent's card doing it to them
// Claiming a location is neither: it returns every token regardless.
export function hostileRemoval(actor, owner, controller, params = {}){
    if(params.takingControl) return false;
    if(actor != owner) return true;
    if(params.forcedEffect && controller && controller != owner) return true;
    return false;
}

// How many of `owner`'s away teams on c this effect is actually allowed to remove.
// Drones count as away teams, but are protected from anything but a drone-targeting attack.
export function removableAway(actor, owner, c, params = {}){
    let n = myAway(owner, c);
    if(!n) return 0;
    if(atPool(owner) == 'drones' && actor != owner && !params.takingControl && !droneRemovalAllowed(params)) return 0;
    return n;
}

export function availableAT(p, c = false, type = false){
    if(!type) type = atPool(p);
    let eligible = allCards().filter(cd => cd != c && cd[type] && cd[type][p.captain] && cd[type][p.captain] > 0);
    let sum = eligible.reduce((a, c) => a + c[type][p.captain], 0);
    return sum;
}

export function hasMurf(p){
    if(!p.captain.includes('Dal') || !p.captain.includes('Gwyn')) return false; // Only D&G can use Murf
    return true;
} 

export function defpCard(p){
    let defp = allScoreableCards(p).find(c => c.name == "Orbital Defense Platforms");
    return defp;
}

export async function chooseNum(verb, type, num, available){
    if(num == 'all') return available;
    if(typeof num == 'number') return num;
    if(num == 'any' || num.max || num.min){
        let min = 0;
        if(num.min) min = num.min;
        if(available < min) throw 'uncompleted';
        let max = available;
        if(num.max && num.max < available) max = num.max;
        let options = [];
        for(let i = min; i <= max; i++){
            options.push(`${i} [[${type}]]`);
        }
        let choice = await choose(`Choose how many ${type} to ${verb}`, options);
        return options.indexOf(choice) + min;
    }
}

export async function sendMurf(p, c, alwaysCan){
    if(!hasMurf(p)){
        logText('Only Dal & Gwyn can send [[murf]]!');
        throw 'uncompleted';
    }
    if(!canBeamTo(p, c) && !alwaysCan){
        throw 'uncompleted'; // To trigger no cost things
        return false;
    }
    if(!p.decks.captain[0]) throw 'uncompleted';
    let murf = p.decks.captain[0];
    if(murf.murf){
        c.murf = true;
        delete murf.murf;
    }else{
        // It's somewhere else, so find it 
        let murfLoc = allCards().find(c => c.murf);
        if(murfLoc){
            delete murfLoc.murf;
        }else{
            console.log('NB no murf prior to this!')
        }
        c.murf = true;
    }
}

export async function returnTokensToCaptainCard(p, c, num, type){
    if(!p.decks.captain[0]) throw 'uncompleted';
    let eligible = allCards().filter(cd => (type == 'drones'|| cd != c) && cd[type] && cd[type][p.captain] && cd[type][p.captain] > 0);
    if(type == 'drones') eligible = eligible.filter(c => !ongoingEffects(c).includes('drone_alcoves')); // Can't return from alcoves
    let hrTypes = {
        away_teams: 'Away Team(s)',
        drones: 'Drone(s)',
        murf: 'Murf'
    }
    let hrType = hrTypes[type];
    let sum = eligible.reduce((a,c ) => a + c[type][p.captain], 0);
    if(eligible.length == 0 || sum < num){
        if(p.bot){
            if(sum == 0) throw 'uncompleted';
            // Otherwise send what you can
            num = sum;
        }else{
            //cancel(c, `No ${hrType} left to send`);
            logText(`No ${hrType} left to send!`);
            throw 'uncompleted';
        }
    }
    sum = num - p.decks.captain[0][type][p.captain];
    while(sum > 0){
        //eligible = eligible.sort((a,b) => countPlayerTokens(a, p) - countPlayerTokens(b, p));
        eligible = eligible.filter(cd => (type == 'drones' || cd != c) && cd[type] && cd[type][p.captain] && cd[type][p.captain] > 0);
        eligible = bestAwayRemove(eligible).filter(c => c.uniqueID != p.decks.captain[0].uniqueID);
        let card = eligible[0];
        if(!p.bot){
            card = await chooseCards(`Pick a card to remove ${hrType} from`, eligible, {cancellable: true});
            if(!card || card == 'cancelled') throw 'cancelled';
        }
        if(sum <= card[type][p.captain]){
            await removeAwayTeam(p, card, sum, type); // self-directed: recalling your own tokens to fund a send
            sum = 0;
            break;
        }else{
            let num = card[type][p.captain];
            await removeAwayTeam(p, card, num, type);
            sum -= num;
        }
        clearSelection();
    }
}

export async function awayTeam(p, c, num, alwaysCan = false, type = false){
    let hrTypes = {
        away_teams: 'Away Team(s)',
        drones: 'Drone(s)',
        murf: 'Murf'
    }
   if(!p.decks.captain[0]) throw 'uncompleted';
   if(type == 'drone') type = 'drones'
   if(!type || type == 'away' || type == 'away_teams') type = atPool(p); // drones are this player's away teams
    if(type == 'murf'){
        await sendMurf(p, c, alwaysCan);
        return;
    }
    let hrType = hrTypes[type];
    if(!num) num = 1;
    if(num == 'all') num = availableAT(p, c, type);
    if(num == 'any' || num.max || num.min){
        let min = 0;
        if(num.min) min = num.min;
        let max = availableAT(p, c, type);
        if(num.max) max = num.max;
        if(max == 0){
            logText('No Away Teams to place');
            throw 'uncompleted';
        }
        let options = [];
        for(let i = min; i <= max; i++){
            options.push(`${i} [[away team]]`);
        }
        let choice = await choose(`Choose how many ${hrType} to send`, options);
        num = options.indexOf(choice) + min;
    }
    if(isNaN(num)) num = 1;
    if(!canBeamTo(p, c) && !alwaysCan){
        throw 'uncompleted'; // To trigger no cost things
        return false;
    }
    
    let locs = get(state).commons.locations;
    let el = allCards().filter(cd => cd[type]);

    if(!p.decks.captain[0].hasOwnProperty(type)){
        logText(`Cannot send ${hrTypes[type]}!`);
        throw 'uncompleted';
    }
    if(!p.decks.captain[0][type]){
        // somehow has been set to null
        p.decks.captain[0][type] = {};
        p.decks.captain[0][type][p.captain] = 0;
    }
    
    if(ongoingEffects(c).includes('no_away')) throw 'uncompleted'; // applies to drones too: they are away teams
    if(p.decks.captain[0][type] && p.decks.captain[0][type][p.captain] < num){
       await returnTokensToCaptainCard(p, c, num, type);
    }
    p.decks.captain[0][type][p.captain] -= num;
    if(!c[type]) c[type] = {};
    if(!c[type][p.captain]) c[type][p.captain] = 0;
    c[type][p.captain] += num;
    return num;
}

export async function removeAllAway(c){
    if(!c || (!c.away_teams && !c.drones)) return;
    if(c.murf){
        let p = get(state).players.find(pl => pl.captain.includes('Gwyn'));
        if(!p){
            alert('Dal & Gwyn not in play!');
            throw 'uncompleted';
        }
        await doAction(p, 'remove_away', {obj: {num: 1}, from: [c.uniqueID], ATtype: 'murf'})
        //p.decks.captain[0].murf = true;
        //delete c.murf;
    }
    if(c.away_teams){
        for(let k of Object.keys(c.away_teams)){
            let p = get(state).players.find(p => p.captain == k);
            //await doAction(p, 'remove_away', {obj: {num: c.away_teams[k]}, from: [ c.uniqueID ], notMurf: true});
            let num = c.away_teams[k]; // NB not myAway(): that now includes drones, counted in the loop below
            await doAction(p, 'remove_away', {obj: {num: 'all', owner: 'you'}, from: [ c.uniqueID ]});
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(!s.cache.awayRemoved) s.cache.awayRemoved = 0;
                s.cache.awayRemoved += num;
                return s;
            })
        }
        // The key should be deleted as part of the above anyway
    }
    if(c.drones){
        for(let k of Object.keys(c.drones)){
            let p = get(state).players.find(p => p.captain == k);
            let num = c.drones[k];
            await doAction(p, 'remove_drones', {obj: {num}, from: [ c.uniqueID ]});
            state.update(s => {
                if(!s.cache) s.cache = {};
                // Drones are away teams, so they feed the same counter (snw_trigger reads it).
                // The old s.cache.dronesRemoved was written here and never read anywhere.
                if(!s.cache.awayRemoved) s.cache.awayRemoved = 0;
                s.cache.awayRemoved += num;
                return s;
            })
        }
        // The key should be deleted as part of the above anyway
    }
    /**/
}

export function kirkBeamedAwayTeams(p, c){
    if(p.captain == 'TosKirk' && c.beamed && c.beamed.length > 0 && get(state).cardLog[c.uniqueID].area == 'commons'){
        return c.beamed;
    }
    return [];
}

// opts.hostile: someone other than the token's owner is doing this to them.
// opts.droneTargeted: the effect is an ATTACK that explicitly named a [[drone]].
export async function removeAwayTeam(p, c, num, type = false, opts = {}){
   if(!c) throw 'uncompleted';

   p = getP(p); // stop them disappearing

   if(type == 'drone') type = 'drones';
   if(!type) type = atPool(p); // 'remove an [[away team]]' means this player's away team token

   if(type == 'drones' && opts.hostile && !opts.droneTargeted){
        // Drones are away teams, but an opponent's effect must explicitly target a [[drone]]
        logText(`[[drone]] can only be removed by an effect that explicitly targets a [[drone]]`);
        throw 'uncompleted';
   }

   if(type == 'drones'){
     // Removing BQ drones
     p = get(state).players.find(p => p.captain == 'Borg Queen');
     if(!p) throw 'uncompleted';
   }

   if(type == 'swarm'){
     // Removing Gorn swarm
     p = get(state).players.find(p => p.captain == 'Gorn');
     if(!p) throw 'uncompleted';
   }

   // Need same for platoon
    
    if(!num) num = 1;
    if(num == 'any' || num.max || num.min){
        let min = 0;
        if(num.min) min = num.min;
        let max = 0;
        if(c[type] && c[type][p.captain]) max = c[type][p.captain];
        if(num.max) max = Math.min(max, num.max);
        if(max == 0){
            logText('No Away Teams to remove');
            throw 'uncompleted';
        }
        let options = [];
        for(let i = min; i <= max; i++){
            options.push(`${i} [[away team]]`);
        }
        let choice = await choose(`Choose how many [[away team]] to remove`, options);
        num = options.indexOf(choice) + min;
    }
    if(c && type == 'murf' && hasMurf(p)){
        //let murfP = get(state).players.find(p => hasMurf(p));
        if(p.decks.captain[0]) p.decks.captain[0].murf = true;
        delete c.murf;
        state.update(s => {
            if(!s.cache) s.cache = {};
            if(!s.cache.awayRemovedDetails) s.cache.awayRemovedDetails = [];
            s.cache.awayRemovedDetails.push({
                type: 'away_teams',
                card: c.uniqueID,
                owner: getPlayerIndex(p),
                num: 1
            })
            return s;
        })
        return 1;
    }
    if(num == 'all'){
        num = 0;
        if(c[type] && c[type][p.captain]) num = c[type][p.captain];
        num += kirkBeamedAwayTeams(p, c).length;
    }
    let maxPossible = (c[type] && c[type][p.captain] ? c[type][p.captain] : 0) + kirkBeamedAwayTeams(p, c).length;

    if(isNaN(num)) num = 1;
    if(maxPossible == 0) throw 'uncompleted';
    if(maxPossible < num) num = maxPossible;

    let numStillToRemove = num;

    if(kirkBeamedAwayTeams(p, c).length > 0){
        let cardsToDismiss = [];
        if(maxPossible == num){
            // No choice, so just remove all beamed cards
            cardsToDismiss = c.beamed;
        }else{
            // You can elect to remove fewer beamed cards
            let number = {
                min: num,
                max: c.beamed.length
            }
            if(c[type] && c[type][p.captain]) number.min = Math.max(0, num - c[type][p.captain]);
            let extra = `select ${number.min}`;
            if(number.min != num) extra = `select between ${number.min} and ${number.max}`
            cardsToDismiss = await chooseCards(`TosKirk: ${extra} beamed card(s) to discard from [[location]]`, c.beamed, {number, lookSpecific: true})
        }
        numStillToRemove -= cardsToDismiss.length;
        for(let b of cardsToDismiss){
            await doAction(p, 'dismiss', {obj: b.uniqueID});
        }
    }

    if((!get(state).practice || getPlayerIndex(p) == 0) && p.decks.captain[0] && c.uniqueID != p.decks.captain[0].uniqueID){
        // If you're removing from captain it's just going
        p.decks.captain[0][type][p.captain] += numStillToRemove;
    }
    
    if(c[type] && c[type][p.captain]) c[type][p.captain] -= numStillToRemove;
    state.update(s => {
        if(!s.cache) s.cache = {};
        if(!s.cache.awayRemovedDetails) s.cache.awayRemovedDetails = [];
        s.cache.awayRemovedDetails.push({
            type,
            card: c.uniqueID,
            owner: getPlayerIndex(p),
            num
        })
        return s;
    })
    if(c[type] && c[type][p.captain] == 0 && !(p.decks.captain[0] && p.decks.captain[0].uniqueID == c.uniqueID)) delete c[type][p.captain];
    if(c[type] == {}) delete c[type];
    return num;
}

export async function orbit(p, c, ship, to, behaviour = false, params){
    let eligibleCards = [...getNeutralZone(), ...p.decks.locations, ...p.decks.missions, ...p.decks.fleet.filter(c => ongoingEffects(c).includes('can_warp_here'))];
    if(params.including_to_opp_loc) eligibleCards = [...eligibleCards, ...otherPlayer(p).decks.locations];
    if(to) eligibleCards = to.map(c => getCard(c));
    //let verb = 'warp to'; //'put ship in orbit around';
    //if(c.orbitingCard && c.orbitingCard[ship]) verb = 'warp ship to'
    let toCard;
    let oc;
    if(c.orbitingCard && c.orbitingCard[ship]) oc = getCard(c.orbitingCard[ship]);
    if(oc) eligibleCards = eligibleCards.filter(e => e.uniqueID != oc.uniqueID); // You can't stay in the same place
    let allRestrictions = get(state).players.flatMap(p => ongoingPlayer(p, 'only_types_warp_ship_location'));
    let excluded = [];
    if(allRestrictions.some(r => !matches(c, r))){
        outer: for(let l of eligibleCards){
            let ships = shipsAtLocation(l);
            for(let s of ships){
                let ot = ongoingEffects(s, 'only_types_warp_ship_location');
                if(ot.length > 0){
                    ot = ot[0];
                    if(!matches(c, ot)){
                        excluded.push(l);
                        break outer;
                    }
                }
            }
        }
        eligibleCards = eligibleCards.filter(l => excluded.some(e => e.uniqueID != l.uniqueID));
    }
    if(params.to){
        if(Array.isArray(params.to)){
            if(params.to.length == 1){
                toCard = getCard(params.to[0]);
            }else{
                eligibleCards = params.to.map(c => getCard(c));
            }
        }else{
            toCard = getCard(params.to); // hopefully won't break!
        }
    }
    if(p.bot){
        eligibleCards = [...getNeutralZone()];
        if(!toCard){
            toCard = bestShipDestinations(eligibleCards, c, behaviour);
            if(toCard && toCard.length > 0) toCard = toCard[0];
        }
    }else{
        if(!toCard) toCard = await chooseCards(`Choose where you want to warp [[${ship}]] to`, eligibleCards, {cancellable: true});
        if(toCard == 'cancelled') throw 'cancelled';
    }
    if(!toCard) return false;
    if(excluded.some(e => toCard.uniqueID == e.uniqueID)){
        logText('Unable to warp to this location!');
        throw 'uncompleted';
    }
    if(oc){
        oc.orbiting = oc.orbiting.filter(s => !(s.ship == ship && s.card == c.uniqueID)); // names aren't unique: copies of a ship card share one
        if(oc.orbiting.length == 0) delete oc.orbiting;
    }
    if(!toCard.orbiting) toCard.orbiting = [];
    if(!c.orbitingCard) c.orbitingCard = {};
    c.orbitingCard[ship] = toCard.uniqueID;
    toCard.orbiting = [...toCard.orbiting, {ship, card: c.uniqueID, sourcePlayer: getPlayerIndex(cardOwner(c))}];
    return toCard.uniqueID;
}

export async function warp(p, c, ship, params){
    let eligibleCards = [...getNeutralZone(), ...p.decks.locations, ...p.decks.missions, ...p.decks.fleet.filter(c => ongoingEffects(c).includes('can_warp_here'))];
    if(params.including_to_opp_loc) eligibleCards = [...eligibleCards, ...otherPlayer(p).decks.locations];
    let allRestrictions = get(state).players.flatMap(p => ongoingPlayer(p, 'only_types_warp_ship_location'));
    if(allRestrictions.some(r => !matches(c, r))){
        let excluded = [];
        outer: for(let l of eligibleCards){
            let ships = shipsAtLocation(l);
            for(let s of ships){
                let ot = ongoingEffects(s, 'only_types_warp_ship_location');
                if(ot.length > 0){
                    ot = ot[0];
                    if(!matches(c, ot)){
                        excluded.push(l);
                        break outer;
                    }
                }
            }
        }
        eligibleCards = eligibleCards.filter(l => excluded.some(e => e.uniqueID != l.uniqueID));
    }
    let toCard = await chooseCards(`Choose a location to warp to`, eligibleCards, {cancellable: true, optional: params.optional || false});
    if(!toCard) return false;
    if(toCard == 'cancelled') throw 'cancelled';
    let entry = orbitingEntry(c, ship, p);
    let shipCard = getCard(entry.card);
    if(!shipCard.orbitingCard) shipCard.orbitingCard = {};
    shipCard.orbitingCard[ship] = toCard.uniqueID;
    c.orbiting = c.orbiting.filter(s => s !== entry);
    if(c.orbiting.length == 0) delete c.orbiting;
    if(!toCard.orbiting) toCard.orbiting = [];
    toCard.orbiting = [...toCard.orbiting, entry];
    return toCard.uniqueID;
}

export function setDefault(params){
    if(!params.obj && !params.auto) params.obj = params.card;
    if(!params.obj) throw 'uncompleted';
}

let visibleTypes = ['play', 'freeplay', 'activate', 'play_activate', 'refresh', 'dismiss', 'discard', 'exhaust', 'beam', 'deploy', 'duty', 'gain_control', 'take_control', 'reveal'];

export function setHidden(verb, params, keys = ['obj', 'result']){
    if(!params.hasOwnProperty('hidden')) params.hidden = {};
    for(let k of keys){
        for(let c of possArray(params[k])){
            if(!c) continue;
            let id = false;
            if(typeof c == 'number'){
                id = c;
            }else if(c.uniqueID){
                id = c.uniqueID;
            }
            if(id){
                let fd = isFacedown(getCard(id));
                if(visibleTypes.includes(verb)) fd = false;
                if(params.hidden.hasOwnProperty(id)){
                    // If it's ever face-up, then set it to faceup
                    params.hidden[id] = params.hidden[id] && fd;
                }else{
                    params.hidden[id] = fd;
                }
                //params.hidden[id] = 
            }
        }
    }
}

function checkFrom(place, params){
    if(!params.auto) return;
    if(!params.obj) throw 'uncompleted';
    let c = getCard(params.obj);
    if(!c) throw 'uncompleted';
    if(params.from) return true;
    let info = getLocation(c);
    if(!info) throw 'uncompleted';
    if(info.area == place) return true;
    /*if(!Array.isArray(place)) place = [place];
    for(let pl of place){
        card{}
        //if(p.decks[pl].some(card => card.uniqueID == c.uniqueID)) return true;
    }*/
    // Card is not in the place it needs to be, so action can't be finished
    throw 'uncompleted'
}

// Ship names come from the card name, so two copies of a ship card (one per player, say) can
// orbit the same place under one name: prefer p's own if there's a choice.
export function orbitingEntry(c, ship, p = false){
    let entries = c.orbiting.filter(o => o.ship == ship);
    return (p && entries.find(o => o.sourcePlayer == getPlayerIndex(p))) || entries[0];
}

export async function dismissShip(p, c, ship){
    let entry = orbitingEntry(c, ship, p);
    let shipCard = getCard(entry.card);
    if(shipCard.orbitingCard) delete shipCard.orbitingCard[ship];
    if(shipCard.orbitingCard == {}) delete shipCard.orbitingCard;
    c.orbiting = c.orbiting.filter(s => s !== entry);
    if(c.orbiting.length == 0) delete c.orbiting;
    await dismissCard(p, shipCard);
    //await moveTo(shipCard, `players.discard.${getPlayerIndex(p)}`);
}

export function getLocation(c){
    return get(state).cardLog[c.uniqueID];
}

export function cardResourceTypes(){
    let t = ['glory'];
    for(let p of get(state).players){
        if(p.captain == 'Burnham' && !t.includes('dilithium')) t.push('dilithium');
    }
    return t;
}

function hasTokens(c){
    let has = false;
    for(let r of allTokenTypes()){//cardResourceTypes()){//get(res).cardResourceTypes){
        if(c[r]) has = true;
    }
    if(countAllTokens(c)) return true;
    return has;
}

export function canJunk(c){
    // Note can check hasTokens or similar here if that rule changes
    if(hasTokens(c)) return false;
    return true;
}

export function getCardIndex(c){
    if(!c) return 0;
    let info = get(state).cardLog[c.uniqueID];
    let deck;
    let s = get(state);
    if(info.area == 'commons'){
        deck = s.commons[info.deck];
    }else if(info.area == 'players'){
        deck = s.players[info.player].decks[info.deck];
    }else if(info.area == 'beamed'){
        deck = getCard(parseInt(info.deck)).beamed;
    }else if(info.area == 'player_dashboards'){
        deck = s.players[info.player].dashboard.missions;
    }
    return deck.findIndex(cd => cd == c);
}

export function isLastCardOfDeck(c){
    if(!c) return true;
    let info = get(state).cardLog[c.uniqueID];
    let deck;
    let s = get(state);
    if(info.area == 'commons'){
        deck = s.commons[info.deck];
    }else if(info.area == 'players'){
        deck = s.players[info.player].decks[info.deck];
    }else if(info.area == 'beamed'){
        deck = getCard(parseInt(info.deck)).beamed;
    }else if(info.area == 'player_dashboards'){
        deck = s.players[info.player].dashboard.missions;
    }
    let index = deck.findIndex(cd => cd == c);
    if(index == deck.length - 1) return true;
    return false;
}


export async function completeMission(c){
    //cardOnStack(c);
    //await info(`Complete the reward action: ${c.reward}`);
    //console.log(c);
    // TODO replace once sorted!!
    let p = cardOwner(c); 

    if(c.status.numMet){
        // cache everything having been met
        state.update(s => {
            s.numMissionElementsMet = c.status.numMet;
            return s;
        })
    }
    
    //await info('Complete the mission reward and then press OK');
    if(!get(prefs).inPlayNotBeam){
        // Dismiss contributing cards
        let allEligible = []; 
        // !! TODO may need to make this handle otherLocs too?
        let otherShips = Array.from(new Set(trawlFor(trawlFor(c.status, 'otherShips').flat(2), 'ship').flat(2)));
        let ships = Array.from(new Set(trawlFor(c.status, 'ship', true).flat(2)));
        let test = trawlFor(c.status, 'ship', true);
        console.log(test, ships, otherShips, c.status)
        ships = Array.from(new Set([...otherShips, ...ships])).filter(s => typeof s == 'number'); // oops, don't count ship tokens from cards...!
        let chosenShip = getCard(ships[0]);
        if(ships.length > 1){
            chosenShip = await chooseCards(`Several possible matches for mission – choose the ship you want to count`, ships.map(c => getCard(c)));
        }
        // !! TODO below only works where there is a single ship involved!!
        if(c.status.elements && c.status.elements.some(e => e.ship && e.ship != chosenShip.uniqueID && e.otherShips)){
            let other = c.status.elements.find(e => e.ship && e.ship != chosenShip.uniqueID && e.otherShips);
            c.status.elements = other.otherShips.find(s => s.flat(2).some(h => h.ship == chosenShip.uniqueID));
        }


        for(let e of c.status.elements){
            /*if(e.ship && e.ship != chosenShip.uniqueID && e.otherShips){
                e = e.otherShips.find(s => s.flat(2).some(h => h.ship == chosenShip.uniqueID));
            }*/
            if(e.eligibleTypes){
                // Looking for specific number of types
                let eligible = Array.from(new Set(e.eligible)).map(c => getCard(c));
                if(e.eligibleTypes.length > e.target){
                    eligible = await chooseCards(`Pick cards to count for your ${e.text} goal:`, eligible, {
                        number: 'any',
                        cancellable: true,
                        lookSpecific: true,
                        specialCondition: (ui, state) => {
                            let selected = ui.multiSelection;
                            let count = countMatches(p, selected, e.lookingFor || 'different-species' || 'different species', {}, [], [], e.each_diff || []);
                            if(count >= e.target) return true;
                            return false;
                        }
                    })
                    if(!eligible || eligible == 'cancelled') throw 'cancelled';
                }
                allEligible = [...allEligible, ...eligible];
            }else if(e.differentTraits){
                let eligible = Array.from(new Set(e.eligible)).map(c => getCard(c));
                if(eligible.reduce((a,c) => a + countableTraits(c.traits).length, 0) > e.target){
                    eligible = await chooseCards(`Pick cards to count for your ${e.text} goal:`, eligible, {
                        number: 'any',
                        cancellable: true,
                        lookSpecific: true,
                        specialCondition: (ui, state) => {
                            let selected = ui.multiSelection;
                            let wildcards = selected.reduce((a,c) => a + c.traits.filter(t => t == 'wildcard').length, 0);
                            let count = Array.from(new Set(selected.flatMap(c => countableTraits(c.traits)).filter(t => t != 'wildcard'))).length;
                            count += wildcards;
                            if(count >= e.target) return true;
                            return false;
                        }
                    })
                    if(!eligible || eligible == 'cancelled') throw 'cancelled';
                }
                allEligible = [...allEligible, ...eligible];
            }else if(e.eligible){
                let eligible = Array.from(new Set(e.eligible)).map(c => getCard(c));
                if(e.eligible.length > e.target){
                    //if(e.eligible.filter(c => !c.traits.some(t => t == 'wildcard')))
                    eligible = await chooseCards(`Pick ${e.target} cards to count for your ${e.text} goal:`, eligible, {cancellable: true, number: e.target, lookSpecific: true});
                    if(!eligible || eligible == 'cancelled') throw 'cancelled';
                }
                allEligible = [...allEligible, ...eligible];
            }
            if(e.loc && !allEligible.some(c => c.uniqueID == e.loc)){
                allEligible = [...allEligible, getCard(e.loc)];
            }
            if(e.ship && !allEligible.some(c => c.uniqueID == e.ship)){
                allEligible = [...allEligible, getCard(e.ship)];
            }
        }
        state.update(s => {
            s.missionContributors = allEligible.map(c => c.uniqueID);
            return s;
        })
        let reward = getHints(c, 'reward');
        c.rewarding = true;
        if(reward) await autoCardActions(c, reward);
        let mission = c;
        for(let c of allEligible){
            let info = get(state).cardLog[c.uniqueID];
            if(info.area == 'beamed'){
                let host = getCard(parseInt(info.deck));
                // 1 April 2025: Probably redundant now that it's in the dismiss action,
                // but leave here anyway for now because why not
                if(!ongoingEffects(host).includes('no_mission_dismissal') && !ongoingEffects(mission).includes('no_mission_completion_dismiss')) await doAction(get(state).players[get(state).activePlayer], 'dismiss', {obj: c.uniqueID});
            }
        }
        state.update(s => {
            delete s.missionContributors;
            delete s.numMissionElementsMet;
            return s;
        })
        // NB above can be commented out if dismissal will now be explicit
    }else if(c.orbiting && c.orbiting.length > 0){
        await autoCardActions(c, getHints(c, 'reward'));
        for(let s of c.orbiting){
            //console.log(get(state).players[get(state).activePlayer])
            if(get(prefs).completeDismissesShips && !ongoingEffects(c).includes('no_mission_completion_dismiss')){
                //await doAction(get(state).players[get(state).activePlayer], 'dismiss_ship', {card: c.uniqueID, ship: s.ship});
                await doAction(get(state).players[get(state).activePlayer], 'dismiss', {obj: s.card});
            }else{
                let shipCard = getCard(s.card);
                await removeBeamed(shipCard);
            }
        }
    }
    //cardOffStack(c);
    // Now mark the mission complete and log the mission if it's done and not a dashboard mission
    c.complete = true;
    if(!c.dashMission){
        //await moveTo(c, `players.completed_missions.${getPlayerIndex(cardOwner(c))}`);
        let p = get(state).players[get(state).activePlayer];
        if(p.captain == 'Borg Queen'){
            await doAction(p, 'assimilate', {obj: c.uniqueID});
        }else{
            await doAction(p, 'log', {obj: c.uniqueID});
        }
       
    }
}

function cardOnStack(card){
    state.update(s => {
        s.cardStack = [card.uniqueID, ...s.cardStack];
        console.log(`Card stack: ${s.cardStack.length}`)
        return s;
    })
}

function cardOffStack(card){
    state.update(s => {
        s.cardStack = s.cardStack.filter(c => c != card.uniqueID); // TODO should this just be pop?
        console.log(`Card stack: ${s.cardStack.length}`)
        return s;
    })
}

export function stackIncludes(card){
    return get(state).cardStack.some(c => c == card.uniqueID);
}

export function stackLength(){
    return get(state).cardStack.length || 0;
}

export async function shiftLeft(c){
    let key;
    let info = get(state).cardLog[c.uniqueID];
    let deck;
    let s = get(state);
    if(info.area == 'commons'){
        key = `commons.${info.deck}`;
        deck = s.commons[info.deck];
    }else if(info.area == 'players'){
        key = `players.${info.deck}.${info.player}`;
        deck = s.players[info.player].decks[info.deck];
    }else if(info.area == 'beamed'){
        key = `beamed.${info.deck}`
        deck = getCard(parseInt(info.deck)).beamed;
    }
    let index = deck.findIndex(cd => cd == c);
    if(index == -1) return false;
    if(index == 0) return false;
    await moveTo(c, key, index - 1);
}

export async function shiftRight(c){
    let key;
    let info = get(state).cardLog[c.uniqueID];
    let deck;
    let s = get(state);
    if(info.area == 'commons'){
        key = `commons.${info.deck}`;
        deck = s.commons[info.deck];
    }else if(info.area == 'players'){
        key = `players.${info.deck}.${info.player}`;
        deck = s.players[info.player].decks[info.deck];
    }else if(info.area == 'beamed'){
        key = `beamed.${info.deck}`
        deck = getCard(parseInt(info.deck)).beamed;
    }
    let index = deck.findIndex(cd => cd == c);
    if(index == deck.length - 1) return false;
    if(index == -1) return false;
    await moveTo(c, key, index + 1);
}


async function tokenOnCard(c, token, amount, from = 'supply'){
    if(!isInPlay(c) && !getMarketCards().some(cd => cd.uniqueID == c.uniqueID) && !get(state).commons.neutral_zone.some(cd => cd.uniqueID == c.uniqueID)){
        logText(`Can't put [[${token}]] on ${cc(c.uniqueID)} because it's not in play`)
    }
    if(c.dashboardPassive) c = cardOwner(c).dashboard.passives[0];
    if(!c) return;
    if(!c[token]) c[token] = 0;
    c[token] += amount;
    if(from != 'supply'){
        // From a player
        from[token] -= amount;
    }else{
        if(token == 'glory'){
            await takeFromGloryPile(amount);
        }
    }
}

export function beamedHost(c) {
    let info = get(state).cardLog[c.uniqueID];
    if(!info || info.area != 'beamed') return false;
    return getCard(parseInt(info.deck));
}

export function lookAtCards(cards, canHide = false){
    if(cards.length == 0) return false;
    let c = cards[0];
    let info = get(state).cardLog[c.uniqueID];
    let l = {
        ...info,
        exactDeck: cards,
        canShuffle: false,
        component: null,
        canHide
    };

    clearSelection();
    ui.update(ui => {
        ui.looking = [...ui.looking, l];
        return ui;
    })
    return l;
}

export function look(c, cards = false, canHide = true, canReorder = false){
    let info = get(state).cardLog[c.uniqueID];
    //if(info.deck == 'neutral_zone') info.deck = 'locations';
    let l = {
        ...info,
        cards,
        component: null,
        canShuffle: true, // TODO make more granular
        canHide,
        canReorder
    }
    if(l.deck == 'neutral_zone') l.deck = 'locations';
   /* if(l.deck == 'encounters') l.canReorder = true;
    if(l.deck == 'locations') l.canReorder = true;
    if(l.deck == 'reserve') l.canReorder = true;*/

    if(get(ui).looking.some(l => (l.info && (l.info.area == info.area && l.info.deck == info.deck && l.info.player == info.player)) && (l.cards == cards || l.cards && l.cards.every(c => cards.some(cd => cd.uniqueID == c.uniqueID))))) return false; // Don't double up

    clearSelection();
    
    ui.update(ui => {
        ui.looking = [...ui.looking, l];
        return ui;
    })
    return l;
}

export async function duty(p, cards){
    let alreadyThere = p.decks.duty.length;
    if(alreadyThere && p.bot){
        for(let c of p.decks.duty){
            await doAction(p, 'dismiss', {obj: c.uniqueID});
        }
        alreadyThere = false;
    }
    for(let card of cards){
        if(p.bot && p.decks && p.decks.log && p.decks.log.some(c => c.uniqueID == card.uniqueID)) throw 'uncompleted'; // Cannot promote a card from log to DO
        await moveTo(card, `players.duty.${getPlayerIndex(p)}`);
    }
    if(alreadyThere) await rationaliseDuty(p, []); // No longer lists cards because they are also dismissable
}

export async function rationaliseDuty(p, cards = []){
    // Reorder to handle optional later if you want
    while(p.decks.duty.length > howManyOnDuty(p)){ // For e.g. Ambassador Sarek{
        let toDismiss = p.decks.duty.filter(c => !cards.some(cd => c.uniqueID == cd.uniqueID));
        let optional;
        let num = 1;
        if(howManyOnDuty(p) >= p.decks.duty.length){
            optional = true;
        }else{
            num = p.decks.duty.length - howManyOnDuty(p);
        }

        if(optional) break; // Not optional...
        // !!! NB if it does become optional in the future, handle this with ongoingChange
        
        let dismiss;
        if(get(prefs).autoChoose && !optional && toDismiss.length == num){
            dismiss = toDismiss;
        }else{
            dismiss = await chooseCards(`${optional ? 'You may c' : 'C'}hoose ${num == 1 ? 'a' : num} Duty Officer${num > 1 ? 's' : ''} to dismiss`, toDismiss, {optional, number: num});
            if(!dismiss || dismiss == 'cancelled') throw 'cancelled';
        }
        for(let c of dismiss){
            await doAction(p, 'dismiss', {card: c.uniqueID});
        }
    }
}

export function inPlay(c){
    let location = getLocation(c);
    if(!location) return false;
    if(location.area == 'players' && inPlayLocations.includes(location.deck)) return true;
    if(!get(prefs).inPlayNotBeam && location.area == 'beamed'){
        // ...but only for player areas (i.e. not NZ)
        let bc = getCard(location.deck);
        if(!bc) return false;
        let loc = getLocation(bc);
        if(!loc || loc.area != 'players') return false;
        return true;
    }
    return false;
}

export function tableEffectsActive(c){
    if(c?.facedown) return false;
    let location = getLocation(c);
    if(!location) return false;
    if(location.area == 'beamed') return false;
    // 'staging_duty': [[person]] in the Staging Area are on duty, so their table
    // effects (passives, reactions, exhaust/refresh) are live
    if(location.deck == 'play') return matches(c, 'person') && hasStagingDuty(cardOwner(c));
    if(location.deck == 'passives') return true; // mission passives
    if(location.area == 'players' && inPlayLocations.includes(location.deck)) return true;
    if(isBadlands(c)) return true;
    if(location.area == 'commons' && location.deck == 'neutral_zone' && !canGainControl(c)) return true;
    return false;
}

export function inHand(c){
    let location = getLocation(c);
    if(!location) return false;
    if(location.area == 'players' && location.deck == 'hand') return true;
    return false;
}

export function canActivate(c, p = false){
    if(!c) return false;
    if(!isInPlay(c)) return false;
    if(p && p.activations == 0) return false;
    if(get(state).cardLog[c.uniqueID].deck == 'play'){
        let can = false;
        if(p && ongoingPlayer(p).includes('staging_duty') && matches(c, 'person')) can = true;
        if(!can){
            if(!p || !ongoingPlayer(p).includes('staging_activation') || !matches(c, ongoingPlayer(p, 'staging_activation_types'))) return false;
        }
    }else if(matches(c, 'person') && getLocation(c).deck != 'duty') return false;
    if(c.activated) return false;
    let activateEffects = getCardEffect(c, 'activation');
    if(activateEffects.length == 0) return false;
    if(p && activateEffects.every(e => e.actionCost) && p.actions == 0 && (!p.whim || !ongoingPlayer(p).includes('whim_action'))) return false;  // i.e. can't do costly ones
    if(p && activateEffects.every(e => e.droneCost && e.droneCost > numExpendableDrones(p))) return false;
    //if(costEffects == 0 && p.actions <= 0) return false; // i.e. can't do costly ones
    return true;
}

export function canPlay(p, c){
    //if(ongoingEffects(c, 'play_limit').some(l => l.type == 'unplayable')) return false;
    //if(ongoingEffects(c, 'play_limit').some(l => l.type == 'needs_ownership')) return checkOwnership(p, c, ongoingEffects(c, 'play_limit').find(l => l.type == 'needs_ownership'));
    if(isFreePlay(c)) return 'free';
    let possible = get(res).parsedCardText[c.id];
    if(!possible) return false;
    if(possible) possible = possible.effects;
    if(!possible) return true;
    for(let e of possible){
        if(e.type == 'action'){
            if(e.actionCost && (p.actions + (ongoingPlayer(p).includes('whim_action') && p.whim ? p.whim : 0)) < e.actionCost) continue;
            if(e.droneCost && numExpendableDrones(p) < e.droneCost) continue;
            return true;
        }
    }
    return false;
}

export function isFreePlay(c){
    //let hints = getHints(c, 'freeplay', false);
    //return hints && hints.length > 0;
    let possible = get(res).parsedCardText[c.id];
    if(possible) possible = possible.effects;
    if(!possible) return false;
    let hints = hintNames(c, 'freeplay', 'Play', possible.filter(p => p.name == 'free action'));
    if(hints && hints.length > 0) return true;
    //return c.playText && c.playText.split('[[action]] Play')
}

export async function takeFromGloryPile(amount){
    if(get(state).practice && get(state).step != 'glory') return; // In practice mode only the EOT glory comes from stardate
    state.update(s => {
        if(s.glory >= amount){
            s.glory -= amount;
            s.gloryTaken += amount;
        }else{
            s.gloryTaken += s.glory;
            s.glory == 0;
        }
        if(s.glory == 0 /* && !get(prefs).stardates*/) endGame('Resolution');
        return s;
    })
    await giveStardateCards();
}

export function sdCards(){
    if(get(state).stardateCards) return get(state).stardateCards;
    return get(res).stardateCards
}

export function stardateGlory(){
    if(sdCards()[get(state).stardatePlayed]) return sdCards()[get(state).stardatePlayed].glory;
    return Infinity;
}

function currentStardate(){
    if(sdCards()[get(state).stardatePlayed]) return sdCards()[get(state).stardatePlayed];
    return false;
}

// The manual Stardate editor: nudge the glory left on the current card, or toggle the game-end
// trigger once the pile is empty. Opened by clicking the Stardate glory readout on the status
// bar; it lives here rather than in STGame so that readout isn't the only possible caller.
export async function editStardate(){
    let sc = currentStardate();
    if(sc){
        let choice = await choose(`${stardateGlory() - get(state).gloryTaken} [[glory]] left on card. Next event is '${sc.eventText}'.`,
        ['-5 [[glory]]', '-1 [[glory]]', '+1 [[glory]]', '+5 [[glory]]', 'OK'])
        if(choice == '+1 [[glory]]'){
            sc.glory++;
        }else if(choice == '+5 [[glory]]'){
            sc.glory += 5;
        }else if(choice == '-1 [[glory]]'){
            sc.glory --;
            if(sc.glory < 0) sc.glory = 0;
        }else if(choice == '-5 [[glory]]'){
            sc.glory -= 5;
            if(sc.glory < 0) sc.glory = 0;
        }
        state.update(s => s); // the card was mutated in place, so poke the store to redraw
    }else if(get(state).gameEndTurn != -1){
        let choice = await choose(`No Stardate cards left. Untrigger game end? (You will have to trigger manually by clicking here again)`, ['Yes', 'No']);
        if(choice == 'Yes'){
            state.update(s => { s.gameEndTurn = -1; return s; });
        }
    }else{
        let choice = await choose(`No Stardate cards left. Trigger game end?`, ['Yes', 'No']);
        if(choice == 'Yes'){
            state.update(s => { s.gameEndTurn = s.turn + 1; return s; });
        }
    }
}

// Junks the top hidden card: with separate decks [0] is the face-up Market card, so skip it.
// A distinct deck is used at most once even after junking exposes its next card.
export async function junkTopOfDistinctMarketDecks(p, num){
    let max = typeof num == 'number' ? num : num.max;
    let decks = get(prefs).separateMarkets ? ['people', 'cargo', 'ships', 'allies'] : ['market'];
    let idx = get(prefs).separateMarkets ? 1 : 0;
    let removed = [];
    for(let i = 0; i < max; i++){
        let available = decks.filter(d => get(state).commons[d]?.[idx]);
        if(!available.length) break;
        let deck;
        if(p.bot){
            let card = botFavouriteCards(p, available.map(d => get(state).commons[d][idx]))[0];
            deck = available.find(d => get(state).commons[d][idx] == card);
        }else{
            let labels = available.map(d => d == 'market' ? 'Market deck' : `${d[0].toUpperCase()+d.slice(1)} Market deck`);
            let choice = await choose('Choose a different Market deck to junk its top card:', [...labels, 'Finish'], {cancellable: true});
            if(!choice || choice == 'cancelled') throw 'cancelled';
            if(choice == 'Finish') break;
            deck = available[labels.indexOf(choice)];
        }
        if(!deck) throw 'uncompleted';
        decks = decks.filter(d => d != deck);
        let c = get(state).commons[deck][idx];
        await doAction(p, 'junk', {obj: c.uniqueID});
        removed.push(c.uniqueID);
    }
    return removed;
}

// Junk/destroy off the top of each Market deck: used by box-count setup and Stardate cards.
export async function removeTopOfEachMarketDeck(p, verb, num){
    // With a combined market the single deck stands in for all four, so it loses four times as much
    let decks = get(prefs).separateMarkets ? ['people', 'cargo', 'ships', 'allies'] : ['market'];
    let per = get(prefs).separateMarkets ? 1 : 4;
    // Separate Market decks keep their face-up card at index 0, with the deck itself from index 1
    let top = get(prefs).separateMarkets ? 1 : 0;
    let removed = [];
    for(let d of decks){
        for(let i = 0; i < num * per; i++){
            let c = get(state).commons[d][top];
            if(!c) break;
            removed.push(c.uniqueID);
            await doAction(p, verb, {obj: c.uniqueID});
        }
    }
    return removed;
}

// Stardate cards aren't cards in this app: no uniqueID, no cardLog entry, no image, and the UI
// shows them as a glory countdown plus a '!' per held card. Their text is still parsed like a
// card's, though – the loader gives each row an id and registers it in res.parsedCardText – so
// this pseudo-card is enough for getCardEffect and resolveEffects to work on them.
function stardatePseudo(sd){
    return {id: sd.id, name: `Stardate ${sd.ref}`, isStardate: true};
}

// false (not []) when the row has no usable parse, so callers know to fall back to the old enum
function stardateEffects(sd, phase){
    if(!sd || !sd.id) return false;
    let pct = get(res).parsedCardText[sd.id];
    if(!pct || pct.response == 'error' || !pct.effects) return false;
    if(!pct.effects.some(e => e.type == 'emptied' || e.type == 'resolution')) return false; // text predates the section headers
    return pct.effects.filter(e => e.type == phase);
}

// Tiny label for the status bar: the full text is far too long to sit there, and clicking it
// shows the whole card anyway. Derived from the parsed effects so it can't drift from what the
// card does.
const stardateLabels = {
    wipe_market: e => e.all ? 'Wipe market + locations' : 'Wipe market',
    end_game: e => 'Trigger game end',
    clear_badlands: e => 'clear Badlands',
    junk_top_each: e => `junk ${e.num > 1 ? `${e.num} ` : ''}`,
    destroy_top_each: e => `destroy ${e.num > 1 ? `${e.num} ` : ''}`
};

export function stardateSummary(sd){
    if(!sd) return false;
    let effects = [...(stardateEffects(sd, 'emptied') || []), ...(stardateEffects(sd, 'resolution') || [])];
    if(effects.length > 0){
        let bits = effects.flatMap(e => e.effect).flat(3).filter(e => e && stardateLabels[e.verb]).map(e => stardateLabels[e.verb](e));
        if(bits.length > 0) return bits.join(' + ');
        return 'No event';
    }
    // Legacy rows, still on the sniffed event enum
    if(sd.event == 'wipe_market') return 'Wipe market';
    if(sd.event == 'wipe_all') return 'Wipe market + locations';
    if(sd.event == 'end_game') return 'Trigger game end';
    if(sd.event == 'end_game_badlands') return 'Trigger game end + clear Badlands';
    return 'No event';
}

let resolvingStardate = false; // so the defer_stardate action knows which card it is moving

// Hand the card to a player's Staging Area. 'you' is the player resolving it (which is what the
// practice-mode cards say), 'inactive' the other one.
function deferStardate(sd, owner, p){
    let from = getPlayerIndex(p);
    if(from == -1) from = get(state).currentPlayer;
    state.update(s => {
        let i = from;
        if(owner != 'you'){
            i = from + 1;
            if(i > s.players.length - 1) i = 0;
        }
        s.players[i].stardateCards.push(sd);
        logText(`Stardate card passed to ${s.players[i].captain}`);
        return s;
    })
}

async function clearBadlands(){
    let b = badlands();
    if(!b) return;
    logText(`Dismissing all [[ship]] and removing all [[away team]] from *The Badlands*`);
    await removeOrbiting(b);
    await removeAllAway(b);
}

// Rows loaded from a sheet cached before Stardate text carried its section headers: behave as
// the old sniffed event enum did. Delete once no cached sheet can predate the change.
async function legacyStardateEvent(sd, phase, p){
    if(!sd.event) return;
    if(phase == 'emptied'){
        if(sd.event.includes('end_game')){
            logText(`Final Stardate card reached: game end triggered`);
            endGame('Resolution');
        }
        if(sd.event == 'end_game_badlands') await clearBadlands();
        return;
    }
    if(sd.event.includes('wipe')){
        await wipeMarket(p, sd.event == 'wipe_all');
    }else if(sd.event.includes('end_game')){
        endGame('Resolution');
    }
}

// phase is 'emptied' (resolved by whoever emptied the glory pile) or 'resolution' (resolved by
// whoever is holding the card). p is that player: activePlayer is pointed at them for the
// duration so any choice, log line or 'you' in the text belongs to the right person.
async function resolveStardate(sd, phase, p){
    if(!sd) return;
    let effects = stardateEffects(sd, phase);
    if(effects === false) return await legacyStardateEvent(sd, phase, p);
    if(effects.length == 0) return;
    logText(`Stardate ${sd.ref}: ${effects.map(e => (e.text || '').replaceAll('^', '')).join(' ')}`);
    let saved = get(state).activePlayer;
    let index = getPlayerIndex(p);
    resolvingStardate = sd;
    try{
        if(index != -1){
            state.update(s => {
                s.activePlayer = index;
                return s;
            })
        }
        for(let e of effects){
            // A stardate is its own compilation unit, resolved mid-turn between other cards'
            // effects, so it needs its own frame (docs/prev-obj-static-binding-plan.md §3.4).
            let frame = pushFrame({unit: unitOfEffects(e.effect)}); // a stardate has no card, so no `self`
            try{
                await resolveEffects(stardatePseudo(sd), e.effect, e.attack);
            }finally{
                popFrame(frame);
            }
        }
    }finally{
        // finally, not after the await: a cancelled choice throws, and a leaked activePlayer
        // would misattribute the rest of the turn
        resolvingStardate = false;
        state.update(s => {
            s.activePlayer = saved;
            return s;
        })
    }
}

// Cards resolve on the turn of whoever they were given to when the glory pile emptied – usually
// the inactive player, whoever the card's 'when emptied' text named.
export async function resolveStardateCards(){
    resetCache();
    while(get(state).players[get(state).currentPlayer].stardateCards.length > 0){
        let holder = get(state).players[get(state).currentPlayer];
        await resolveStardate(holder.stardateCards[0], 'resolution', holder);
        state.update(s => {
            s.players[s.currentPlayer].stardateCards.shift();
            return s;
        })
    }
}

// When the glory pile empties: run the card's 'when emptied' section, which is what hands it to
// a player's Staging Area (and, on the last card, triggers the end of the game).
async function giveStardateCards(){
    if(get(state).stardatePlayed >= sdCards().length) return;
    while(get(state).gloryTaken >= stardateGlory()){
        let sd = currentStardate();
        let glory = stardateGlory();
        let p = activePlayer();
        await resolveStardate(sd, 'emptied', p);
        if(stardateEffects(sd, 'emptied') === false && (!sd.event || !sd.event.includes('end_game'))){
            deferStardate(sd, get(state).practice ? 'you' : 'inactive', p); // legacy rows say nothing about where the card goes
        }
        state.update(s => {
            s.gloryTaken -= glory;
            if(s.gloryTaken < 0) s.gloryTaken = 0;
            s.stardatePlayed++;
            return s;
        })
    }
}

async function gainTokens(p, tok, amount, fromSupply, fromCard = false, manual = false){
    if(get(state).practice && tok == 'glory' && !fromCard) fromSupply = true; // Always from supply in practice mode
    if(tok == 'glory' && amount > 0 && !fromSupply && !fromCard){
        // Check limits
        await takeFromGloryPile(amount);
    }
    if(tok == 'action') tok = 'actions';
    updatePlayer(p, (p) => {
        if(!manual && amount > 0 && ongoingPlayer(p).some(e => e == `${tok}_holder`) && !fromCard){ // Burnham can still get from market
            let card = cardsInPlay(p).find(c => ongoingEffects(c).some(e => e == `${tok}_holder`));
            card[tok] += amount;
        }else{
            if(tok == 'whim' && p[tok] + amount > p.whim_limit){
                amount = p.whim_limit - p[tok];
                if(amount == 0) throw 'uncompleted';
            }
            p[tok] += amount;
        }
        checkDomination(p);
        return p;
    })
}

async function gainTrack(p, tok, amount){
    let before = p[tok];
    updatePlayer(p, (p) => {
        p[tok] += amount;
        checkDomination(p);
        return p;
    })
    let after = p[tok];
    if(tok == 'collective'){
        await checkCollectiveRewards(p, before, after); // For any rewards
    }
}

async function bottom(p, c, params = {}){
    let card = c;
    if(!c) return false;
    let deck = params.deck || params.place || false;
    let info = get(state).cardLog[card.uniqueID]
    let owner = getPlayerIndex(p);
    if(info.area == 'players') owner = info.player;
    if(info.area == 'beamed'){
        let bc = parseInt(info.deck);
        let bInfo = get(state).cardLog[bc];
        if(bInfo.area == 'players') owner = bInfo.player;
    }
    if(params.owner == 'opponent' || p.bot && params.owner == 'you'){
        owner = [0, 1].find(o => o != owner);
        p = otherPlayer(p);
    }
    if(deck){
        // Specific player's deck
        deck = deck.toLowerCase();
        if(p.decks.hasOwnProperty(deck)){
            await moveTo(c, `players.${deck}.${getPlayerIndex(p)}`, -1)
        }else{
            // Presume commons deck
            await moveTo(c, `commons.${deck}`, -1);
        }   
    }else{
        let place = get(state).cardLog[c.uniqueID];
        if(place.area == 'commons'){
            await moveTo(c, `commons.${place.deck}`, -1)
        }else if(place.area == 'players'){
            await moveTo(c, `players.${place.deck}.${owner}`, -1)
        }
    } 
}

export function howManyOnDuty(p){
    // Check if you're allowed to have any more on duty
    if(p.bot) return 1;
    if(ongoingPlayer(p).includes('no_duty_limit')) return Infinity;
    let total = 0;
    for(let c of cardsInPlay(p, false, true)){
        let e = ongoingEffects(c).filter(e => e.startsWith('extra_duty_'));
        if(e.length == 0) continue;
        let adding = 0;
        for(let a of e){
            let i = parseInt(a.slice("extra_duty_".length));
            if(!isNaN(i)) adding += i;
        }
        let restrictions = ongoingEffects(c, 'extra_duty_restrictions');
        let alreadyAdded = false;
        if(restrictions.length != 0 && restrictions[0]){
            let r = restrictions[0];
            if(r.ifInStaging && get(state).cardLog[c.uniqueID].deck != 'play') continue; // Skip if out of staging 
            let type = r.type;
            if(type){
                let duty = p.decks.duty;
                let matchCount = 0;
                for(let d of duty){
                    if(d.uniqueID == c.uniqueID) continue; // Can't match card itself
                    matchCount += matches(d, type);
                }
                total += Math.min(matchCount, adding); // 
                alreadyAdded = true;
            }
        }
        let type = ongoingEffects(c, 'extra_duty_type');
        if(type.length != 0 && type[0]){
            type = type[0]; // Only one... !! TODO could 
            let duty = p.decks.duty;
            let matchCount = 0;
            for(let d of duty){
                if(d.uniqueID == c.uniqueID) continue;
                matchCount += matches(d, type);
            }
            total += Math.min(matchCount, adding); // 
            alreadyAdded = true;
        }
        if(!alreadyAdded){
            total += adding;
        }
    }
    /*let adds = ongoingPlayer(p).filter(e => e.startsWith('extra_duty_'));
    //console.log(adds);
    let adding = 0;
    for(let a of adds){
        let i = parseInt(a.slice("extra_duty_".length));
        if(!isNaN(i)) adding += i;
    }*/
    return 1 + total;
}

async function returnCard(c){
    if(c.suits.includes('incident')){
        await moveTo(c, `commons.incidents`);
        if(!get(res).BvB) await tick();
        await moveTo(c, `commons.incidents`, -1);
    }
    if(matches(c, 'redshirt')) await moveTo(c, `commons.redshirts`);
}

async function takeControl(p, card, params){
    if(!canGainControl(card)) throw 'uncompleted';
    if(!params.chosenHint){
        params.chosenHint = getHints(card, 'control')
    }
    //cardOnStack(card);
    let info = get(state).cardLog[card.uniqueID];
    let deck = info.deck;
    //console.log(info);
    if(info.area != 'players' || info.deck != 'locations' || parseInt(info.player) != getPlayerIndex(p)){
        await moveTo(card, `players.locations.${getPlayerIndex(p)}`, -1);
    }
    if(card.deck == 'Locations'){
        if(!card.left) card.left = {};
        card.left.turn = get(state).turn;
        card.left.location = p.captain;
    }

    if(p.bot){
        await resolveBotCard(p, card, false);
    }else{
        if(get(prefs).showHints){
            // Something here?
            //console.log(params.chosenHint)
            let savedCache = {...get(state).cache};
            if(params.chosenHint && params.chosenHint.length > 0) await autoCardActions(card, params.chosenHint)
            if(savedCache) state.update(s => {
                s.cache = {...savedCache};
                return s;
            })
        }else{
            await pause(`Complete the actions on ${cc(card.uniqueID)}`);
        }
    }
    
    if(p.captain == 'Khan' && card.traits && card.deck != 'Khan' && collectableTraits(card.traits, p).length > 0){
        // You can mark a trait as collected!
        // NB not for neutral locations any more
        let yes = await choose(`You may mark one of this card's traits (${collectableTraits(card.traits, p).map(t => `[[${t}]]`).join('/')}) as collected. Do you want to?`, ['Yes', 'No']);
        if(yes == 'Yes') await doAction(p, 'mark_collected', {obj: card.uniqueID});
    }
    
    //cardOffStack(card);
}

export async function playCard(p, card, params){

    //console.log(getCostInfo(p, {glory: 1, latinum: 2, dilithium: 3}))
    let whereToGo = 'play';
   /* if(card.suits.includes('location')){
        whereToGo = 'locations';
    }else if(card.suits.includes('ship')){
        whereToGo = 'fleet';
    }else if(card.suits.includes('mission')){
        whereToGo = 'missions';
    }*/
    // !! NB removed below so costs are all handled in autoCardActions
    /*if(!isFreePlay(card) && !params.free){
        if(p.actions == 0) throw 'cancelled';
    }*/
    if(!params.chosenHint){
        params.chosenHint = getHints(card, 'all_play');
        //console.log(getHints(card, null, true))
    }
    /*if(!params.free){
        p.actions--;
    }*/
    
    // Do other stuff here
    //cardOnStack(card);

    // TODO check the card has actions!
    if(card.name.toLowerCase() == 'reinforce' && p.reinforce_boost){
        for(let g of p.reinforce_boost){
            logText(`Triggering Campaign reward for playing *Reinforce*`)
            await doAction(p, 'gain_tokens', {obj: {num: g.num, specific: g.specific}});
        }
    } 
    if(get(prefs).showHints){
        // Something here?
        // Hide the enclosing action's current_obj while this card resolves, so a nested play
        // (e.g. Vidiians "free play an [[incident]]") doesn't make Multiversal Fracture's
        // "scan 2 of the same suit" resolve to [[incident]] instead of the card just given
        let savedCO, savedCV;
        state.update(s => {
            if(!s.cache) s.cache = {};
            savedCO = s.cache.current_obj;
            savedCV = s.cache.current_verb;
            delete s.cache.current_obj;
            delete s.cache.current_verb;
            return s;
        })
        try{
            await autoCardActions(card, params.chosenHint, params.free)
        }finally{
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(savedCO !== undefined) s.cache.current_obj = savedCO;
                if(savedCV !== undefined) s.cache.current_verb = savedCV;
                return s;
            })
        }
    }else{
        await moveTo(card, `players.${whereToGo}.${rightPlayerIndex(p, card)}`, -1);
       // if(whereToGo == 'action_area') await doAction(p, 'put_in_staging', {obj: card.uniqueID}); // for specific reactions
        await pause(`Complete the actions on ${cc(card.uniqueID)}`);
    }

    // Then move it to where it will go!
    // !!! NB the below removed because it's handled by in-card text now
    /*if(card.traits && (card.traits.includes('on-going') || card.traits.includes('ongoing'))){
        if(ongoingEffects(card).includes('mimic_location')){
            await doAction(p, 'control', {obj: card.uniqueID});
        }else if(matches(card, 'location')){
            await moveTo(card, `players.locations.${getPlayerIndex(p)}`, -1); // Just for Sha Ka Ree
        }else{
            await moveTo(card, `players.fleet.${getPlayerIndex(p)}`, -1); // Presuming this is just for cargo cards
        }
       
    }*/
    //cardOffStack(card);
    
    //if(!permanent) await dismissCard(p, card);
}

function rightPlayerIndex(p, card){
    let info = get(state).cardLog[card.uniqueID];
    let owner = getPlayerIndex(p);
    if(info.area == 'players'){
        // NB the below removed Oct 2025 because I think it messed up USS Defiant bot play...
        // if it's here just for 'you log X' then it shouldn't be needed
        // reinstate if other stuff breaks
        /*if(get(state).currentPlayer != owner && get(state).players[get(state).currentPlayer].bot){
            // It is a 'you' effect, so it comes to you
            return owner;
        }*/
        owner = info.player;
    }
    if(info.area == 'beamed'){
        let bc = parseInt(info.deck);
        let bInfo = get(state).cardLog[bc];
        if(bInfo.area == 'players') owner = bInfo.player;
    }
    return owner;
}

export async function dismissCard(p, card){
    if(!card) return false;
    if(ongoingEffects(card).includes('dismiss_log')){
        logText(`Would dismiss ${cc(card.uniqueID)}, so logging it instead`);
        await doAction(p, 'log', {obj: card.uniqueID})
    }else{
        /*let on_dismissal = false;
        if(ongoingEffects(card).includes('on_dismissal')){
            on_dismissal = ongoingEffects(card, 'on_dismissal')[0];

        }*/
        await moveTo(card, `players.discard.${rightPlayerIndex(p, card)}`); // TODO if this works, we can copy for other equivalent player situations. Or use cardOwner?
        //await new Promise(r => setTimeout(r, 300)); // TODO really?
        /*if(on_dismissal){
            //await doAction(p, 'resolve', {card: card.uniqueID, obj: card.uniqueID, effectType: on_dismissal})
            let possibleEffects = getHints(card, on_dismissal);
            await autoCardActions(card, possibleEffects, true);
        }*/
    }
    
}

async function giveCard(p, card){
    let arr = [0, 1, 2, 3];
    let numP = get(state).players.length;
    let poss = arr.slice(0, numP);
    let otherName = '';
    let other;
    if(numP > 2){
        otherName = await choose(`Choose player to give card to`, poss.filter(a => a != getPlayerIndex(p)).map(a => get(state).players[a].captain));
        other = get(state).players.findIndex(p => p.captain == other);
        if(other == -1) throw 'cancelled';
    }else{
        other = poss.find(a => a != getPlayerIndex(p));
        otherName = get(state).players[other].captain;
    }
    await checkForReactions(get(state).players[other], 'take', {obj: card.uniqueID}, 'before');
    if(get(state).players[other].bot){
        await moveTo(card, `players.deck.${other}`);
    }else{
        await moveTo(card, `players.hand.${other}`);
    }
    await checkForReactions(get(state).players[other], 'take', {obj: card.uniqueID}, 'after');
    return otherName;
}

async function activateCard(c, params){
    //cardOnStack(c);
    let p = cardOwner(c);
    await doAction(p, 'exhaust', {obj: c.uniqueID});
    p.stats.turns[get(state).turn].activations++;
    if(get(prefs).showHints){
        // Something here?
        if(!params.chosenHint){
            params.chosenHint = getHints(c, 'activate');
        }
        if(p.activations != -1) p.activations--;
        await autoCardActions(c, params.chosenHint)
    }else{
        if(p.activations != -1) p.activations--;
        await pause(`Complete the actions on ${cc(c.uniqueID)}`);
    }
    //cardOffStack(c);
    //await updateAllTypeGains(); // In case any are triggered
}

export async function deactivateCard(c){
    delete c.activated;
    //await updateAllTypeGains(); // In case any are triggered
    let ongoing = ongoingEffects(c, 'ongoing', true);
    let p = cardOwner(c);
    for(let o of ongoing){
        await handleOngoingChange(p, c, o/*, 'leaving'*/); // NB leaving shouldn't be needed and may cause issues
    }
}

export function unparsedCard(c){
    if(!c) return false;
    let pct = get(res).parsedCardText[c.id];
    if(!pct || pct.error) return true;
    return false;
}

export function mustPlayManual(c){
    if(!c) return false;
    if(!get(prefs).showHints) return false;
    //if(isFacedown(c)) return false;
    //console.log(c.name, getHints(c))
    if(unparsedCard(c)) return true;
    return false;
    //return getHints(c) && getHints(c).length > 0
}

// includeManual: list manual actions even when hints hide them (the phone's long press).
export function getActions(c, facedown, includeManual = false){
    let _state = get(state);
    let p = _state.players[get(ui).seat];//[_state.activePlayer];
    //if(p.bot) p = _state.players[get(ui).seat];
    let info = _state.cardLog[c.uniqueID];

    if(!info) return [];

    if(!includeManual && get(prefs).showHints && !mustPlayManual(c) && get(prefs).hideManualActions) return []; // Auto actions disable tooltip on cards that have autoplay abilities

    if(!isMe(_state.activePlayer)) return []; // Can't do actions unless it's actually your go
    //if(_state.phase != 'action') return []; // Can do some things in other phases though

    let actions = []; //['play', 'dismiss', 'return', 'junk', 'gain_card', 'log', 'beam', 'activate', 'play_activate', 'orbit'];
    let handActions = ['shift_left', 'discard', 'log', 'beam', 'top', 'bottom', 'junk', 'put_in_play', 'shift_right'];
    let deckActions = ['hand', 'discard', 'log', 'bottom', 'junk'];
    let playActions = ['shift_left','dismiss', 'log', 'junk', 'beam', 'hand', 'shift_right'];
    let discardActions = ['hand', 'log', 'top', 'junk']
    let beamedActions = ['shift_left','hand', 'discard', 'junk', 'shift_right']
    let logActions = ['hand', 'junk'];
    let reserveActions = ['enlist', 'top', 'bottom'];
    let devActions = ['develop_manual'];
    let missionActions = ['junk'];
    let dynastyActions = ['discard', 'top', 'log']

    if(info.area == 'commons'){
        if(canJunk(c)) actions.push('junk');
        if(info.deck == 'neutral_zone'){
            actions.push('gain_control', 'force_away');
        }else if(info.deck == 'incidents'){
            actions = ['take', ...actions];
        }else{
            actions = ['gain_card', ...actions];
        }
        if(info.deck == 'missions'){
            actions = missionActions;
            if(p.actions > 0){
                actions = ['play', ...actions];
            }
        }
        if(info.deck == 'incidents'){
            actions = [...actions, 'give'];
        }
        
    }else if(info.area == 'players'){
        if(!facedown){
            if(info.deck == 'hand'){
                actions = handActions;
                if(matches(c, 'location')) actions.push('gain_control');
                if(c.suits.includes('cargo') || matches(c, 'ship') || c.suits.includes('encounter')) actions.push('put_in_fleet');
            }else if(info.deck == 'discard'){
                actions = discardActions;
            }else if(info.deck == 'deck' || info.deck == 'continuum' || info.deck == 'journey'){
                actions = deckActions;
            }else if(info.deck == 'log'){
                actions = logActions;
            }else if(info.deck == 'reserve'){
                actions = reserveActions;
            }else if(info.deck == 'dev'){
                actions = devActions;
            }else if(info.deck == 'dynasty'){
                actions = dynastyActions;
            }else if(info.deck == 'play' || info.deck == 'fleet' || info.deck == 'locations' || info.deck == 'missions' || info.deck == 'duty'){
                actions = playActions;
                if(matches(c, 'location') && info.deck != 'locations') actions.push('gain_control');
                if(matches(c, 'person')) actions.push('duty');
            }else if(info.deck == 'captain'){
                actions = ['view_log', 'reset_ats'];
            }
        }else if(info.deck == 'reserve'){
            actions = ['discard']
        }
    }else if(info.area == 'beamed'){
        actions = beamedActions;
    }
    if(matches(c, 'redshirt') && !facedown) actions = [...actions, 'return'].filter(a => a != 'log');
    if(c.suits.includes('incident') && !facedown) actions = [...actions, 'return', 'give'];
    if(c.suits.includes('mission') ) actions = [...actions, 'accept', 'log'];

    if(info.area == 'players' && !inPlayLocations.includes(info.deck) && !facedown){
        // possibly play?
        /*if(c.playText && c.playText.toLowerCase().includes('free action') && canPlay(p, c)){
            actions = ['freeplay', 'play_activate', ...actions];
        }else if(canPlay(p, c)){
            actions = ['play', 'play_activate', ...actions];
        }*/
        if(canPlay(p,c)){
            actions = ['play', 'freeplay', 'play_activate', ...actions];
        }else{
            actions = ['freeplay', 'play_activate', ...actions];
        }
        
    }

    //console.log(c, p)
    if(matches(c, 'location') && !facedown && canBeamTo(p, c)){
        actions = [...actions, 'away', 'force_away']; 
    }
    if(matches(c, 'location') || isInPlay(c) && atPool(p) == 'drones'){
        actions = [...actions, 'send_drone'];
    }
    if(c.drones && Object.keys(c.drones).filter(k => c.drones[k]).length > 0){
        actions = [...actions, 'remove_drone'];
    }
    if(matches(c, 'location')  && !facedown && myAway(p, c)){
        actions = [...actions, 'remove_away'];
    }
    if(matches(c, ['ship', 'ongoing', 'qsuit']) && !facedown && !p.decks.fleet.includes(c)){
        actions = [...actions, 'deploy'];
    }
    if(matches(c, 'person') && !facedown && !p.decks.duty.includes(c)){
        actions = [...actions, 'duty'];
    }

    if(c.ships && c.ships.length > 0 && !facedown) actions = [...actions, 'warp']; // TODO was 'orbit'
    if(c.orbiting && c.orbiting.length > 0) actions = [...actions, 'warp', 'dismiss_ship'];
    if(matches(c, 'qsuit')) actions = [...actions, 'teleport'];
    if(info.area == 'players' &&  getCardEffect(c, 'activation') &&  getCardEffect(c, 'activation').length > 0){//inPlayLocations.includes(info.deck) && (!matches(c, 'person') || info.deck == 'duty') && get(res).parsedCardText[c.id] && get(res).parsedCardText[c.id].effects && get(res).parsedCardText[c.id].effects.some(e => e.type == 'activation' || e.type == 'reaction')){
        if(c.activated){
            actions = ['refresh', 'play_activate', ...actions];
        }else if(p.activations > 0 || p.activations == -1){
            actions = ['activate', 'play_activate', ...actions];
        }
    }else if(info.area == 'players' && c.activated){
        actions = ['refresh', ...actions];
    }

    if(c.reverse || c.facedown) actions = [...actions, 'flip'];

    if(p.collected_traits && c.traits && collectableTraits(c.traits, p).length > 0) actions = [...actions, 'mark_collected']

    if(p.captain == 'Borg Queen'){
        actions = [...actions, 'assimilate'];
        if(ongoingEffects(c).includes('drone_alcoves')) actions = [...actions, 'regenerate'];
    }
    if(p.captain == 'Q' && info.deck != 'void'){
        actions = [...actions, 'snap'];
    }
    if(c.name == 'Q'){
        actions = [...actions, 'increase_whim', 'reduce_whim']
    }
    
    let l = isBeingLookedAt(get(ui), c);
    /*if(l && l.canReorder){
        if(!actions.includes('shift_left')) actions = ['shift_left', ...actions];
        if(!actions.includes('shift_right')) actions = [...actions, 'shift_right'];
    }*/


    let ret = actions.map(a => allActions.find(ac => ac.type == a));
    return ret;
}

export function getShiftActions(){
    return ['shift_left', 'shift_right'].map(a => allActions.find(ac => ac.type == a));
}

function updatePlayer(p, actions){
    let pn = getPlayerIndex(p);
    state.update(s => {
        s.players[pn] = actions(s.players[pn]);
        return s;
    })
}

export function updateMissions(){
    let missions = [];
    for(let p of get(state).players){
        missions.push(...p.dashboard.missions, ...p.decks.missions);
        if(p.decks.continuum) missions.push(...p.decks.continuum);
    }

    for(let c of missions){
        c.status = checkMission(cardOwner(c), c);
    }
}

export const dbUpdateMissions = debounce(updateMissions, 500);

export function oneOffMessage(p, message, fn = logText){
    if(!p.oneOffMessages) p.oneOffMessages = {};
    if(p.oneOffMessages[message]) return;
    fn(message);
    p.oneOffMessages[message] = true;
}

// keepTop: cards still on top of the old deck mid-effect (e.g. 'discard top 3' with 2 left) stay on top, unshuffled
function shuffleBelow(p, keepTop = 0){
    let tail = p.decks.deck.splice(keepTop);
    shuffle(tail);
    p.decks.deck.push(...tail);
}

export async function reshuffleDeck(p, params){
    p = getP(p);
    if(ongoingPlayer(p).includes('no_cycle')){
        oneOffMessage(p, `Reminder: ${p.captain} does not cycle.`);
        return;
    }
    if(!p.stats) p.stats = {};
    if(!p.stats.cycled) p.stats.cycled = [];
    p.stats.cycled.push(get(state).turn);
    let i = getPlayerIndex(p);

    if(!p.bot){
        await checkForReactions(p, 'cycle', {}, 'before');
    }
    
    
    
    //await new Promise(r => setTimeout(r, 300));
   /* if(devCard){
        await moveTo(devCard, 'players.deck.'+i, 0); // To put on top
    }*/
    if(!p.bot){
        let doEnlist = true;
        if(ongoingPlayer(p).includes('no_enlist')){
           let ne = ongoingPlayerWithCards(p, 'no_enlist');
           if(ne && ne.length > 0){
            for(let n of ne){
                // hopefully never more than one of these effects anyway
                let c = n.card;
                let el = n.effects;
                let should = false;
                let someCondition = false;
                for(let e of el){
                    if(e.condition){
                        someCondition = true;
                        should = await resolveCondition(p, c, e.condition, false);
                    }
                }
                if(should || !someCondition){
                    logText(`This Captain does not enlist when cycling.`)
                    doEnlist = false;
                    for(let e of el){
                        if(e.instead){
                            logText(`Instead of enlisting:`);
                            await resolveEffects(c, e.instead, false);
                        }
                    }
                }
                
            }
           }
        }

        for(let c of p.decks.discard){
            await moveTo(c, 'players.deck.'+i);
        }
        shuffleBelow(p, params.keepTop);

        let didEnlist = false;

        if(doEnlist){
            if(p.decks.dev.length == 0) await checkForReactions(p, 'enlist_empty', {}, 'before');
            if(p.decks.reserve.length > 0){
                
                let c = p.decks.reserve[0];
                logText(`Draw deck empty, so putting card ${cc(c.uniqueID, 'h')} from Reserve on top of deck pile`);
                //await moveTo(c, 'players.discard.'+i);
                //await checkForReactions(p, 'enlist', {obj: c.uniqueID}, 'before');
                //await moveTo(c, 'players.deck.'+i, 0);
                await doAction(p, 'enlist', {obj: c.uniqueID});
                didEnlist = true;
                //shuffle(p.decks.discard);
                //await checkForReactions(p, 'cycle', {}, 'after');
                
            }else{
                let did = false;
                do{
                   did = await autoDevelop(p);
                   if(!did) await checkForReactions(p, 'enlist', {}, 'before'); // To make Q work
                }while(did == -1);
                //if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
                //if(devCard) devCard = getCard(devCard);
                //await pause('Draw deck empty: put a card from development deck into discard pile, paying its cost');
                //shuffle(p.decks.discard);
                /*for(let c of p.decks.discard){
                    await moveTo(c, 'players.deck.'+i);
                }*/
               didEnlist = did;
            }

            if(!didEnlist && ongoingPlayer(p).includes('when_no_enlist')){
                let wne = ongoingPlayerWithCards(p,'when_no_enlist');
                for(let full of wne){
                    let {card, effects} = full;
                    await resolveEffects(card, effects, effects.attack);
                }
            }
            
            
        }
        // rather than inside dev/reserve because you still cycle even when those decks are empty
        // Feb 2026: cycle even if nothing changes (Khan)
        /*if(p.decks.deck.length > 0)*/ await checkForReactions(p, 'cycle', {}, 'after');

        if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
        
    }else{
        for(let c of p.decks.discard){
            await moveTo(c, 'players.deck.'+i);
        }
        shuffleBelow(p, params.keepTop);

        if(p.decks.reserve.length > 0){
            let c = p.decks.reserve[0];
            logText(`Draw deck empty, so putting card ${cc(c)} from bot reserve on top of deck`);
            await moveTo(c, 'players.deck.'+i, 0);
            if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
        }
    }
}

export function faceupDraw(p){
    return ongoingPlayer(p).includes('faceup_draw');
}

export async function drawCard(p, num, params){
    let cards = [];
    let drawTo = 'hand';
    if(p.bot) drawTo = 'discard';
    if(params.intoPlay) drawTo = 'play';
    let index = 0;
    if(params.toEnd) index = -1;
    for(let i = 0; i < num; i++){
        if(p.decks.deck.length == 0){
            await reshuffleDeck(p, params);
            //await resolveEffects(params.card || {uniqueID: -1}, {type: 'action', verb: 'reshuffle_poss_enlist', text: 'Reshuffle deck'}, false);
            if(!get(res).BvB) await tick();
            /*if(p.decks.deck.length > 0){
                let c = p.decks.deck[0].uniqueID;
                console.log('new card', p.decks.deck[0]);
                cards = [...cards, c];
                await moveTo(p.decks.deck[0], `players.${drawTo}.${getPlayerIndex(p)}`, index);
                //console.log(p);
                if(!params.drawn) params.drawn = [];
                params.drawn = [...params.drawn, c];
                if(!get(res).BvB) await tick();
                if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
            }*/
        }
        if(p.decks.deck.length > 0){
            if(faceupDraw(p) && (num - i) < p.decks.deck.length){
                // Select the cards to draw, because there are more than are in the deck to draw
                let chosen = await chooseCards(`Choose ${num - i} card(s) to draw`, p.decks.deck, {number: num - i, lookSpecific: true});
                for(let c of chosen){
                    cards = [...cards, c.uniqueID];
                    await moveTo(c, `players.${drawTo}.${getPlayerIndex(p)}`, index);
                    if(!params.drawn) params.drawn = [];
                    params.drawn = [...params.drawn, c.uniqueID];
                    if(!get(res).BvB) await tick();
                    if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
                    i++; // to skip ahead
                }
            }else{
                let c = p.decks.deck[0].uniqueID;
                cards = [...cards, p.decks.deck[0].uniqueID];
                await moveTo(p.decks.deck[0], `players.${drawTo}.${getPlayerIndex(p)}`, index);
                if(!params.drawn) params.drawn = [];
                params.drawn = [...params.drawn, c];
                if(!get(res).BvB) await tick();
                if(!params.noPause) await doActionPause();//new Promise(r => setTimeout(r, 300));
            }
        }else{
            // No card draw possible because everything is empty
            if((!p.decks.dev || p.decks.dev.length == 0) && !get(prefs).stopWarning && !get(state).practice){
                playSound('self_destruct', true);
                let choices = ['OK'];
                if(get(prefs).hasBeenWarned) choices = ['Ha-ha, stop telling me this now', 'OK']
                let choice = await choose(`<div>No card draw possible because you have emptied your deck, discard and reserves/devs.</div><div>Game will now self-destruct.</div>&nbsp;<div></div><div>... Nah, just kidding. (Hi there, Stormburns!)</div>`, choices);
                prefs.update(p => {
                    p.hasBeenWarned = true;
                    return p;
                })
                if(choice != 'OK'){
                    prefs.update(p => {
                        p.stopWarning = true;
                        return p;
                    })
                }
            }
        }
    } 
    ui.update(u => {
        u.selection = false;
        return u;
    })
    return cards;
}

export async function beamCard(p, params){
    if(!Array.isArray(params.obj)) params.obj = [params.obj]
    for (let id of params.obj){
        let card = getCard(id);
        if(matches(card, 'location', false)){
            logText('Cannot beam location: abandoning action');
            throw 'uncompleted';
        }
        if(Array.isArray(params.to)){
            params.to = params.to[0];
            if(!params.to) throw 'uncompleted';
        }

        if(!params.to){
            let cards = [...p.decks.locations, ...p.decks.fleet.filter(c => matches(c, 'ship') || matches(c, 'levitation boots'))]; //.filter(c => canBeamTo(p, c));
            if(p.captain.toLowerCase().includes('rebner')){
                cards = [...p.decks.locations, ...p.decks.fleet, ...p.decks.duty, ...p.decks.fleet]
            }
            cards = cards.filter(c => !ongoingEffects(c).includes('no_beaming_here') || params.card == c.uniqueID);
            let c = await chooseCards('Choose a card to beam to', cards, {cancellable: true});
            
            if(!c || c == 'cancelled') throw 'cancelled';
            console.log(c)
            params.to = c.uniqueID;
        }
        

        // Jan 2026: added this so Lursa works
        // ...but we might need to rethink prepositions 
        // in prev obj if this breaks other stuff
        // (it's kinda a mess, isn't it??)
        // Recorded as 'beam_to', not 'beam': a 'beam' verb means 'the beamed card', so logging the
        // destination under it made 'if the beamed card is X' test the ship too.
        addCardsToCache(getCard(params.to), 'beam_to'); 

        await moveTo(card, `beamed.${params.to}`);
    }
}

export function canBeamTo(p, c, params = {}){
    if(!matches(c, 'location')) return false;
    if(ongoingEffects(c).includes('no_away')) return false;
    if(ongoingEffects(c).includes('no_other_away') && params.card && params.card != c.uniqueID) return false;
    if(c.defp && defpCard(otherPlayer(p))) return false; // Cannot send away teams where defp is
    if(params.ignoring_ships) return true;
    if(ongoingPlayer(p).includes('ignore_ships')) return true;
    if(theirOrbiting(p, c) > myOrbiting(p, c)) return false;
    return true;
}

export function isBeingLookedAt(_ui, c){
    if(!c) return false;
    //let info = get(state).cardLog[c.uniqueID];
    //let deck = getDeck(get(state), info.area, info.deck, info.player);
    if(_ui.looking.some(l => !l.cards && getDeck(get(state), l.area, l.deck, l.player).includes(c))){
        return _ui.looking.find(l => !l.cards && getDeck(get(state), l.area, l.deck, l.player).includes(c))
    }
    if(_ui.looking.some(l => l.cards && l.cards.includes(getDeck(get(state), l.area, l.deck, l.player).findIndex(cd => cd == c)))){
        return _ui.looking.find(l => l.cards && l.cards.includes(getDeck(get(state), l.area, l.deck, l.player).findIndex(cd => cd == c)));
    }
    
    return false;
}

export async function cardSearch(){
    console.log('searching');
    let text = prompt(`Search for:`);
    if(!text) return;
    let cards = allCards().filter(c => c.name.toLowerCase().includes(text.toLowerCase()));
    console.log(cards);
    lookAtCards(cards);
    /*let cards = allCards();
    let c = await choose(`Search for:`, cards, {cancellable: true, lookSpecific: true, textChoice: {
        input: '',
        func: (f) => {
            return cards.filter(c => c.name.toLowerCase().includes(f.toLowerCase()));
        }
    }})
    await doAction(get(state).players[get(ui).seat], 'gain_card', {card: c.uniqueID});*/
}

export function possArray(a){
    if(Array.isArray(a)) return a;
    return [a];
}

export function scalarIfOne(a){
    if(possArray(a).length == 1) return possArray(a)[0];
    return possArray(a);
}


let checkingMimic = new Set(); // see the 'mimic_' lookup in matches()

export function matches(c, filter, countWildcards = true, countWildSkills = true){
    if(!c) return 0; // Non-existent cards have nothing - don't throw, fail gracefully
    let p;

    if(Array.isArray(c)){
        // collate all
        let count = 0;
        for(let card of c){
            count += matches(card, filter, countWildcards, countWildSkills);
        }
        return count;
    }

    if(cardOwner(c)){
        // !! You only count wildcards if you're the active player
        
        p = cardOwner(c);
        let active = get(state).players[get(state).activePlayer];
        if(active.captain != p.captain) countWildcards = false;
    }

    if(typeof c == 'number') c = getCard(c);
    //console.log('testing', c, filter)
    if(!c.suits || !c.traits){
        console.log('Card badly formed!', get(state), c);
        return 0;
        //throw 'Card badly formed'; // Make it more forgiving
    }
    
    if(filter == 'chosen_type'){
        // get from cache
        if(get(state).cache && get(state).cache.chosen){
            filter = get(state).cache.chosen;
        }else{
            alert('Error: no chosen type!')
            return 0;
        }
    }
    if(filter == 'beamed_card'){
        let info = get(state).cardLog[c.uniqueID];
        if(info.area == 'beamed') return 1;
        return 0;
    }
    if(filter == 'visited'){
        if(!c.visiting) return 0;
        return c.visiting.length;
    }
    if(Array.isArray(filter)){
        let num = 0;
        //let matchWildSkills = true;
        let wc = false;
        if(countWildcards){ // Should this fill it in?
            if(typeof countWildcards == 'boolean'){
                wc = {
                    wildcardsUsed: 0,
                    wildcardsLeft: cardWCs(c, filter.types)
                };
            }else{
                wc = {
                    wildcardsUsed: 0,
                    wildcardsLeft: cardWCs(c, filter.types),
                    ...countWildcards
                }
            }
            
        }
        let matchedSkillAlready = false;
        let matchedFocusAlready = false;
        for(let f of filter){
            let ws = false;
            let baseAdd = matches(c, f, wc, false);
            num += baseAdd;
            if(countWildSkills){
                if(typeof f == 'string' && f.endsWith('-skill') && !matchedSkillAlready){
                    ws = true;
                    let extra = matches(c, f, wc, ws);
                    if(extra > baseAdd){
                        matchedSkillAlready = true;
                        num += (extra - baseAdd);
                    }
                }
                if(typeof f == 'string' && f.endsWith('-focus') && !matchedFocusAlready){
                    ws = true;
                    let extra = matches(c, f, wc, ws);
                    if(extra > baseAdd){
                        matchedFocusAlready = true;
                        num += (extra - baseAdd);
                    }
                }
            }
            
            //if(f.endsWith('-skill')) matchWildSkills = false; // So that it only picks up wild once
            //if(countWildcards ** c.traits) num += c.traits.filter(t => t == 'wildcard')
        }
        return num;
    }else if(filter && filter.main){
        // It's a main-type and an exclude/specific type
        let num = matches(c, filter.main, countWildcards, countWildSkills);
        let sub = 0;
        if(filter.exclude && matches(c, filter.exclude, false, false)) return 0; // Don't count wildcards for this, but flat exclude if it fits
        if(filter.beamer){
            let beamed = c.beamed || [];
            if(!['cards', 'card'].includes(filter.beamer.types)) beamed = beamed.filter(c => matches(c, filter.beamer.types));
            if(!testNum(filter.beamer.num, beamed.length)) return 0;
        }
        if(filter.specific){
            if(filter.specific == 'same_location'){
                // Sharing a location with one of your [[ship]]
                let loc = shipLocation(c);
                if(!loc) return 0;
                let ships = shipsAtLocation(loc, get(state).players[get(state).activePlayer]);
                if(ships.length == 0) return 0;
            }
        }
        num -= sub; // !!! what's this all about then??
        if(num < 0) num = 0;
        return num;
    }else if(filter.types){
        // It's a types construction
        let wc = false;
        if(countWildcards){ // Should this fill it in?
            if(typeof countWildcards == 'boolean'){
                wc = {
                    wildcardsUsed: 0,
                    wildcardsLeft: cardWCs(c, filter.types)
                };
            }else{
                wc = {
                    wildcardsUsed: 0,
                    wildcardsLeft: cardWCs(c, filter.types),
                    ...countWildcards
                }
            }
        }
        let num = matches(c, filter.types, wc, countWildSkills);
        if(filter.filter){
            let filterNum = matches(c, filter.filter, wc, countWildSkills);
            return Math.min(filterNum, num);
        }else{
            return num;
        }
    }else if(filter.card){
        filter = filter.card; // get card from name
    }
    //if(typeof c == 'number') c = getCard(c);
   // console.log('matching', filter, c)
    if(filter.includes('+')){
        let elements = filter.split('+');
        // March 2026: add the below so that suits don't match wildcards
        let matchableCount = elements.filter(e => get(res).traits.includes(e)).length;
        let numMatched = 0;
        for(let e of elements){
            numMatched += matches(c, e, false);
        }
        if(matchableCount > 0 && numMatched < elements.length && countWildcards){ // only look at below if needed
            let numWildcards = cardWCs(c, elements);

            //!!! WILDCARD fix todo
            if(typeof countWildcards == 'object'){
                if(countWildcards.hasOwnProperty('wildcardsLeft') && countWildcards.wildcardsLeft < numWildcards){
                    numWildcards = countWildcards.wildcardsLeft;
                }
                numMatched += Math.min(numWildcards, matchableCount);
                countWildcards.wildcardsUsed += numWildcards;
                if(countWildcards.wildcardsLeft){
                    countWildcards.wildcardsLeft -= numWildcards;
                }
            }else{
                numMatched += Math.min(numWildcards, matchableCount);
            }
        }
        if(numMatched >= elements.length) return 1;
        return 0;
        /*if(!c.traits.some(t => t == 'wildcard')){
            for(let e of elements){
                if(!matches(c, e)) fits = 0;
            }
        }else{
            let cW = JSON.parse(JSON.stringify(c));
            let w = cW.traits.filter(t => t == 'wildcard');
            cW.traits = cW.traits.filter(t => t != 'wildcard');
            let wildcardsNeeded = 0;
            for(let e of elements){
                let without = matches(cW, e);
                let withW = matches(c, e);
                if(withW != without) wildcardsNeeded++;
            }
            if(wildcardsNeeded <= w.length){
                return 1;
            }else{
                return 0;
            }
        }*/
    }
    filter = filter.toLowerCase();
    /*if(c.id == 'DUMMY'){
        //console.log('dummy', filter, c)
        if(filter.endsWith('ship') && c.name == 'Dummy Duty Officer') return 0; 
        if((filter == 'person' || filter == 'duty') && c.name == 'Dummy ship') return 0;
        return 1;
    }*/
    if(filter.startsWith('>=')){
        filter = filter.slice('>='.length).trim();
        if(c.vp && c.vp >= parseInt(filter)) return 1;
        return 0;
    }
    if(filter.startsWith('=')){
        filter = filter.slice('<='.length).trim();
        if(c.vp && c.vp <= parseInt(filter)) return 1;
        return 0;
    }
    if(filter.startsWith('=')){
        filter = filter.slice('='.length).trim();
        if(c.vp && c.vp == parseInt(filter)) return 1;
        return 0;
    }
    if(filter.startsWith('common ')){
        filter = filter.slice('common'.length).trim();
        if(c.deck != 'Common' && c.deck != 'Locations') return 0;
    }
    if(filter.startsWith('exhausted deployed ')){
        // adjectives arrive in text order ("an exhausted deployed [[ship]]", Enchanced Biotech)
        if(!c.activated) return 0;
        filter = filter.slice('exhausted'.length).trim();
    }
    if(filter.startsWith('deployed ')){

        let info = get(state).cardLog[c.uniqueID];
        //console.log('looking for deployed', c, info, filter.slice('deployed'.length));
        if(ongoingEffects(c).includes('visiting_deployed')){
            // It is considered deployed if token is not here
            if(!c.whereAmI) return 0; // if token is elsewhere then it's not considered here
        }else{
            if(!ongoingEffects(c).includes('mimic_deployed') && (info.area != 'players' || info.deck != 'fleet')) return 0;
        }
        
        filter = filter.slice('deployed'.length).trim();
    }
    if(filter.startsWith('exhausted ')){
        
        if(!c.activated) return 0;
        filter = filter.slice('exhausted'.length).trim();
    }
    if(filter.startsWith('opponent ')){
        let owner = cardOwner(c);
        if(owner == get(state).players[get(state).activePlayer]) return 0; // Bit of a bodge but should work 
        filter = filter.slice('opponent'.length).trim();
    }
    if(filter == 'any_deployed'){
        let info = get(state).cardLog[c.uniqueID];
        //console.log('looking for deployed', c, info, filter.slice('deployed'.length));
        if(info.area != 'players' || info.deck != 'fleet') return 0;
        return 1;
    }
    if(filter.includes('unmarked')){
        let p = get(state).players[get(state).activePlayer];
        if(p.captain == 'Khan'){
            // Collecting traits
            if(collectableTraits(c.traits, p).length == 0) return 0;
        }else{
            p = cardOwner(c);
            if(p.captain == 'Zek'){ 
                // ROA
                if(!matches(c, 'rule of acquisition')) return 0;
                if(c.marked) return 0;
            }
        }
        filter = filter.replace(/\s+unmarked\s+/, ' ').trim();
    }
    let sec = false;
    let oppus = false;
    let info = get(state).cardLog[c.uniqueID];
    if(filter.startsWith('secured ')){
        if(!canControlLocation(get(state).players[get(state).activePlayer], c)) return 0;
        //if(info.deck != 'neutral_zone') return 0;
        filter = filter.slice('secured'.length).trim();
    }
    if(filter.startsWith('oppunsecured ')){
        let opp = otherPlayer(get(state).players[get(state).activePlayer]);
        if(info.deck != 'neutral_zone') return 0;
        if(canControlLocation(opp, c)) return 0;
        filter = filter.slice('oppunsecured'.length).trim();
        
    }
    if(filter == 'neutral location'){
        if(!c.suits.includes('location')) return 0;
        if(info.deck == 'neutral_zone') return 1;/*{
            if(oppus){
                let opp = get(state).players.find(pl => pl.captain != get(state).players[get(state).activePlayer]);
                if(!canControlLocation(opp, c)){
                    return 1;
                }else{
                    return 0;
                }
            }
            if(!sec || canControlLocation(get(state).players[get(state).activePlayer], c)) return 1;
        }*/
        return 0;
    }
    if(filter == 'beamed'){
        let info = get(state).cardLog[c.uniqueID];
        if(info.area == 'beamed') return 1;
        return 0;
    }
    if(filter == 'exhausted'){
        if(c.activated) return 1;
        return 0;
    }

    if(filter.startsWith('neutral ')){
        let info = get(state).cardLog[c.uniqueID];
        if(info.deck != 'neutral_zone') return 0;
        filter = filter.slice('neutral '.length).trim();
    }
    if(filter.startsWith('opponent ')){
        // check it belongs to opponent
        let info = get(state).cardLog[c.uniqueID];
        // UMMM... this used to say != get(state).activePlayer which would mean it's always been wrong...!!
        if(info.area != 'players' || parseInt(info.player) == get(state).activePlayer) return 0;
        filter = filter.slice('opponent '.length).trim();
    }
    if(filter.startsWith('your ')){
        // check it belongs to opponent
        let info = get(state).cardLog[c.uniqueID];
        if(info.area != 'players' || parseInt(info.player) != get(state).activePlayer) return 0;
        filter = filter.slice('your '.length).trim();
    }

    if(filter == 'neutral'){
        if(getNeutralZone().some(n => n.uniqueID == c.uniqueID)) return 1;
        return 0;
    }

    if(filter == 'controlled'){
        if(ongoingEffects(c).includes('mimic_location') && isInPlay(c)) return 1;
        if(!c.suits.includes('location')) return 0;
        let info = get(state).cardLog[c.uniqueID];
        if(info.area == 'players' && info.deck == 'locations') return 1;
        if(ongoingEffects(c).includes('mimic_controlled')) return 1; 
        return 0;
    }

    if(filter == 'duty'){
        let info = get(state).cardLog[c.uniqueID];
        if(info.deck == 'duty') return 1;
        if(info.deck == 'play' && matches(c, 'person') && hasStagingDuty(p)) return 1; // 'staging_duty'
        return 0;
    }
    if(filter == 'token'){
        return countAllTokens(c);
    }
    if(filter == 'resource'){
        let count = 0;
        for(let r of allTokenTypes()){
            if(c[r]) count += c[r];
        }
        return count;
    }
    if(filter == 'away'){
        if(!c.suits.includes('location') && !ongoingEffects(c).includes('mimic_location')) return 0;
        return allAway(c);
    }
    if(filter == 'multiple_species'){
        let cardSpecies = Array.from(new Set(c.traits.filter(t => get(res).species.includes(t))));
        if(cardSpecies.length > 1) return 1;
        return 0;
    }
    if(filter == 'skilled_card'){
        if(c.values && c.values.length > 0) return 1;
        return 0;
    }

    if(filter == 'most_token_card'){
        let options = getMarketCards();
        let count = countAllTokens(c);
        if(count == Math.max(...options.map(o => countAllTokens(o)))) return 1;
        return 0;
    }

    if(filter == 'visiting_q'){
        if(!c.visiting) return 0;
        return c.visiting.length;
    }
    
    if(filter == 'controlled location'){
        if(ongoingEffects(c).includes('mimic_location') && isInPlay(c)) return 1;
        if(!c.suits.includes('location')) return 0;
        let info = get(state).cardLog[c.uniqueID];
        if(info.area == 'players' && info.deck == 'locations') return 1;
        return 0;
    }
    if(filter.endsWith('-guard')){
        let end = '-guard';
        let type = filter.slice(0,-(end.length));
        let track = get(res).trackTypes.find(t => t.startsWith(type));
        if(type){
            let num = 0;
            if(c.stripe == track) num++;
            for(let v of c.values){
                if(v == track || v == 'wild' && countWildSkills) num++;
            }
            return num;
        }
        return 0;
    }
    if(filter.endsWith('-skill')){
        let end = '-skill';
        let type = filter.slice(0,-(end.length));
        let track = [...get(res).trackTypes, 'treachery'].find(t => t.startsWith(type));
        if(type == 'wild') track == 'wild';
        if(type){
            let num = 0;
            for(let v of c.values){
                if(v == track || (v == 'wild' && countWildSkills && track != 'treachery')){
                    num++;
                }else if(p && countWildSkills && ongoingPlayer(p).includes('skill_conversion')){
                    let skills = expandSkills(p, v);
                    if(skills.includes(track)) num++;
                }
            }
            return num;
        }
        return 0;
    }
    if(filter.endsWith('-focus')){
        let end = '-focus';
        let type = filter.slice(0, -(end.length));
        let track = get(res).trackTypes.find(t => t.startsWith(type));
        if(type == 'wild' && c.stripe == 'wild'){
            return 1;
        }else if(track){
            if(c.stripe == track || c.stripe == 'wild' && countWildSkills) return 1;
        }
        
        return 0;
    }
    if(filter.startsWith('spec-')){
        let start = 'spec-';
        let type = filter.slice(start.length);
        let subtype = false;
        if(type.endsWith('skill icon')){
            subtype = 'skill';
            type = type.split(' ')[0];
        }else if(type.endsWith('focus icon')){
            subtype = 'focus';
            type = type.split(' ')[0];
        }
        let track = get(res).trackTypes.find(t => t.startsWith(type));
        if(type){
            let num = 0;
            if(c.stripe == track && (!subtype || subtype == 'focus')) num++;
            if(!subtype || subtype == 'skill'){
                for(let v of c.values){
                    if(v == track || v == 'wild' && countWildSkills){
                        num++;
                    }else if(p && countWildSkills && ongoingPlayer(p).includes('skill_conversion')){
                        let skills = expandSkills(p, v);
                        if(skills.includes(track)) num++;
                    }
                }
            }
            return num;
        }
        return 0;
    }
    if(filter.endsWith('-card')){
        let end = '-card';
        let type = filter.slice(0,-(end.length));
        let track = get(res).trackTypes.find(t => t.startsWith(type));
        if(type){
            let num = 0;
            if(c.stripe == track) num++;
            for(let v of c.values){
                if(v == track) num++;
            }
            return num;
        }
        return 0;
    }
    //if(filter == 'location' && ongoingEffects(card).includes('mimic_controlled_location') && isInPlay(c)) return 1;
    if(filter == 'any species' || filter.startsWith('any species')){
        let except = '';
        if(filter.startsWith('any species') && filter.includes('!')){
            except = filter.split('!')[1];
        }
        if(!except && currentPlayer() && currentPlayer().bot && currentPlayer().captain == 'Borg Queen' && get(state).activePlayer == get(state).currentPlayer){
            // BQ is looking for any species, so exclude borg
            except = 'borg';
            if(c.traits.includes('borg')) return 0; // borg cards are ignored
        }
        return c.traits.filter(t => t != except && get(res).species.includes(t) || t == 'any species').length;
    }
    if(get(res).suits.includes(filter)){
        // ongoingEffects() -> validEffect() can ask what suit this card is (e.g.
        // 'staging_duty' needs to know if it's a [[person]]), so the mimic lookup
        // can re-enter here for the same card. Fall back to the printed suits on
        // the way round – a 'mimic_' grant is a Special, which validEffect lets
        // through regardless, so it is still found by the outer call.
        let mimicKey = `${c.uniqueID}|${filter}`;
        if(!checkingMimic.has(mimicKey)){
            checkingMimic.add(mimicKey);
            try {
                if(ongoingEffects(c).includes('mimic_'+filter)) return 1;
            } finally {
                checkingMimic.delete(mimicKey);
            }
        }
        return c.suits.filter(s => s == filter).length;
    }
    if(get(res).traits.includes(filter)){
        let num = currentTraits(c).filter(t => t == filter).length;
        if(countWildcards){
            let numWildcards = cardWCs(c, filter);
            //if(numWildcards) console.log('some wildcards', filter, c.name, cardWCs(c, filter));
            if(typeof countWildcards == 'object'){
                if(countWildcards.hasOwnProperty('wildcardsLeft') && countWildcards.wildcardsLeft < numWildcards){
                    numWildcards = countWildcards.wildcardsLeft;
                }
                num += numWildcards;
                countWildcards.wildcardsUsed += numWildcards;
                if(countWildcards.wildcardsLeft){
                    countWildcards.wildcardsLeft -= numWildcards;
                }
            }else{
                // NB handle later?
                /*if(shouldCheckWCs()){
                    for(let n of Array(numWildcards)) cacheWC(c, filter); // !!! blunt instrument because no choice!
                }*/
                num += numWildcards;
            }
        }
        return num;
    }
    
    let testName = c.name.toLowerCase().trim().replace(/\./g, ''); //To avoid ship name HMS/H.M.S. problems
    let shipPrefixes = ['USS', 'IKS', 'HMS']
    filter = filter.toLowerCase().trim().replace(/\./g, '');

    if(testName == filter){
        return 1;
    }else if(filter != 'q'){ // Q has to max exactly
        if(testName.startsWith(filter+' ') || testName.endsWith(' '+filter) || testName.startsWith(filter+'-')) return 1; // in other words, if you've given Pasteur for USS Pasteur or similar
    }

    //console.log('filter', filter, testName)
    if(shipPrefixes.some(p => testName.startsWith(p.toLowerCase()) && testName == `${p} ${filter}`.trim())){
        return 1;
    }
    if(filter == 'badlands' && testName == 'the badlands') return 1;
    return 0;
}

export function getTypeInfo(filter){
    if(filter.endsWith('-skill')){
        let end = '-skill';
        let type = filter.slice(0,-(end.length));
        type = get(res).trackTypes.find(t => t.startsWith(type)) || type;
        return {key: 'values', type};
    }
    if(filter.endsWith('-focus')){
        let end = '-focus';
        let type = filter.slice(0,-(end.length));
        type = get(res).trackTypes.find(t => t.startsWith(type)) || type;
        return {key: 'stripe', type, scalar: true};
    }
    if(get(res).suits.includes(filter.toLowerCase())){
        return {key: 'suits', type: filter.toLowerCase()};
    }
    if(get(res).traits.includes(filter.toLowerCase())){
        return {key: 'traits', type: filter.toLowerCase()};
    }
    return {key: 'traits', type: filter.toLowerCase()};
}

export async function scanFor(p, toScan, trait){
    let chooseType = true;
    let chosenTrait = trait;
    //console.log(trait);
    if(trait.card && trait.card.card){
        // It's looking for specific card(s)!
        // And just look in the whole market
        let eligible = [...get(state).commons.people, ...get(state).commons.cargo, ...get(state).commons.ships, ...get(state).commons.allies].filter(c => c);
        let card = trait.card.card;

        // If you choose first...
        /*
        if(Array.isArray(card)){
            // Choose which
            card = await chooseCards('Select card to scan for:', card.map(c => c.split(' ').map(s =>`*${upperInitial(s)}*`).join(' ')));
            card = card.toLowerCase().trim();
            let foundCards = eligible.filter(e => e.name.toLowerCase().trim() == card.toLowerCase().trim()));
        }*/


        let foundCards = eligible.filter(e => card.some(c => e.name.toLowerCase().trim() == c.toLowerCase().trim()));
        if(foundCards.length == 0){
            logText(`None of ${card.map(c => c.split(' ').map(s => `*${upperInitial(s)}*`).join(' ')).join('/')} found in Market, so gaining [[glory]] instead`);
            await doAction(p, 'gain_tokens', { token: 'glory', amount: 2});
            return false;
        }
        let c = foundCards[0];
        if(foundCards.length > 1){
            // You choose
            c = await chooseCards(`Multiple cards found: choose which to gain`, foundCards, {cancellable: true, lookSpecific: true});
            if(!c || c == 'cancelled') throw 'cancelled';
        }
        await doAction(p, 'gain_card', { card: c.uniqueID/*, noReactions: true*/});//moveTo(c, 'players.hand.'+getPlayerIndex(p));
        cardMessage(c, `Card ${c.name} found!`);
        return;
    }
    if(Array.isArray(trait)){
        if(trait.length == 0){
            logText(`No trait left to scan for!`);
            throw 'uncompleted';
        }
        if(trait.length == 1){
            trait = trait[0];
        }else if(chooseType){
            chosenTrait = await choose(`Which trait do you want to scan for?`, trait.sort((a,b) => a.localeCompare(b)).map(t => `[[${t}]]`));
            if(!chosenTrait || chosenTrait == 'cancelled') throw 'cancelled';
            trait = trait.find(t => chosenTrait == `[[${t}]]`);
        }
    }
    // cache the trait scanned for so as to filter out next time if scan_different is set
    state.update(s => {
        if(!s.cache) s.cache = {};
        if(!s.cache.scanForTypes) s.cache.scanForTypes = [];
        s.cache.scanForTypes = [...s.cache.scanForTypes, trait];
        return s;
    })
    let marketMatches = toScan.filter(c => matches(c, trait));
    let junkMatches = marketMatches.filter(c => get(state).cardLog[c.uniqueID].deck == 'junk');
    if(junkMatches.length > 0){
        let card = await chooseCards(`You may take a match from the Junk if you wish, or click 'No card'' to go on to scan the Market`, junkMatches, {optional: true});
        if(card && card != 'cancelled'){
            marketMatches = [card];
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(!s.cache.fromJunk) s.cache.fromJunk = {};
                if(!s.cache.fromJunk.scan) s.cache.fromJunk.scan = [];
                s.cache.fromJunk.scan.push(card.uniqueID);
                if(!s.cache.fromJunk.gain) s.cache.fromJunk.gain = [];
                s.cache.fromJunk.gain.push(card.uniqueID);
                return s;
            })
        }else{
            marketMatches = marketMatches.filter(c => !junkMatches.some(cd => cd.uniqueID == c.uniqueID));
        }
    }
    let marketMatchesWithoutWC = toScan.filter(c => matches(c, trait, false, false));
    // Below disabled until confirmed
    /*if(marketMatches.length > 0 && marketMatchesWithoutWC.length == 0){
        // You can choose!
        let pick = await chooseCards(`Eligible wild match(es) in the Market: select to gain, or click 'No Card' to look in decks instead`, marketMatches, {optional: true});
        if(pick == 'cancelled') throw 'cancelled';
        if(pick){
            marketMatches = [pick];
        }else{
            marketMatches = []; // Throw on
        }
    }*/
    if(marketMatches.length == 1){
        // Automatically take this one!
        let c = marketMatches[0];
        await doAction(p, 'gain_card', { card: c.uniqueID/*, noReactions: true*/});//moveTo(c, 'players.hand.'+getPlayerIndex(p));
        cardMessage(c, `Card ${c.name} gained!`);
        //info(`Card ${c.name} found!`)
        return c.uniqueID;
    }else if(marketMatches.length > 0){
        // Choose one of them
        let c = await chooseCards(`Multiple eligible cards in Market: choose one to gain`, marketMatches);
        await doAction(p, 'gain_card', { card: c.uniqueID/*, noReactions: true*/});//moveTo(c, 'players.hand.'+getPlayerIndex(p));
        cardMessage(c, `Card ${c.name} gained!`);
        //info(`Card ${c.name} found!`)
        return c.uniqueID;
    }
    toScan = toScan.filter(c => get(state).cardLog[c.uniqueID].deck != 'junk'); // 
    while(toScan.length > 0){
        let deck = toScan[0];
        if(toScan.length > 1) {
            deck = await chooseCards(`Select deck to scan:`, toScan); //TODO cancellable?
            if(!deck || deck == 'cancelled') throw 'cancelled';
        }
        let info = get(state).cardLog[deck.uniqueID];
        let scanDeck = getDeck(get(state), info.area, info.deck, info.player);
        //if(ongoingPlayer(p).includes('scan_junk')) deck = [...deck, ...get(state).commons.junk];
        for(let c of scanDeck){
            if(c && matches(c, trait)){  // (choose && cardMatches())  //c.traits.includes(trait)){
                await doAction(p, 'gain_card', { card: c.uniqueID/*, noReactions: true*/});//moveTo(c, 'players.hand.'+getPlayerIndex(p));
                cardMessage(c, `Card ${c.name} found!`);
                //info(`Card ${c.name} found!`)
                return c.uniqueID;
            }
        }
        logText(`[[${trait}]] not found in ${upperInitial(info.deck)} deck`);
        toScan = toScan.filter(s => s != deck);
    }
    await doAction(p, 'gain_tokens', { token: 'glory', amount: 2});
    //info(`[[${trait}]] not found: gaining 2 [[glory]] instead`); // !TODO this may not work... might need to go back to await
    return false;
}

export function closeLook(f){
    ui.update(ui =>{
        let i = ui.looking.findIndex(l => l.area == f.area && l.deck == f.deck && l.player == f.player);
        console.log('closing a', i, ui.looking, f);
        if(i != -1){
            let l = ui.looking[i];
            ui.looking = [...ui.looking.slice(0, i), ...ui.looking.slice(i+1)];
            console.log('closing', l);
            if(l.component){
                try{
                    l.component.$destroy();
                }catch(e){
                    console.log("Error destroying look component:", e)
                }
            }
        }
        return ui;
    })
}

export function closeAllLooks(exactOnly = false){
    ui.update(ui => {
        for(let l of ui.looking.filter(l => !exactOnly || l.exactDeck)){
            if(l.component){
                try{
                    l.component.$destroy();
                }catch(e){
                    console.log("Error destroying look component:", e)
                }
            }
        }
        ui.looking = ui.looking.filter(l => exactOnly && !l.exactDeck)
        return ui;
    })
    if(!exactOnly){
        // Also destroy all DOM elements
        let elements = document.querySelectorAll('.look');
        for(let e of elements){
            e.remove();
        }
    }
}

export function hasNeutralJunkAccess(p){
    return getNeutralZone().some(c => myAway(p, c, 'remove_away') &&
        (isBadlands(c) || ongoingEffects(c, 'from_junk', true).length > 0));
}

export async function checkFromJunk(p, type, scan = false){
    let junk = false;
    let param = [];
    if(p.from_junk) param = p.from_junk.filter(j => !type || !j.filter || j.filter.includes(type));
    if(ongoingPlayer(p).includes('from_junk')){
        param = [...param, ...ongoingPlayer(p, 'from_junk').filter(j => !type || !j.filter || j.filter.includes(type))];
    }
    if(scan) param = param.filter(p => !p.justGain);
    if(param.length > 0){
        if(param.some(s => !s.cost)){
            junk = true;
        }else{
            let s = param[0];
            // replace below with ongoingPlayerWithCards soon
            let triggeringCard = allScoreableCards(p).find(c => ongoingEffects(c, 'from_junk').includes(s));
            let cost = await getCostInfo(p, s.cost, 'reward', triggeringCard);
            if(cost){
                let should = await choose(`Do you want to pay ${renderCost(cost)} to gain from junk instead?`, ['Yes', 'No'], {cancellable: true});
                if(!should || should == 'cancelled') throw 'cancelled';
                if(should == 'Yes'){
                    if(!await pay(p, {...s.cost, optional: false}, 'reward', triggeringCard)) return false;
                    junk = true;
                    // consequence here
                    if(s.consequence){
                        //let triggeringCard = allScoreableCards(p).find(c => ongoingEffects(c, 'from_junk').includes(s));
                        if(triggeringCard) await resolveEffects(triggeringCard, s.consequence, false);
                    }
                }
            }
        }
    }
    if(!p.bot && !junk){
        for(let c of getNeutralZone()){
            if(!myAway(p, c, 'remove_away')) continue;
            let rules = ongoingEffects(c, 'from_junk', true);
            // Keep the established Badlands trade available for older/unparsed card text.
            if(!rules.length && isBadlands(c)) rules = [{cost: {type: 'action', verb: 'remove_away', obj: {num: 1, types: 'away', owner: 'you'}, from: {num: 1, card: 'this card'}}}];
            for(let rule of rules){
                if(scan && rule.justGain || type && rule.filter && !rule.filter.includes(type)) continue;
                let choice = await choose(`Remove an [[away team]] from ${cc(c.uniqueID)} to include the Junk?`, ['Yes', 'No'], {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                if(choice != 'Yes') continue;
                if(rule.cost?.verb == 'remove_away'){
                    try{
                        let result = await doAction(p, 'remove_away', {card: c.uniqueID, from: c.uniqueID, obj: {...rule.cost.obj}});
                        if(result == 'cancelled' || result == 'failed') return false;
                    }catch(e){
                        if(e == 'uncompleted') return false;
                        throw e;
                    }
                }else if(rule.cost && !await pay(p, {...rule.cost, optional: false}, 'Junk access', c)) return false;
                // Permission is local to the pending gain/scan. Nested consequences cannot consume it.
                if(rule.consequence) await resolveEffects(c, rule.consequence, false);
                return true;
            }
        }
    }
    return junk;
}

export async function scanOf(p, deck, num, type, junk = false){
    if(!deck) deck = []; // for junk only
    //let array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] 
    let looking = [];

    if(ongoingPlayer(p).includes('scan_extra')){
        let extra = ongoingPlayer(p, 'scan_extra')[0];
        if(extra) num += extra;
    }
    
    let topID = false;
    if(deck.length > 0){
        looking = [deck[0], ...deck.slice(1, num + 1)];
        topID =  deck[0].uniqueID;
    }
    //deck = getOrigDeck(deck);
    //console.log(ongoingPlayer(p))
    if(ongoingPlayer(p).includes('scan_junk')) junk = true;
    if(!junk && (badlands() || p.from_junk || ongoingPlayer(p).includes('from_junk'))){
        junk = await checkFromJunk(p, type, 'scan');
    }
    if(!junk && (!deck || deck.length == 0)) return false;
    let addFromJunk = [];
    if(junk) addFromJunk = get(state).commons.junk.filter(c => matches(c, type));
    looking = [...looking, ...addFromJunk];
    let card = await chooseCards(`Choose a card to take (from deck${junk ? ', junk' : '' } or from market)`, looking, {lookSpecific: true});
    if(card){
        //let index = deck.indexOf(card);
        await doAction(p, 'gain_card', { card: card.uniqueID/*, noReactions: true*/});
        let count = 0;
        for(let c of looking.filter(cd => cd.uniqueID != topID && cd.uniqueID != card.uniqueID && !addFromJunk.some(c => c.uniqueID == cd.uniqueID))){
            //let type = c.suits[0];
            await moveTo(c, `commons.${get(res).marketTypes[type]}`, -1);
            count++;
        }
        if(count > 1 && await choose('You may reorder the remaining cards on the bottom of the deck. Do you want to?', ['Yes', 'No']) == 'Yes'){
            await chooseCards('Reorder cards (rightmost is bottom of deck)', get(state).commons[get(res).marketTypes[type]].slice(-count), {look: true, reorder: true, noCard: 'OK', optional: true})
        }
        /*let top = null;
        if(index == 1){
            top = deck[0];
            deck.shift();
        }
        console.log(deck.map(c => c.name).join(','));
        if(deck.length > 0) shuffle(deck);
        console.log(deck.map(c => c.name).join(','));
        if(top) deck.unshift(top);
        console.log(deck);*/

        return card.uniqueID;
    }
    
}

export async function beamToCard(p, card, filter, multiple){
    let cards = [...get(state).players[getPlayerIndex(p)].decks.hand.filter(c => matches(c, filter))];
    let options = {
        cancellable: true
    };
    if(multiple) options.num = 'any';
    let c = await chooseCards('Choose a card to beam to this card', cards, options);
    if(c && c != 'cancelled'){
        await moveTo(c, `beamed.${card.uniqueID}`);
        return c.uniqueID;
    }
}

export function myBeamed(p, card){
    if(!card || !card.beamed) return 0;
    return card.beamed.filter(c => c.sourcePlayer == getPlayerIndex(p)).length;
}

export function theirBeamed(p, card){
    if(!card || !card.beamed) return 0;
    return card.beamed.filter(c => c.sourcePlayer != getPlayerIndex(p)).length;
}

export function allAway(c, action = ''){
    let amount = 0;
    for(let p of get(state).players){
        amount += myAway(p, c, action);
    }
    return amount;
}

// NB `action` is vestigial: it used to gate whether drones counted. Drones are away teams
// now, unconditionally, so nothing reads it. Left in place because ~25 call sites pass it.
export function myAway(p, c, action = ''){
    let away_teams = 0;
    if(!c || !c.away_teams || !c.away_teams[p.captain]){
        away_teams = 0;
    }else{
        away_teams = c.away_teams[p.captain];
    }
    if(p && c) away_teams += drones(p, c); // drones ARE away teams
    
    if(c.murf && hasMurf(p)) away_teams++;
    if(matches(c, 'neutral location') && c.beamed && p && p.captain == 'TosKirk'){
        // Add on all beamed as AT for him
        away_teams += c.beamed.length;
    }
    return away_teams;
}

/*export function ownsMurf(p){
    let murf = hasMurf(p);
    if(!murf) return false;
    let info = get(state).cardLog[murf.uniqueID];
    if(info.area == 'players' && info.player == getPlayerIndex(p)) return true;
    return false;
}*/

export function drones(p, c){
    if(!c) return 0;
    let count = c.drones?.[p.captain] || 0;
    let ships = [];
    if(c.orbiting && Array.isArray(c.orbiting)) ships = c.orbiting.filter(o => o.sourcePlayer == getPlayerIndex(p));
    for(let s of ships){
        if(ongoingEffects(s).includes('drone_cube')){
            if(s.drones && s.drones[p.captain]) count += s.drones[p.captain];
        }
    }
    return count;
}

export function allDrones(c){
    return get(state).players.reduce((a, p) => a + drones(p, c), 0);
}

export function theirAway(p, c, action = ''){
   /* let away_teams = 0;
    if(!c || !c.away_teams) return 0;
    return get(state).players.filter(pl => pl != p).reduce((a, p) => a + myAway(p, c), 0);*/
    return myAway(otherPlayer(p), c, action);
}

// loc: where the ships are, so passives limited to some locations ("at opponent [[location]]s") can be checked
export function countShips(ships, securing = false, loc = false){
    let count = 0;
    for(let s of ships){
        let c = getCard(s.card);
        let p = cardOwner(c);
        if(securing && p.bot && p.captain == 'Borg Queen' && matches(c, 'cube') && p.decks.fleet.filter(cd => matches(cd, 'sync')).length >= 3){
            count += 2;
        }else if(securing && ongoingEffects(c, 'ongoing').includes('multi_token_secure')){
            let mtsArr = ongoingEffects(c, 'multi_token_secure'); // Could generalise the bot application if desired
            for(let mts of mtsArr){
                if(typeof mts == 'number'){
                    count += mts;
                }else{
                    let num = mts.num;
                    if(mts.per && mts.per.format == 'type_count'){
                        let mult = resolveCountTypes(cardOwner(c), c, mts.per.obj, 'nocache', {...mts.per}, []);
                        num = num * mult;
                    }
                    // NB can add more in future if need be
                    count += num;
                }
            }
        }else if(securing && ongoingPlayer(p).includes('type_specific_multi_token_secure')){
            let tsMts = ongoingPlayer(p, 'type_specific_multi_token_secure');
            let boosted = false;
            for(let t of tsMts){
                if(t.yourTurnOnly && get(state).currentPlayer != getPlayerIndex(p)) continue;
                if(t.visited && !shipAtVisitedLocation(p, loc, t.visited)) continue;
                let num = t.num;
                let type = t.type;
                if(matches(c, type)){
                    count += num;
                    boosted = true;
                    break;
                }
            }
            if(!boosted) count++; // just boost as one if not boosted as more
        }else{
            count++;
        }
    }
    return count;
}

function shipAtVisitedLocation(p, loc, visited){
    if(!loc) return false;
    if(visited == 'opponent'){
        let info = getLocation(loc);
        return !!info && info.area == 'players' && info.deck == 'locations' && info.player != getPlayerIndex(p);
    }
    return !!matches(loc, visited + ' location');
}

export function myOrbiting(p, card, securing = false){
    if(!card || !card.orbiting) return 0;
    let mine = card.orbiting.filter(o => o.sourcePlayer == getPlayerIndex(p));
    return countShips(mine, securing, card);
}


export function theirOrbiting(p, card, securing = false){
    if(!card || !card.orbiting) return 0;
    let theirs = card.orbiting.filter(o => o.sourcePlayer != getPlayerIndex(p));
    return countShips(theirs, securing, card);
}

export function cardMessage(c, message){
    ui.update(ui => {
        ui.cardMessage[c.uniqueID] = message;
        return ui;
    })
}

function resetTypeGain(c){
    if(c.converted){
        for(let v of c.converted){
            let card = getCard(v.converter);
            let p = cardOwner(card);
            resetTraitConvert(p, card, v.conversion); // Back to normal
        }
    }
    
    if(c.savedTypeGains){
        for(let k of Object.keys(c.savedTypeGains)){
            c[k] = c.savedTypeGains[k];
            if(c[`saved${upperInitial(k)}`]) delete c[`saved${upperInitial(k)}`]; // wipe memory of whatever was there
        }
        delete c.savedTypeGains;
    }
    if(c.converted){
        for(let v of c.converted){
            let card = getCard(v.converter);
            let p = cardOwner(card);
            handleTraitConvert(p, card, v.conversion); // Back to normal
        }
    }
    delete c.converted;
}

// The card's traits/values/suits before any type gain or trait conversion touched them.
// Every snapshot must come from here: if a conversion snapshotted traits a type gain had
// already added to (or vice versa), restoring that snapshot would keep the gain for good and
// it would stack again on every update (e.g. Vadic's wildcard piling up).
function originalTypes(c, key){
    if(c.savedTypeGains && c.savedTypeGains.hasOwnProperty(key)) return [...c.savedTypeGains[key]];
    if(c[`saved${upperInitial(key)}`]) return [...c[`saved${upperInitial(key)}`]];
    return [...c[key]];
}

async function updateTypeGains(p, c, gains){
    resetTypeGain(c);
    let first = true;
    let saved = {};
    let changedSomething = false;

    for(let g of gains){
        if(g.where == 'play'){
            let info = get(state).cardLog[c.uniqueID];
            if(!info || info.deck != 'play') continue; // Only if in play TODO need to reset?
        }
        if(g.condition){
            if(Array.isArray(g.condition)){
                let should = true;
                for(let cond of g.condition){
                    if(!await resolveCondition(p, c, cond, false)){
                        should = false;
                        break;
                    }
                }
                if(!should) continue;
            }else{
                let should = await resolveCondition(p, c, g.condition, false);
                if(!should) continue;
            }
            
        }
        let num = g.num;
        if(g.same_as){
            let card = await resolveObject(g.same_as, 'type_gains', {}, p);
            if(card.length > 0){
                card = getCard(card[0]);
                if(card){
                    if(g.same_type == 'traits'){
                        if(!saved.hasOwnProperty('traits')) saved.traits = originalTypes(c, 'traits');
                        c.traits = [...currentTraits(card)];
                    }else if(g.same_type == 'skills'){
                        if(!saved.hasOwnProperty('values')) saved.values = originalTypes(c, 'values');
                        c.values = [...card.values];
                    }
                }
            }
        }
        if(g.trait){
            if(g.trigger){
                // !TODO for now it's just types in play, but it could expand in future. In which case, rewrite the below to link to PerElement
                let per = g.trigger.per || 1;
                let eligible = allScoreableCards(p);
                if(g.trigger.locs && g.trigger.locs.length > 0){
                    eligible = [];
                    for(let l of g.trigger.locs){
                        eligible.push(...resolveLocCondition(c, l, p, []));
                    }
                }
                if(g.trigger.no_beamed){
                    eligible = eligible.filter(c => get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].area != 'beamed');
                }
                if(g.trigger.filter) eligible = eligible.filter(c => matches(c, g.trigger.filter));
                if(g.trigger.excludeThis) eligible = eligible.filter(e => e.uniqueID != c.uniqueID);
                let count = eligible.reduce((a, c) => a + matches(c, g.trigger.type, first), 0)
                
                num = Math.floor(num * count / per);
                if(g.trigger.max && num > g.trigger.max) num = g.trigger.max;
                if(g.trigger.min && num < g.trigger.min) num = g.trigger.min;
            }
            first = false;
            let info = getTypeInfo(g.trait);
            if(!saved.hasOwnProperty(info.key)) saved[info.key] = info.scalar ? clone(c[info.key]) : originalTypes(c, info.key);
            if(info.key == 'values') c[info.key] = c[info.key].filter(v => v != 'variable'); // To remove the variable signs as they are misleading
            for(let i = num; i > 0; i--){
                if(info.scalar){
                    c[info.key] = info.type;
                }else{
                    c[info.key].push(info.type);
                }
            }
        } 
    }
    if(!c.savedTypeGains) c.savedTypeGains = saved;
}


function clearTypeModifications(c){
    if(c.savedTypeGains){
        for(let k of Object.keys(c.savedTypeGains)){
            c[k] = c.savedTypeGains[k];
            //if(c[`saved${upperInitial(k)}`]) delete c[`saved${upperInitial(k)}`]; // wipe memory of whatever was there
        }
        delete c.savedTypeGains;
    } // shouldn't coexist with other types
    if(c.savedValues){
        c.values = c.savedValues;
        delete c.savedValues;
    }
    if(c.savedTraits){
        c.traits = c.savedTraits;
        delete c.savedTraits;
    }
    if(c.savedSuits){
        c.suits = c.savedSuits;
        delete c.savedSuits;
    }
    if(c.savedConversions) delete c.savedConversions; // 
}


export async function updateAllTypeGains(){
    // First clear them all (makes the other resets unnecessary)
    for(let c of [...get(state).commons.junk, ...get(state).players.flatMap(p => allScoreableCards(p))]){ // In case of anything junked!
            clearTypeModifications(c); // hopefully all the other resets won't be needed then
        }
    for(let p of get(state).players){

        // We have a problem: order matters. How to resolve?
        // One solution is to iterate around until no change
        // Another solution is to flag cards that both have and count for type changes
        // and re-run their dependencies after they are modified
        
        for(let c of [...(p.dashboard.passives || []), ...allScoreableCards(p)]){//cardsInPlay(p)){
            //clearTypeModifications(c); // hopefully all the other resets won't be needed then
            /*if(c.name.includes('splinter group')){
                console.log('Vadic', c); // just for logging
            }*/
            if(ongoingEffects(c, 'ongoing', true).includes('type_gains')){
                // override is on so that conditional ongoings still trigger once condition has 
                // ceased to be relevant, for resetting purposes
                let gains = ongoingEffects(c, 'type_gains');
                if(gains.length > 0){
                    await updateTypeGains(p, c, gains);
                }/*else{
                    // Presume all reset
                    resetTypeGain(c);
                }*/
                
            }
            if(ongoingEffects(c, 'ongoing', true).includes('trait_convert')){
                let convert = ongoingEffects(c, 'trait_convert');
                
                //if(convert.length == 0){
                    // Reset it, because effect no longer relevant
                //    resetTraitConvert(p, c, false);
                //}else{
                    for(let v of convert){
                        await handleTraitConvert(p, c, v);
                    }  
                //}
            }
        }
    }
}

async function handleTypeGains(p, c, gains, type){
    /*if(type == 'entering'){
        await updateTypeGains(p, c, gains);
    }else if(type == 'leaving' && c.savedTypeGains){
        resetTypeGain(c); // Cancel it
    }*/
    if(type == 'leaving' && c.savedTypeGains){
        resetTypeGain(c); // Cancel it
    }else{
        await updateTypeGains(p, c, gains);
    }
}

let valueConversion = {
    'mil-skill': 'military',
    'inf-skill': 'influence',
    'res-skill': 'research',
    'wild-skill': 'wild',
}

async function handleTraitConvert(p, card, convert){
    //resetTraitConvert(p, card, convert);
    if(!card.savedConversions) card.savedConversions = [];
    if(convert.trigger){
        if(convert.trigger == 'play'){
            let info = get(state).cardLog[card.uniqueID];
            if(!info || info.deck != 'play') return; // Only if in play area
        }else if(convert.trigger == 'duty_play'){
            let info = get(state).cardLog[card.uniqueID];
            if(!info) return;
            if(info.deck != 'play' && info.deck != 'duty') return;
        }else if(convert.trigger == 'inPlay'){
            if(!inPlay(card)) return;
        }else if(convert.trigger == 'exhausted'){
            if(!card.activated) return;
        }else if(convert.trigger.type == 'condition'){
            let should = await resolveCondition(p, card, convert.trigger, false);
            if(!should) return;
        }
    }
    let eligible = [];
    if(convert.card){
        if(convert.card == 'this card'){
            eligible = [card];
        }else if(convert.card.place){
            eligible = resolvePlace(p, convert.card.place, 'trait_convert', false);
        }else{
            let toResolve = resolveExactCard(convert.card, 'trait_convert', p)
            if(toResolve){
                eligible = toResolve.map(c => getCard(c));
            }
            // otherwise fall through  
        }
        // Handle converting all
    }else{
        eligible = convert.where == 'all' ? allScoreableCards(p) : cardsInPlay(p);
        if(convert.notThis) eligible = eligible.filter(c => c.uniqueID != card.uniqueID);
    }

    let from = convert.from;

    for(let c of eligible){
        if(convert.filter && !matches(c, convert.filter)) continue;
        if(!from){
            if(convert.wipeTraits){
                if(!c.savedTraits) c.savedTraits = originalTypes(c, 'traits');
                c.traits = [];
            }
            addSuitTraitValue(c, card, convert.to);
        }else if(convert.gain){
            // then from is a match thing rather than anything else
            if(matches(c, from)) addSuitTraitValue(c, card, convert.to);
        }else if(c.suits && c.suits.includes(from)){
            // First save
            if(!c.savedSuits) c.savedSuits = originalTypes(c, 'suits'); // Only if not already saved
            for(let i = 0; i < c.suits.length; i++){
                if(c.suits[i] == from){
                    if(convert.filter && !matches(c, convert.filter)) continue;
                    c.suits[i] = convert.to;
                    card.savedConversions.push({
                        id: c.uniqueID,
                        i,
                        oldSuit: from
                    });
                    if(!c.converted) c.converted = [];
                    
                }
            }
            c.converted.push({
                converter: card.uniqueID,
                conversion: convert
            })
        }else if(c.traits && c.traits.includes(from)){
            // First save
            
            if(c.converted){
                let already = c.converted.filter(v => v.converter == card.uniqueID);
                // reset
                if(already.length > 0){
                    for(let v of already){
                        resetTraitConvert(p, c, v.conversion);
                    }
                    c.converted = c.converted.filter(v => v.converter != card.uniqueID);
                } 
            }
            if(!c.savedTraits) c.savedTraits = originalTypes(c, 'traits'); // Only if not already saved
            for(let i = 0; i < c.traits.length; i++){
                if(c.traits[i] == from){
                    if(convert.filter && !matches(c, convert.filter)) continue;
                    c.traits[i] = convert.to;
                    card.savedConversions.push({
                        id: c.uniqueID,
                        i,
                        oldTrait: from
                    });
                    if(!c.converted) c.converted = [];
                    
                }
                
            }
            c.converted.push({
                converter: card.uniqueID,
                conversion: convert
            })
        }else if(c.values && c.values.includes(valueConversion[from] || from)){
            // First save
            if(!c.savedValues) c.savedValues = originalTypes(c, 'values');
            for(let i = 0; i < c.values.length; i++){
                if(c.values[i] == (valueConversion[from] || from)){
                    if(convert.filter && !matches(c, convert.filter)) continue;
                    c.values[i] = valueConversion[convert.to] || convert.to;
                    card.savedConversions.push({
                        id: c.uniqueID,
                        i,
                        oldValue: valueConversion[from] || from
                    });
                    if(!c.converted) c.converted = [];
                    
                }
            }
            c.converted.push({
                converter: card.uniqueID,
                conversion: convert
            })
        }
    }
}

function addSuitTraitValue(c, card, stv){
    let type = 'values';
    if(valueConversion[stv]) stv = valueConversion[stv]; // To remove '-skill' endings
    if(get(res).suits.includes(stv)) type = 'suits';
    if(get(res).traits.includes(stv)) type = 'traits';
    if(['traits', 'suits'].includes(type) && c[type].includes(stv)) return; // Don't duplicate if already there
    if(!c[`saved${upperInitial(type)}`]) c[`saved${upperInitial(type)}`] = originalTypes(c, type); // Only if not already saved
    c[type] = [...c[type], stv];
    let toPush = {
        id: c.uniqueID,
        addedType: type,
        addedThing: stv
    };
    toPush[`added${upperInitial(type)}`] = stv;
    //toPush[`resetAll${upperInitial(type)}`] = c[`saved${upperInitial(type)}`];
    card.savedConversions.push(toPush);
}

function resetTraitConvert(p, card, convert, specificID = false){
    //let eligible = convert.where == 'all' ? allScoreableCards(p) : cardsInPlay(p); // !!!TODO why this? 
    if(card.savedConversions){
        for(let v of card.savedConversions){
            if(specificID && v.id != specificID) continue;
            let c = getCard(v.id); //eligible.find(c => c.uniqueID == v.id)
            if(v.oldTrait && c && c.traits && c.traits.length >= v.i + 1){
                // i.e. not left play
                c.traits[v.i] = v.oldTrait;
                if(c.savedTraits && c.traits.join(',') == c.savedTraits.join(',')) delete c.savedTraits;
            }else if(v.oldValue && c && c.values && c.values.length >= v.i + 1){
                // i.e. not left play
                c.values[v.i] = v.oldValue;
                if(c.savedValues && c.values.join(',') == c.savedValues.join(',')) delete c.savedValues;
            }else if(v.oldSuit && c && c.suits && c.suits.length >= v.i + 1){
                // i.e. not left play
                c.suits[v.i] = v.oldSuit;
            }else if(v.addedType){
                //let i = -1;
                let i = c[v.addedType].length - 1;
                for(; i >= 0; i--){
                    if(c[v.addedType][i] == v.addedThing) break;
                }
                if(i != -1) c[v.addedType] = [...c[v.addedType].slice(0, i), ...c[v.addedType].slice(i+1)];
            }else if(v.resetAllTraits && c.savedTraits){
                c.traits = c.savedTraits;
                delete c.savedTraits;
            }else if(v.resetAllValues){
                c.values = c.savedValues;
                delete c.savedValues;
            }else if(v.resetAllSuits){
                c.suits = c.savedSuits;
                delete c.savedSuits;
            }
        }
        delete card.savedConversions;
    }
}

export async function handleOngoingChange(p, c, effect, type){
    if(!p) return;
    /*if(effect == 'mimic_controlled_location'){
        if(type == 'entering'){
            c.suits = [...c.suits, 'location'];
        }else if(type == 'leaving'){
            c.suits = c.suits.filter(t => t != 'location');
        }
    }
    if(effect == 'mimic_deployed_ship'){
        if(type == 'entering'){
            c.suits = [...c.suits, 'ship'];
        }else if(type == 'leaving'){
            c.suits = c.suits.filter(t => t != 'ship');
        }
    }*/

    // Jan 2026: disabling the below because it's handled
    // via updateAllTypeGains instead
    /*if(effect == 'type_gains'){
        let gains = ongoingEffects(c, 'type_gains', type == 'leaving');
        await handleTypeGains(p, c, gains, type);
    }else*/ if(effect.startsWith('extra_duty_')){
        await rationaliseDuty(p);
    }
    
    // Jan 2026: more of below removed for updateAllTypeGains
    /*else if(effect == 'trait_convert'){
        let allConvert = ongoingEffects(c, 'trait_convert', true);
        for(let v of allConvert){
            resetTraitConvert(p, c, v);
        }
        let nowConvert = ongoingEffects(c, 'trait_convert'); // After reset so its own effects can't contribute
        for(let v of nowConvert){
            await handleTraitConvert(p, c, v);
        }
    }*/
    if(effect == 'copy_passive'){
        // Handle hand size increases etc. Or no longer needed?
    }
    if(type == 'entering'){
        p.ongoing.push(c);
        p.ongoing.sort((a, b) => ongoingSortValue(a) - ongoingSortValue(b));
    }else if(type == 'leaving'){
        let i = p.ongoing.findIndex(card=> card.uniqueID == c.uniqueID);
        if(i == -1){
            console.log('error: ongoing effect not found!', c, effect, p.ongoing);
        }else{
            p.ongoing.splice(i, 1);
        }
    }
    // 'continuing' won't fire this, which is what we want
}

function ongoingSortValue(c){
    let o = ongoingEffects(c, 'ongoing', true);
    let possibleTraitEffects = ['trait_convert', 'type_gains'];
    for(let e of possibleTraitEffects){
        o = [...o, ...ongoingEffects(c, e, true)];
    }
    // !!! NB bodge ahead – better to read fully in future, but for now...
    if(JSON.stringify(o).includes('wildcard')) return 0;
    return 1;
}

export async function drawToHandSize(p){
    let toDraw;
    let drawn;
    do{
        toDraw = await handSize(p) - p.decks.hand.length;
        /// 
        if(toDraw <= 0) break;
        if(p.decks.deck.length == 0) await reshuffleDeck(p, {}); // So that you're ready to continue!
        toDraw = await handSize(p) - p.decks.hand.length; // in case of added cards from reshuffle
        if(p.decks.deck.length <= toDraw){
            // Draw all, since that's all that's left
            toDraw -= p.decks.deck.length;
            drawn = await drawCard(p, p.decks.deck.length, {});
        }else{
            // Choose what you need 
            drawn = await drawCard(p, toDraw, {}); // Just pick
        }
    }while(drawn && drawn.length > 0);
}
